/**
 * A function to create a log object for the 'rPremiumPurchaseError' event (evid: 105)
 *
 * Event description: R_PremiumPurchaseError
 *
 * @param {rPremiumPurchaseErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rPremiumPurchaseErrorParams>} LogObject<rPremiumPurchaseErrorParams>
 */
export function rPremiumPurchaseError(params) {
    return { evid: 105, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aClickOnUpdatePayment' event (evid: 11)
 *
 * Event description: A_ClickOnUpdatePayment
 *
 * @param {aClickOnUpdatePaymentParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} existingPaymentMethod - none/boleto/payU/creditCard/sepa
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {string} actionName - Update_payment_method/add_payment_method/renew_with_CC/Boleto/PayU
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} renewWith - boleto/payU/sepa/creditCard
 * @property {string} type - partners/diy
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickOnUpdatePaymentParams>} LogObject<aClickOnUpdatePaymentParams>
 */
export function aClickOnUpdatePayment(params) {
    return { evid: 11, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'new1512' event (evid: 110)
 *
 * Event description: We are migrating dealer client to call a new platformized api.
 * those events will contains comparison results of both api's - new and old.  it will make migration process safer.
 *
 * @param {new1512Params} params - The parameters for this event
 * @property {GUID} bannerIdNew - banner id returning from new dealer
 * @property {GUID} bannerIdOld - banner id returning fro old dealer
 * @property {string} realEstateId - the real estate that the request was made from
 * @property {boolean} assetIdEqual - true if assetId has the same value in both responses
 * @property {boolean} dynamicParamsEqual - true if dynamicParams has the same value in both responses
 * @property {boolean} equal - true if all other comparison fields are true
 * @property {boolean} daysLeftEqual - true if daysLeft has the same value in both responses - only if its back from new dealer
 * @property {boolean} bannerIdEqual - true if bannerId has the same value in both responses
 * @property {boolean} templateEqual - true if template has the same value in both responses
 * @property {boolean} saleTypeEqual - true if saleType has the same value in both responses - only if its back from new dealer
 * @property {boolean} lightboxTriggersEqual - true if lightboxTriggers has the same value in both responses
 * @property {GUID} msid - the metasite id in context of request
 * @return {LogObject<new1512Params>} LogObject<new1512Params>
 */
export function new1512(params) {
    return { evid: 110, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesClick' event (evid: 1106)
 *
 * Event description: click on a CTA in Business Email page
 *
 * @param {gSuiteMyMailboxesClickParams} params - The parameters for this event
 * @property {string} nextStep - Next step type - Single Connected domain/  Multiple Connected domain /No connected domain
 * @property {number} accountTotalDomains - account_total_domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - True/False
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} domain - domain name
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} clickType - 'Google Voice Get Started'
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - [yes / no]
 * @property {string} isConnectedDomain - true, false
 * @property {number} emailProvider - email_provider
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {boolean} isPremium - is_premium
 * @property {string} pageName - current version of the page
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {string} discount - discount
 * @property {GUID} siteGuid - site_id
 * @return {LogObject<gSuiteMyMailboxesClickParams>} LogObject<gSuiteMyMailboxesClickParams>
 */
export function gSuiteMyMailboxesClick(params) {
    return { evid: 1106, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'checkOutPageCreateOrderPage' event (evid: 1124)
 *
 * Event description: server
 *
 * @param {checkOutPageCreateOrderPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - externalSessionId
 * @property {string} initiatorProductType - initiator_product_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} products - json
 * @property {string} invoiceId - id
 * @property {string} newPurchase - false, true
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} initiator - initiator
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkOutPageCreateOrderPageParams>} LogObject<checkOutPageCreateOrderPageParams>
 */
export function checkOutPageCreateOrderPage(params) {
    return { evid: 1124, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickOnResetAdminPassword' event (evid: 1130)
 *
 * Event description: G-suite > click on Reset Admin Password
 *
 * @param {gSuiteClickOnResetAdminPasswordParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickOnResetAdminPasswordParams>} LogObject<gSuiteClickOnResetAdminPasswordParams>
 */
export function gSuiteClickOnResetAdminPassword(params) {
    return { evid: 1130, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteResetAdminPasswordPopUpClick' event (evid: 1131)
 *
 * Event description: G-suite > Reset Admin Password Pop-up > click
 *
 * @param {gSuiteResetAdminPasswordPopUpClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} clickType - cancel, close, reset password
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteResetAdminPasswordPopUpClickParams>} LogObject<gSuiteResetAdminPasswordPopUpClickParams>
 */
export function gSuiteResetAdminPasswordPopUpClick(params) {
    return { evid: 1131, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickRetrieveMailboxesArrow' event (evid: 1132)
 *
 * Event description: G-suite > click retrieve mailboxes arrow
 * the little down facing arrow next to the mailbox
 *
 * @param {gSuiteClickRetrieveMailboxesArrowParams} params - The parameters for this event
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} clickType - expand, collapse
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<gSuiteClickRetrieveMailboxesArrowParams>} LogObject<gSuiteClickRetrieveMailboxesArrowParams>
 */
export function gSuiteClickRetrieveMailboxesArrow(params) {
    return { evid: 1132, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailbox' event (evid: 1133)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Set Up Mailbox.  This button available when mailbox was purchased for this domain but not set up yet.
 *
 * @param {gSuiteClickSetUpMailboxParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} seatName - seat name
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickSetUpMailboxParams>} LogObject<gSuiteClickSetUpMailboxParams>
 */
export function gSuiteClickSetUpMailbox(params) {
    return { evid: 1133, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickGoToMailbox' event (evid: 1134)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Go to Mailbox.
 *
 * @param {gSuiteClickGoToMailboxParams} params - The parameters for this event
 * @property {number} numSetUpSeats - num_setup_seats
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total_seats
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickGoToMailboxParams>} LogObject<gSuiteClickGoToMailboxParams>
 */
export function gSuiteClickGoToMailbox(params) {
    return { evid: 1134, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickManageAtGoogle' event (evid: 1135)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Manage at Google.
 *
 * @param {gSuiteClickManageAtGoogleParams} params - The parameters for this event
 * @property {number} numSetUpSeats - number of seats that were already setup
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total number of seats in the account
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} 	productTypeId - 	product_type_id
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickManageAtGoogleParams>} LogObject<gSuiteClickManageAtGoogleParams>
 */
export function gSuiteClickManageAtGoogle(params) {
    return { evid: 1135, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickManagePayments' event (evid: 1136)
 *
 * Event description: After use goes to G-suite > click retrieve mailboxes arrow,
 * he clicks Manage Payments.
 *
 * @param {gSuiteClickManagePaymentsParams} params - The parameters for this event
 * @property {number} numSetUpSeats - number of saets that were already set up in the mailbox account
 * @property {string} viewMode - empty_state / maage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total number of seats in the mailbox account
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} productTypeId - product_type_id
 * @property {GUID} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickManagePaymentsParams>} LogObject<gSuiteClickManagePaymentsParams>
 */
export function gSuiteClickManagePayments(params) {
    return { evid: 1136, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickRenewSubscription' event (evid: 1137)
 *
 * Event description: G-suite > click Renew Subscription
 *
 * @param {gSuiteClickRenewSubscriptionParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level/ account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {GUID} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickRenewSubscriptionParams>} LogObject<gSuiteClickRenewSubscriptionParams>
 */
export function gSuiteClickRenewSubscription(params) {
    return { evid: 1137, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickRenewSubscriptionClick' event (evid: 1138)
 *
 * Event description: G-suite > click Renew Subscription > click inside the pop-up
 *
 * @param {gSuiteClickRenewSubscriptionClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} clickType - close, next
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickRenewSubscriptionClickParams>} LogObject<gSuiteClickRenewSubscriptionClickParams>
 */
export function gSuiteClickRenewSubscriptionClick(params) {
    return { evid: 1138, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailboxes' event (evid: 1139)
 *
 * Event description: After use goes to G-suite > he clicks Set Up Mailboxes. This button exists when domain had already set up a mailbox with at least one seat.
 *
 * @param {gSuiteClickSetUpMailboxesParams} params - The parameters for this event
 * @property {number} numSetUpSeats - number of seats in the mailbox account that were already set up
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total number of seats in the mailbox account
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {GUID} productTypeId - productTypeId
 * @property {GUID} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickSetUpMailboxesParams>} LogObject<gSuiteClickSetUpMailboxesParams>
 */
export function gSuiteClickSetUpMailboxes(params) {
    return { evid: 1139, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickBuyAMailbox' event (evid: 1140)
 *
 * Event description: After use goes to G-suite > he clicks Buy a Mailbox. This button exists when user didn't yet buy a mailbox for this domain.
 *
 * @param {gSuiteClickBuyAMailboxParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickBuyAMailboxParams>} LogObject<gSuiteClickBuyAMailboxParams>
 */
export function gSuiteClickBuyAMailbox(params) {
    return { evid: 1140, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailboxesToolTip' event (evid: 1141)
 *
 * Event description: After use goes to G-suite > he clicks Set Up Mailboxes > Hovers or clicks the tool tip. distinguish between hover and click according to clickType field.
 *
 * @param {gSuiteClickSetUpMailboxesToolTipParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - /
 * @return {LogObject<gSuiteClickSetUpMailboxesToolTipParams>} LogObject<gSuiteClickSetUpMailboxesToolTipParams>
 */
export function gSuiteClickSetUpMailboxesToolTip(params) {
    return { evid: 1141, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickSetUpMailboxesEnterField' event (evid: 1142)
 *
 * Event description: After use goes to G-suite > he clicks Set Up Mailboxes >  clicks in any of the boxes in the screen. distinguish between boxes with fieldName field.
 *
 * @param {gSuiteClickSetUpMailboxesEnterFieldParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} fieldName - Choose admin user name, Create Password, Re-enter password, First Name, Last Name, Alternative email, Company Name,  Country, Postal Code
 * @return {LogObject<gSuiteClickSetUpMailboxesEnterFieldParams>} LogObject<gSuiteClickSetUpMailboxesEnterFieldParams>
 */
export function gSuiteClickSetUpMailboxesEnterField(params) {
    return { evid: 1142, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesPageClickDropdown' event (evid: 1145)
 *
 * Event description: G-suite > Click the three dots dropdown in my mailboxes page
 *
 * @param {gSuiteMyMailboxesPageClickDropdownParams} params - The parameters for this event
 * @property {boolean} canUpgrade - If the current package is eligible for upgrade
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} items - MANAGE_AT_GOOGLE, UPGRADE_TO_BUSINESS_EMAIL, MANAGE_PAYMENTS
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<gSuiteMyMailboxesPageClickDropdownParams>} LogObject<gSuiteMyMailboxesPageClickDropdownParams>
 */
export function gSuiteMyMailboxesPageClickDropdown(params) {
    return { evid: 1145, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesExpandLoadSuccess' event (evid: 1146)
 *
 * Event description: My mailboxes > expand load success
 *
 * @param {gSuiteMyMailboxesExpandLoadSuccessParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesExpandLoadSuccessParams>} LogObject<gSuiteMyMailboxesExpandLoadSuccessParams>
 */
export function gSuiteMyMailboxesExpandLoadSuccess(params) {
    return { evid: 1146, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesExpandLoadFailure' event (evid: 1147)
 *
 * Event description: My mailboxes > expand load failure
 *
 * @param {gSuiteMyMailboxesExpandLoadFailureParams} params - The parameters for this event
 * @property {string} errorInfo - network error /data retrieve error
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesExpandLoadFailureParams>} LogObject<gSuiteMyMailboxesExpandLoadFailureParams>
 */
export function gSuiteMyMailboxesExpandLoadFailure(params) {
    return { evid: 1147, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesClickLearnMore' event (evid: 1148)
 *
 * Event description: Click on learn how to set up an additional user/mailbox after the admin was already set up
 *
 * @param {gSuiteMyMailboxesClickLearnMoreParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referraladditionalinfo
 * @return {LogObject<gSuiteMyMailboxesClickLearnMoreParams>} LogObject<gSuiteMyMailboxesClickLearnMoreParams>
 */
export function gSuiteMyMailboxesClickLearnMore(params) {
    return { evid: 1148, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesPageLoadFailure' event (evid: 1149)
 *
 * Event description: G-suite > My mailboxes > Page load failure (manage state)
 *
 * @param {gSuiteMyMailboxesPageLoadFailureParams} params - The parameters for this event
 * @property {string} errorInfo - network error /data retrieve error
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referraladditionalinfo
 * @return {LogObject<gSuiteMyMailboxesPageLoadFailureParams>} LogObject<gSuiteMyMailboxesPageLoadFailureParams>
 */
export function gSuiteMyMailboxesPageLoadFailure(params) {
    return { evid: 1149, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesConnectMailboxLearnHow' event (evid: 1150)
 *
 * Event description: Click on learn how to connect a mailbox that was purchased outside of Wix
 *
 * @param {gSuiteMyMailboxesConnectMailboxLearnHowParams} params - The parameters for this event
 * @property {number} accountTotalDomains - total number of domains in the account
 * @property {string} pageView - page_view
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesConnectMailboxLearnHowParams>} LogObject<gSuiteMyMailboxesConnectMailboxLearnHowParams>
 */
export function gSuiteMyMailboxesConnectMailboxLearnHow(params) {
    return { evid: 1150, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesClickDropdownSeatLevel' event (evid: 1151)
 *
 * Event description: G-suite > Click the three dots dropdown in seat level (my mailboxes page)
 *
 * @param {gSuiteMyMailboxesClickDropdownSeatLevelParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain name
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {GUID} 	productTypeId - 	productTypeId
 * @property {GUID} 	productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteMyMailboxesClickDropdownSeatLevelParams>} LogObject<gSuiteMyMailboxesClickDropdownSeatLevelParams>
 */
export function gSuiteMyMailboxesClickDropdownSeatLevel(params) {
    return { evid: 1151, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickOnRenameUser' event (evid: 1152)
 *
 * Event description: G-suite > Click 'Rename User'
 *
 * @param {gSuiteClickOnRenameUserParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} productTypeId - productTypeId
 * @property {GUID} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteClickOnRenameUserParams>} LogObject<gSuiteClickOnRenameUserParams>
 */
export function gSuiteClickOnRenameUser(params) {
    return { evid: 1152, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteRenameUserPopUpClick' event (evid: 1153)
 *
 * Event description: G-suite > Rename User Pop-up > click
 *
 * @param {gSuiteRenameUserPopUpClickParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {boolean} firstNameChanged - true/false
 * @property {string} domain - domain
 * @property {string} clickType - cancel, close, rename_user
 * @property {string} pageView - site_level/account_level
 * @property {boolean} emailAddressChanged - true/false
 * @property {boolean} lastNameChanged - true/false
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteRenameUserPopUpClickParams>} LogObject<gSuiteRenameUserPopUpClickParams>
 */
export function gSuiteRenameUserPopUpClick(params) {
    return { evid: 1153, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesRenameUserLearnMore' event (evid: 1154)
 *
 * Event description: Click on learn more on the message  "Renaming your user can take up to 10 minutes" or on "This user will continue to receive emails sent to old and new address"
 *
 * @param {gSuiteMyMailboxesRenameUserLearnMoreParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - emailPackageGuid
 * @property {string} domain - domain name
 * @property {string} messageType - time_to_update/email_address
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteMyMailboxesRenameUserLearnMoreParams>} LogObject<gSuiteMyMailboxesRenameUserLearnMoreParams>
 */
export function gSuiteMyMailboxesRenameUserLearnMore(params) {
    return { evid: 1154, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteRenameUserSubmitSuccess' event (evid: 1155)
 *
 * Event description: Rename user Submit Success
 *
 * @param {gSuiteRenameUserSubmitSuccessParams} params - The parameters for this event
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<gSuiteRenameUserSubmitSuccessParams>} LogObject<gSuiteRenameUserSubmitSuccessParams>
 */
export function gSuiteRenameUserSubmitSuccess(params) {
    return { evid: 1155, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteRenameUserSubmitError' event (evid: 1156)
 *
 * Event description: Rename user Submit Error
 *
 * @param {gSuiteRenameUserSubmitErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error info
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<gSuiteRenameUserSubmitErrorParams>} LogObject<gSuiteRenameUserSubmitErrorParams>
 */
export function gSuiteRenameUserSubmitError(params) {
    return { evid: 1156, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesRedirectionFromPurchase' event (evid: 1157)
 *
 * Event description: G-suite > My mailboxes > Redirection from Purchase
 *
 * @param {gSuiteMyMailboxesRedirectionFromPurchaseParams} params - The parameters for this event
 * @property {string} errorInfo - network error /data retrieve error
 * @property {number} retryCount - number of retries
 * @property {string} domainName - domainName
 * @property {boolean} isSuccess - whether setup form redirection worked
 * @property {string} referralAdditionalInfo - referraladditionalinfo
 * @return {LogObject<gSuiteMyMailboxesRedirectionFromPurchaseParams>} LogObject<gSuiteMyMailboxesRedirectionFromPurchaseParams>
 */
export function gSuiteMyMailboxesRedirectionFromPurchase(params) {
    return { evid: 1157, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowEligibilityCartExposure' event (evid: 1222)
 *
 * Event description: Is eligible to get the Cart experience (express checkout). Used for exposure for the AB test
 *
 * @param {expressFlowEligibilityCartExposureParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {boolean} isEligible - Is eligible for cart or not
 * @property {GUID} msid - msid
 * @return {LogObject<expressFlowEligibilityCartExposureParams>} LogObject<expressFlowEligibilityCartExposureParams>
 */
export function expressFlowEligibilityCartExposure(params) {
    return { evid: 1222, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutView' event (evid: 1223)
 *
 * Event description: User viewed the Pre-Checkout of express flow
 *
 * @param {expressFlowPreCheckoutViewParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @return {LogObject<expressFlowPreCheckoutViewParams>} LogObject<expressFlowPreCheckoutViewParams>
 */
export function expressFlowPreCheckoutView(params) {
    return { evid: 1223, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutPlanProductIsViewed' event (evid: 1224)
 *
 * Event description: Plan product is shown
 *
 * @param {expressFlowPreCheckoutPlanProductIsViewedParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} productType - plan
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {string} productId - product_id
 * @property {GUID} msid - site
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutPlanProductIsViewedParams>} LogObject<expressFlowPreCheckoutPlanProductIsViewedParams>
 */
export function expressFlowPreCheckoutPlanProductIsViewed(params) {
    return { evid: 1224, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutDomainProductViewed' event (evid: 1225)
 *
 * Event description: Domain product is shown
 *
 * @param {expressFlowPreCheckoutDomainProductViewedParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} privacy - true, false
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {string} productId - product_id
 * @property {GUID} msid - site
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutDomainProductViewedParams>} LogObject<expressFlowPreCheckoutDomainProductViewedParams>
 */
export function expressFlowPreCheckoutDomainProductViewed(params) {
    return { evid: 1225, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutGeneralCtaClick' event (evid: 1226)
 *
 * Event description: Clicks on CTAs in pre checkout page
 *
 * @param {expressFlowPreCheckoutGeneralCtaClickParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} elementText - domain_privacy_learn_more
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutGeneralCtaClickParams>} LogObject<expressFlowPreCheckoutGeneralCtaClickParams>
 */
export function expressFlowPreCheckoutGeneralCtaClick(params) {
    return { evid: 1226, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutProductRemoveAdd' event (evid: 1228)
 *
 * Event description: Add or Remove product from the pre-checkout page  (check / uncheck)
 *
 * @param {expressFlowPreCheckoutProductRemoveAddParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} productType - domain, plan
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} action - add, remove
 * @property {string} referraladditionalinfo - .
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutProductRemoveAddParams>} LogObject<expressFlowPreCheckoutProductRemoveAddParams>
 */
export function expressFlowPreCheckoutProductRemoveAdd(params) {
    return { evid: 1228, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutPlanSelectionCycleChange' event (evid: 1229)
 *
 * Event description: Change of Plan cycle
 *
 * @param {expressFlowPreCheckoutPlanSelectionCycleChangeParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {number} cycle - 3,6,7,8
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @property {string} changeSource - Where was the cycle changed from- dedicated CTA, or cycle scroll
 * @return {LogObject<expressFlowPreCheckoutPlanSelectionCycleChangeParams>} LogObject<expressFlowPreCheckoutPlanSelectionCycleChangeParams>
 */
export function expressFlowPreCheckoutPlanSelectionCycleChange(params) {
    return { evid: 1229, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutDomainSelectionPrivacyChange' event (evid: 1230)
 *
 * Event description: Change of domain privacy
 *
 * @param {expressFlowPreCheckoutDomainSelectionPrivacyChangeParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} action - add, remove
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutDomainSelectionPrivacyChangeParams>} LogObject<expressFlowPreCheckoutDomainSelectionPrivacyChangeParams>
 */
export function expressFlowPreCheckoutDomainSelectionPrivacyChange(params) {
    return { evid: 1230, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutDomainSelectionCycleChange' event (evid: 1231)
 *
 * Event description: Change of domain cycle
 *
 * @param {expressFlowPreCheckoutDomainSelectionCycleChangeParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {number} cycle - cycle_id
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutDomainSelectionCycleChangeParams>} LogObject<expressFlowPreCheckoutDomainSelectionCycleChangeParams>
 */
export function expressFlowPreCheckoutDomainSelectionCycleChange(params) {
    return { evid: 1231, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutCtaComparePlans' event (evid: 1232)
 *
 * Event description: click "Compare Plans" CTA in Pre Checkout page (redirects to Package Picker)
 *
 * @param {expressFlowPreCheckoutCtaComparePlansParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {string} flow - flow
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutCtaComparePlansParams>} LogObject<expressFlowPreCheckoutCtaComparePlansParams>
 */
export function expressFlowPreCheckoutCtaComparePlans(params) {
    return { evid: 1232, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutContinueToCheckout' event (evid: 1233)
 *
 * Event description: click Continue in Pre-Checkout page
 *
 * @param {expressFlowPreCheckoutContinueToCheckoutParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {number} totalAmount - amount
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {string} currency - currency
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowPreCheckoutContinueToCheckoutParams>} LogObject<expressFlowPreCheckoutContinueToCheckoutParams>
 */
export function expressFlowPreCheckoutContinueToCheckout(params) {
    return { evid: 1233, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowPreCheckoutClickBack' event (evid: 1234)
 *
 * Event description: click back in Pre Checkout page
 *
 * @param {expressFlowPreCheckoutClickBackParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} sourcePage - bundle_selector (budle/domain only), plan_selector (PP), cart (summary page), checkout
 * @property {string} countryCode - .
 * @property {GUID} viewGuid - unique view_guid
 * @property {boolean} isAccountPremium - true, false
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @property {string} eventAggregator - eventaggregator
 * @property {string} viewmode - view_mode
 * @return {LogObject<expressFlowPreCheckoutClickBackParams>} LogObject<expressFlowPreCheckoutClickBackParams>
 */
export function expressFlowPreCheckoutClickBack(params) {
    return { evid: 1234, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowErrorPage' event (evid: 1235)
 *
 * Event description: Add or Remove product from the pre-checkout page  (check / uncheck)
 *
 * @param {expressFlowErrorPageParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {GUID} uuid - uuid
 * @property {string} errorMsg - error_message
 * @property {string} countryCode - .
 * @property {boolean} isAccountPremium - true, false
 * @property {string} pageName - page name
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowErrorPageParams>} LogObject<expressFlowErrorPageParams>
 */
export function expressFlowErrorPage(params) {
    return { evid: 1235, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'checkoutPagePaymentMethodLoadingStart' event (evid: 1342)
 *
 * Event description: Payment Method Loading - Start event for test the loading time of Payment method on the checkout
 *
 * @param {checkoutPagePaymentMethodLoadingStartParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPagePaymentMethodLoadingStartParams>} LogObject<checkoutPagePaymentMethodLoadingStartParams>
 */
export function checkoutPagePaymentMethodLoadingStart(params) {
    return { evid: 1342, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'checkoutPagePaymentMethodLoadingEnd' event (evid: 1343)
 *
 * Event description: Payment Method Loading - End , event for test the loading time of Payment method on the checkout
 *
 * @param {checkoutPagePaymentMethodLoadingEndParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {number} paymentMethodSubType - 0=OXXO ; 4=boleto, ?=Sofort
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<checkoutPagePaymentMethodLoadingEndParams>} LogObject<checkoutPagePaymentMethodLoadingEndParams>
 */
export function checkoutPagePaymentMethodLoadingEnd(params) {
    return { evid: 1343, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUp' event (evid: 14081)
 *
 * Event description: after users clicks on remove contributor, he reaches a pop up which shows the subscriptions are related to his payment methods.
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the replaced billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUp(params) {
    return { evid: 14081, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccess' event (evid: 14082)
 *
 * Event description: after update of the PM was processed successfully , user reaches update success page.
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the new billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccess(params) {
    return { evid: 14082, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClick' event (evid: 14083)
 *
 * Event description: after update of the PM was processed successfully , user reaches update success page and selects action
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClickParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the new billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} clickType - keep/remove/close
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClickParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClickParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateSuccessClick(params) {
    return { evid: 14083, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFail' event (evid: 14084)
 *
 * Event description: after update of the PM was failed, user reaches pop up
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the replaced billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} inviteStatus - pending/expired/accepted/leave_team
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFail(params) {
    return { evid: 14084, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClick' event (evid: 14085)
 *
 * Event description: after update of the PM failed, user reaches update fail page and selects action
 *
 * @param {rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClickParams} params - The parameters for this event
 * @property {GUID} teammateId - the user_id of the removed team/team member (if status is pending then invite_id)
 * @property {string} roleIds - role_id of the removed user
 * @property {string} billingAccountGuid - the replaced billing account guid
 * @property {string} serviceGuid - the associated service of the PM
 * @property {string} context - account/site
 * @property {string} clickType - keep/try/close/back
 * @property {string} roleId - role_id of the removed user
 * @return {LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClickParams>} LogObject<rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClickParams>
 */
export function rolesAndPermissionsViewRemoveTeammatePopUpPmUpdateFailClick(params) {
    return { evid: 14085, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainClickOnAssignToADifferentSite' event (evid: 15)
 *
 * Event description: My Subscriptions >  Click on "Assign to a different site".
 *
 * @param {domainClickOnAssignToADifferentSiteParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscriptionId
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} paymentCycle - cycle_id
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} productTypeName - productTypeName
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} productTypeId - productTypeId
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - partners/diy
 * @property {string} isEditorxSiteExist - Is any of the sites editor x site (true/false)
 * @property {number} '29' - initiator
 * @property {string} productGuid - productGuid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<domainClickOnAssignToADifferentSiteParams>} LogObject<domainClickOnAssignToADifferentSiteParams>
 */
export function domainClickOnAssignToADifferentSite(params) {
    return { evid: 15, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vSearchDomainLoaded' event (evid: 1512)
 *
 * Event description: Client - V_SearchDomainLoaded (view domain search page)
 *
 * @param {vSearchDomainLoadedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} voucher - true | false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} screenResolution - screen_resolution
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} referral - referral
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - where a user came from
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - where a user came from
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vSearchDomainLoadedParams>} LogObject<vSearchDomainLoadedParams>
 */
export function vSearchDomainLoaded(params) {
    return { evid: 1512, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'voucherPageGetYourDomainCta' event (evid: 1515)
 *
 * Event description: voucher page > Get Your Domain CTA
 *
 * @param {voucherPageGetYourDomainCtaParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} text - get your domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @return {LogObject<voucherPageGetYourDomainCtaParams>} LogObject<voucherPageGetYourDomainCtaParams>
 */
export function voucherPageGetYourDomainCta(params) {
    return { evid: 1515, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aClickOnViewSingleInvoice' event (evid: 1600)
 *
 * Event description: client
 *
 * @param {aClickOnViewSingleInvoiceParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {string} selectionType - 'invoice_row'/ 'edit invoice toast'
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} invoiceId - invoice_id
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {GUID} sessionId - session_id
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {GUID} siteId - site_id
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickOnViewSingleInvoiceParams>} LogObject<aClickOnViewSingleInvoiceParams>
 */
export function aClickOnViewSingleInvoice(params) {
    return { evid: 1600, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aDomainClickOnCancel' event (evid: 1611)
 *
 * Event description: A_DomainClickOnCancel.
 *
 * @param {aDomainClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {number} domainSkuId - domain_sku_id
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aDomainClickOnCancelParams>} LogObject<aDomainClickOnCancelParams>
 */
export function aDomainClickOnCancel(params) {
    return { evid: 1611, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMailClickOnCancel1612' event (evid: 1612)
 *
 * Event description: client
 *
 * @param {aMailClickOnCancel1612Params} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} emailSkuId - email_sku_id
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {boolean} isIncudingVoice - true if has active voice that will be cancelled
 * @property {string} isIncludingGemini - true if has active geminin that will be cancelled
 * @property {string} subscriptionsList - all subscription guids that will be cancelled (gws and add-ons)
 * @property {string} action - view of the modal or click on one of the CTAs
 * @property {GUID} GeminiProductId - gemini_product_id
 * @property {GUID} VoiceProductId - voice_product_id
 * @return {LogObject<aMailClickOnCancel1612Params>} LogObject<aMailClickOnCancel1612Params>
 */
export function aMailClickOnCancel1612(params) {
    return { evid: 1612, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'editInvoiceWarningMessage' event (evid: 1622)
 *
 * Event description: edit invoice -> warning message
 *
 * @param {editInvoiceWarningMessageParams} params - The parameters for this event
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {GUID} serviceGuid - service_guid
 * @property {string} externalSessionId - externalSessionId
 * @property {string} errorMessage - cant apply vat , cant apply postal code
 * @property {string} domain - domain
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} invoiceId - invoice_id
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {number} cycleId - cycle_id
 * @property {string} product - product_name_on_screen
 * @return {LogObject<editInvoiceWarningMessageParams>} LogObject<editInvoiceWarningMessageParams>
 */
export function editInvoiceWarningMessage(params) {
    return { evid: 1622, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'editInvoiceClick' event (evid: 1623)
 *
 * Event description: edit invoice click
 *
 * @param {editInvoiceClickParams} params - The parameters for this event
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {GUID} serviceGuid - service_guid
 * @property {string} externalSessionId - externalSessionId
 * @property {string} futureUpdatedFields - Fields to be updated in future invoices
 * @property {string} domain - domain
 * @property {boolean} applyToAllOtherServices - true/false
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - save, cancel, close
 * @property {string} invoiceId - invoice_id
 * @property {string} fieldsUpdated - fields_updated
 * @property {string} subscriptionsEffected - subscriptions_effected
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {boolean} applyToAllOtherInvoices - true/false
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {number} cycleId - cycle_id
 * @property {string} product - product_name_on_screen
 * @return {LogObject<editInvoiceClickParams>} LogObject<editInvoiceClickParams>
 */
export function editInvoiceClick(params) {
    return { evid: 1623, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'editInvoiceClickSaveError' event (evid: 1625)
 *
 * Event description: Invoice update error message
 *
 * @param {editInvoiceClickSaveErrorParams} params - The parameters for this event
 * @property {GUID} newBillingAccountGuidCurrentInvoice - new_billing_account_for_invoice
 * @property {GUID} newBillingAccountGuidForServices - new_billing_account_for_services
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {GUID} serviceGuid - service_guid
 * @property {string} errorInfo - error
 * @property {string} externalSessionId - external_session_id
 * @property {string} domain - domain
 * @property {boolean} isBulk - Is_bulk
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} invoiceId - invoice_id
 * @property {GUID} originalPaymentSourceId - old_billing_account_guid
 * @property {boolean} isUpdatedLastInvoice - true/false
 * @property {GUID} newPaymentSourceIdCurrentInvoice - new_billing_account_for_invoice
 * @property {string} fieldsUpdated - fields_updated
 * @property {string} servicesInvoicesList - services_invoices_list
 * @property {string} invalidFields - Invalid fields
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {GUID} newPaymentSourceIdForServices - new_billing_account_for_services
 * @property {number} cycleId - cycle_id
 * @property {string} product - I hate this field
 * @return {LogObject<editInvoiceClickSaveErrorParams>} LogObject<editInvoiceClickSaveErrorParams>
 */
export function editInvoiceClickSaveError(params) {
    return { evid: 1625, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'ilInvoicePendingElectronicSignatureMessage' event (evid: 1630)
 *
 * Event description: A message that Israeli users receive when they click on view invoice, and the invoice is still pending an electronic signature
 *
 * @param {ilInvoicePendingElectronicSignatureMessageParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - where did the user arrive from
 * @property {string} billingInvoiceId - invoice
 * @return {LogObject<ilInvoicePendingElectronicSignatureMessageParams>} LogObject<ilInvoicePendingElectronicSignatureMessageParams>
 */
export function ilInvoicePendingElectronicSignatureMessage(params) {
    return { evid: 1630, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistory' event (evid: 1631)
 *
 * Event description: The user clicks on go to billing history CTA from the message that his invoice is still pending an electronic signature
 *
 * @param {ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistoryParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - where did the user arrive from
 * @property {string} billingInvoiceId - billingInvoiceId
 * @return {LogObject<ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistoryParams>} LogObject<ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistoryParams>
 */
export function ilInvoicePendingElectronicSignatureMessageClickGoToBillingHistory(params) {
    return { evid: 1631, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rSbsOrderPagePremiumPurchaseBusinessError' event (evid: 176)
 *
 * Event description: R_SbsOrderPagePremiumPurchaseBusinessError
 *
 * @param {rSbsOrderPagePremiumPurchaseBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rSbsOrderPagePremiumPurchaseBusinessErrorParams>} LogObject<rSbsOrderPagePremiumPurchaseBusinessErrorParams>
 */
export function rSbsOrderPagePremiumPurchaseBusinessError(params) {
    return { evid: 176, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rSbsOrderPagePremiumPurchaseFatalError' event (evid: 177)
 *
 * Event description: R_SbsOrderPagePremiumPurchaseFatalError
 *
 * @param {rSbsOrderPagePremiumPurchaseFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rSbsOrderPagePremiumPurchaseFatalErrorParams>} LogObject<rSbsOrderPagePremiumPurchaseFatalErrorParams>
 */
export function rSbsOrderPagePremiumPurchaseFatalError(params) {
    return { evid: 177, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aSbsPremiumPurchaseBuyButtonPressed' event (evid: 178)
 *
 * Event description: A_SbsPremiumPurchaseBuyButtonPressed
 *
 * @param {aSbsPremiumPurchaseBuyButtonPressedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aSbsPremiumPurchaseBuyButtonPressedParams>} LogObject<aSbsPremiumPurchaseBuyButtonPressedParams>
 */
export function aSbsPremiumPurchaseBuyButtonPressed(params) {
    return { evid: 178, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsDomainConnectionProblems' event (evid: 197)
 *
 * Event description: Triggers if users have at least 1 domain in the following status:  DNS_DOMAIN_CONNECTION_STATUS_ERROR, POINTING_DOMAIN_CONNECTION_STATUS_ERROR, DNS_RECORDS_POINTING_OUTSIDE_OF_WIX, DOMAIN_STILL_PROPAGATING, DOMAIN_STILL_VERIFYING
 *
 * @param {myDomainsDomainConnectionProblemsParams} params - The parameters for this event
 * @property {string} status_text - first negative domain status that we detected
 * @property {string} referralAdditionalInfo - where users come from
 * @property {GUID} msid - msid (null for account level)
 * @property {string} domainsQuantity - domains quantity on the page
 * @return {LogObject<myDomainsDomainConnectionProblemsParams>} LogObject<myDomainsDomainConnectionProblemsParams>
 */
export function myDomainsDomainConnectionProblems(params) {
    return { evid: 197, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'manageDomainsBottomBanner' event (evid: 198)
 *
 * Event description: Get help for connect domain banner in my domains in case the list have a at least 1 domain in the following status:  DNS_DOMAIN_CONNECTION_STATUS_ERROR, POINTING_DOMAIN_CONNECTION_STATUS_ERROR, DNS_RECORDS_POINTING_OUTSIDE_OF_WIX, DOMAIN_STILL_PROPAGATING, DOMAIN_STILL_VERIFYING
 *
 * @param {manageDomainsBottomBannerParams} params - The parameters for this event
 * @property {string} clickType - view | click
 * @property {string} popup_type - wix_arena_banner
 * @property {string} status_text - first negative domain status that we detected
 * @property {string} referralAdditionalInfo - where users come from
 * @property {GUID} msid - msid (null for account level)
 * @property {string} domainsQuantity - domains quantity on the page
 * @return {LogObject<manageDomainsBottomBannerParams>} LogObject<manageDomainsBottomBannerParams>
 */
export function manageDomainsBottomBanner(params) {
    return { evid: 198, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aClickOnUnAssign' event (evid: 20)
 *
 * Event description: A_ClickOnUnAssign
 *
 * @param {aClickOnUnAssignParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} subscriptionId - subscription_id
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {string} productTypeName - product_type_name
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {GUID} siteid - site_id
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {string} productTypeId - product_type_id
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - partners/diy
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - to_msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<aClickOnUnAssignParams>} LogObject<aClickOnUnAssignParams>
 */
export function aClickOnUnAssign(params) {
    return { evid: 20, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vManageDomains' event (evid: 209)
 *
 * Event description: client
 *
 * @param {vManageDomainsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} responseSpeed - download page time in milliseconds
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} domains - 5 random domains from myDomains
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} emptyState - true | false
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - where users came from
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {boolean} isPremiumSite - true, false
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {boolean} isVoucher - true, false
 * @property {string} region - region
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} reseller - reseller guid if applicable
 * @property {string} pageType - default, reseller
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid for site level, null for account
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vManageDomainsParams>} LogObject<vManageDomainsParams>
 */
export function vManageDomains(params) {
    return { evid: 209, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'bundlePurchaseSuccessPageClick' event (evid: 2234)
 *
 * Event description: CTAs click on bundle plan purchase success page
 *
 * @param {bundlePurchaseSuccessPageClickParams} params - The parameters for this event
 * @property {string} voucher - true/false
 * @property {string} domain - domain
 * @property {number} paymentMethod - payment_method
 * @property {string} clickType - buy_mailbox , show_summary, go_to_dashboard
 * @property {string} eventAggregator - event_aggregator
 * @property {number} cycle - cycle_id
 * @property {string} flow - express_checkout
 * @property {string} pageType - default success page / connect domain success page
 * @property {string} productGuid - Product Guid
 * @property {GUID} msid - msid
 * @property {string} product - bundle_domain_plan
 * @property {string} abTesting - abTesting1
 * @return {LogObject<bundlePurchaseSuccessPageClickParams>} LogObject<bundlePurchaseSuccessPageClickParams>
 */
export function bundlePurchaseSuccessPageClick(params) {
    return { evid: 2234, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vUpgradeBeforeConnect' event (evid: 283)
 *
 * Event description: Triggers when free users click on Connect Domain button
 *
 * @param {vUpgradeBeforeConnectParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} split_referral - referral of the modal (where it was opened from)- funnel/concierge/setupwidget
 *
 * @property {string} version - old or new modal
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - true, false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} totalUnassignedDomains - num of domains
 * @property {string} '23' - additional_info
 * @property {string} voucherSupportedTlds - .
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {GUID} siteOwnerId - .
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} domainPermissions - .
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} totalInactiveDomains - num of domains
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} domains - list of domains
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} totalDomains - num of domains
 * @property {boolean} emptyState - true / false
 * @property {boolean} isPublished - true, false
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} locale - .
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - Where user came from
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {boolean} isPremiumPlansOnSale - .
 * @property {boolean} hasSites - If the user has sites in the account of not
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {boolean} isPremiumSite - true, false
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {string} isConcierge - true, false
 * @property {GUID} '2' - billing_session_id
 * @property {boolean} isVoucher - If the modal was at it's voucher version or not
 * @property {string} region - region
 * @property {string} totalConnectedDomains - num of domains
 * @property {string} hasValidVouchers - .
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - Where user came from
 * @property {boolean} isAccountPremium - User has at least one valid premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} place - empty_state | connectdomain_topbanner
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - true, false
 * @property {string} totalAssignedDomains - num of domains
 * @property {string} sites - .
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} hosting - .
 * @property {number} limit - .
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {string} action - view | select_plan | close | transfer_your_domain | learn_more
 * @property {boolean} isSale - if the modal was on its sale version or not
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vUpgradeBeforeConnectParams>} LogObject<vUpgradeBeforeConnectParams>
 */
export function vUpgradeBeforeConnect(params) {
    return { evid: 283, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aSearchNewDomain' event (evid: 285)
 *
 * Event description: A_SearchNewDomain
 *
 * @param {aSearchNewDomainParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} name - name
 * @property {string} voucher - voucher
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} totalUnassignedDomains - total_unassigned_domains
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} totalInactiveDomains - total_inactive_domains
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} totalDomains - total_domains
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {string} totalConnectedDomains - total_connected_domains
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {string} reseller - reseller uuid
 * @property {string} pageType - default, reseller
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - is_premium
 * @property {string} totalAssignedDomains - total_assigned_domains
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aSearchNewDomainParams>} LogObject<aSearchNewDomainParams>
 */
export function aSearchNewDomain(params) {
    return { evid: 285, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aClickConnectDomainNextButton' event (evid: 286)
 *
 * Event description: A_ClickConnectDomainNextButton.
 *
 * @param {aClickConnectDomainNextButtonParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - true/false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - additional_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} pagetype - page_type
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral additiona linfo
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral additiona linfo
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aClickConnectDomainNextButtonParams>} LogObject<aClickConnectDomainNextButtonParams>
 */
export function aClickConnectDomainNextButton(params) {
    return { evid: 286, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vUpgradeBeforeDomainPurchase' event (evid: 290)
 *
 * Event description: Premium Upgrade Pop-Up appears when a user without premium clicks on 'Get it' CTA on the domain search
 *
 * @param {vUpgradeBeforeDomainPurchaseParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} intent - connect or get
 * @property {string} version - indicating if was opened as a modal or new tab
 * @property {string} splitReferral - referral of the split page (where it was opened from)- concierge/funnel/storefront
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel/ focusWidget  / express-checkout
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - true / false
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} voucherSupportedTlds - .
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {GUID} siteOwnerId - .
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} domainPermissions - .
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - clicked domain name
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} locale - .
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - where a user came from to the page
 * @property {string} browser_family - browser_family
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {string} bot_name - bot_name
 * @property {string} '31' - clicked domain name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {boolean} isPremiumPlansOnSale - .
 * @property {boolean} hasSites - If the user has sites in the account
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {boolean} isPremiumSite - true, false
 * @property {number} '20' - cancel_reason
 * @property {string} actionName - view / upgrade_now / buy_domain / bundle_domain_plan / click_collapse
 * @property {number} '27' - email_provider
 * @property {string} isConcierge - true,false
 * @property {GUID} '2' - billing_session_id
 * @property {boolean} isVoucher - if the modal was at it's voucher version or not
 * @property {string} region - region
 * @property {string} hasValidVouchers - .
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - where a user came from to the page
 * @property {boolean} isAccountPremium - true, false
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {boolean} isPremium - true, false
 * @property {string} sites - .
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} hosting - null / dashboard
 * @property {number} limit - .
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {boolean} isSale - if the modal was at it's sale version or not
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} domains - list
 * @property {boolean} emptystate - emptystate
 * @property {number} totalassigneddomains - totalassigneddomains
 * @property {number} totalconnecteddomains - totalconnecteddomains
 * @property {number} totaldomains - totaldomains
 * @property {number} totalinactivedomains - totalinactivedomains
 * @property {number} totalunassigneddomains - totalunassigneddomains
 * @return {LogObject<vUpgradeBeforeDomainPurchaseParams>} LogObject<vUpgradeBeforeDomainPurchaseParams>
 */
export function vUpgradeBeforeDomainPurchase(params) {
    return { evid: 290, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vOwnerRestrictedAreaError' event (evid: 299)
 *
 * Event description: V_OwnerRestrictedAreaError.
 *
 * @param {vOwnerRestrictedAreaErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vOwnerRestrictedAreaErrorParams>} LogObject<vOwnerRestrictedAreaErrorParams>
 */
export function vOwnerRestrictedAreaError(params) {
    return { evid: 299, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vVoucher' event (evid: 3)
 *
 * Event description: V_Voucher
 *
 * @param {vVoucherParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} pageView - page_view
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {string} extraInfo - uuid
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vVoucherParams>} LogObject<vVoucherParams>
 */
export function vVoucher(params) {
    return { evid: 3, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'searchDomainSearchResultView' event (evid: 309)
 *
 * Event description: Search domain results view.
 *
 * @param {searchDomainSearchResultViewParams} params - The parameters for this event
 * @property {number} responseSpeed - response time between click on search button and search result view
 * @property {number} numOfSuggestions - number of suggestions appeared
 * @property {string} viewMode - concierge , purchase, focusWidget
 * @property {string} voucher - true | false
 * @property {string} conciergeStatus - search results error (only from concierge)
 * @property {string} voucherSupportedTlds - .
 * @property {string} assignmentStatus - .
 * @property {GUID} siteOwnerId - .
 * @property {boolean} preTyped - was domain pre-filled or typed by user
 * @property {string} domainPermissions - .
 * @property {number} numOfLabels - number of labeled suggestions appeared
 * @property {string} domain - .
 * @property {GUID} uuid - uuid
 * @property {string} searchTerm - searched domain
 * @property {string} result - array of suggested domains/available/error message
 * @property {string} domains - .
 * @property {string} suggestions - .
 * @property {string} locale - .
 * @property {string} transferInState - .
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isPremiumPlansOnSale - true, false
 * @property {boolean} isUnsupported - true, false
 * @property {boolean} isPremiumSite - true / false
 * @property {string} connectionStatus - domain connection status
 * @property {boolean} isVoucher - true / false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {boolean} isAccountPremium - true / false
 * @property {string} requestId - request_id
 * @property {boolean} isAvailable - true, false
 * @property {boolean} isTaken - true, false
 * @property {boolean} isPremium - true / false
 * @property {string} sites - .
 * @property {string} suggestionsList - complex results
 * @property {string} type - suggestions/available/error/pending_transfer_completion
 * @property {string} hosting - null / dashboard
 * @property {string} unassignedDomains - .
 * @property {number} limit - .
 * @property {GUID} msid - msid
 * @property {boolean} isSale - true / false
 * @property {GUID} sourceMsid - msid which the domain is assigned to
 * @property {string} intent - get/connect
 * @property {boolean} IsBundleEligible - true,false
 * @property {string} PageSource - Marketing gate source
 * @property {string} funnelDomainFlow - get domain/connect/domain
 * for new funnel flow
 * @property {number} NumFiltersActive - amount of filters active in view
 * @property {string} ActiveFilters - string of all active filters
 * @property {boolean} IsPremiumDomain - true, false
 * @return {LogObject<searchDomainSearchResultViewParams>} LogObject<searchDomainSearchResultViewParams>
 */
export function searchDomainSearchResultView(params) {
    return { evid: 309, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'searchDomainClickGetIt' event (evid: 310)
 *
 * Event description: Click on "Get it" button in the domain search
 *
 * @param {searchDomainClickGetItParams} params - The parameters for this event
 * @property {number} responseSpeed - response time between search result view and click get it
 * @property {string} viewMode - purchase , concierge, focusWidget
 * @property {string} voucher - true | false
 * @property {string} domain - clicked domain
 * @property {GUID} uuid - uuid
 * @property {string} searchTerm - searched domain
 * @property {string} locale - .
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {boolean} isAccountPremium - true, false
 * @property {number} position - 0 - search/1+ - suggestions
 * @property {boolean} isPremium - true, false
 * @property {string} type - search/suggestions/secondary
 * @property {string} hosting - null / dashboard
 * @property {GUID} msid - msid
 * @property {boolean} isSale - true, false
 * @property {string} intent - get/connect
 * @property {string} second_domain_name - domain name in bundle offering
 * @property {boolean} IsPremiumDomain - true,false
 * @return {LogObject<searchDomainClickGetItParams>} LogObject<searchDomainClickGetItParams>
 */
export function searchDomainClickGetIt(params) {
    return { evid: 310, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rPremiumOrderPageSubmitSuccess' event (evid: 3103)
 *
 * Event description: R_PremiumOrderPageSubmitSuccess.
 *
 * @param {rPremiumOrderPageSubmitSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - eventAggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - abTesting
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - abTesting
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - abTesting
 * @return {LogObject<rPremiumOrderPageSubmitSuccessParams>} LogObject<rPremiumOrderPageSubmitSuccessParams>
 */
export function rPremiumOrderPageSubmitSuccess(params) {
    return { evid: 3103, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rPremiumOrderPageSubmitPending' event (evid: 3104)
 *
 * Event description: R_PremiumOrderPageSubmitPending.
 *
 * @param {rPremiumOrderPageSubmitPendingParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - paymentMethod
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - paymentMethod
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rPremiumOrderPageSubmitPendingParams>} LogObject<rPremiumOrderPageSubmitPendingParams>
 */
export function rPremiumOrderPageSubmitPending(params) {
    return { evid: 3104, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'resellerManagementRedirectUrlView' event (evid: 315)
 *
 * Event description: reseller redirect url shown
 *
 * @param {resellerManagementRedirectUrlViewParams} params - The parameters for this event
 * @property {GUID} reseller_uuid - reseller uuid
 * @property {string} referralAdditionalInfo - referral additional info (origin CTA)
 * @property {string} reseller - reseller name
 * @property {string} subscriptionType - plan, ascend
 * @property {GUID} msid - site msid
 * @return {LogObject<resellerManagementRedirectUrlViewParams>} LogObject<resellerManagementRedirectUrlViewParams>
 */
export function resellerManagementRedirectUrlView(params) {
    return { evid: 315, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'resellerManagementRedirectUrlClick' event (evid: 316)
 *
 * Event description: reseller redirect url click
 *
 * @param {resellerManagementRedirectUrlClickParams} params - The parameters for this event
 * @property {GUID} reseller_uuid - reseller uuid
 * @property {string} clickType - upgrade, learn_more
 * @property {string} referralAdditionalInfo - referral additional info (origin CTA)
 * @property {string} reseller - reseller name
 * @property {string} subscriptionType - plan, ascend
 * @property {GUID} msid - site msid
 * @return {LogObject<resellerManagementRedirectUrlClickParams>} LogObject<resellerManagementRedirectUrlClickParams>
 */
export function resellerManagementRedirectUrlClick(params) {
    return { evid: 316, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'copyOfNoCheckoutFlowToastShown' event (evid: 319)
 *
 * Event description: No-Checkout Flow toast shown
 *
 * @param {copyOfNoCheckoutFlowToastShownParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {string} name - toast name
 * @property {string} productTypeName - product_type_name - not sent!!
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product id
 * @property {string} type - 'error', 'warning', 'success'
 * @property {GUID} msid - msid
 * @return {LogObject<copyOfNoCheckoutFlowToastShownParams>} LogObject<copyOfNoCheckoutFlowToastShownParams>
 */
export function copyOfNoCheckoutFlowToastShown(params) {
    return { evid: 319, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'checkoutPagePmLoadingError' event (evid: 326)
 *
 * Event description: Checkout Page > PM Loading Error
 *
 * @param {checkoutPagePmLoadingErrorParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {string} paymentMethodType - the name
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} initiatorName - Initiator Name
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {number} paymentMethodSubType - paymentMethodSubType
 * @return {LogObject<checkoutPagePmLoadingErrorParams>} LogObject<checkoutPagePmLoadingErrorParams>
 */
export function checkoutPagePmLoadingError(params) {
    return { evid: 326, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeDomainConnectionStatusCta' event (evid: 327)
 *
 * Event description: click on CTA when Domain Status is shown in concierge,
 *
 * @param {conciergeDomainConnectionStatusCtaParams} params - The parameters for this event
 * @property {string} voucher - true, false
 * @property {string} uuid - uuid
 * @property {string} domainStatus - in_verification, in_propagation, other, expired_grace, expired_redemption
 * @property {boolean} isPremiumSite - true, false
 * @property {string} type - check_domain_status, view_instructions, extend, learn_how__to_get_your_domain_back
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - referal
 * @return {LogObject<conciergeDomainConnectionStatusCtaParams>} LogObject<conciergeDomainConnectionStatusCtaParams>
 */
export function conciergeDomainConnectionStatusCta(params) {
    return { evid: 327, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'planPurchaseViewSuccessPageAssignDomainCta' event (evid: 328)
 *
 * Event description: CTAs on Premium purchases > view success page
 *
 * @param {planPurchaseViewSuccessPageAssignDomainCtaParams} params - The parameters for this event
 * @property {string} voucher - true, false, null
 * @property {string} externalSessionId - session id
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} pageView - success_page_assign_domain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {string} couponId - coupon
 * @property {string} action - assign_your_domain, get_voucher, connect_domain, go_to_side_dashboard
 * @property {string} abTesting - ab test value (success_page_assign_domain)
 * @return {LogObject<planPurchaseViewSuccessPageAssignDomainCtaParams>} LogObject<planPurchaseViewSuccessPageAssignDomainCtaParams>
 */
export function planPurchaseViewSuccessPageAssignDomainCta(params) {
    return { evid: 328, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'planPurchaseViewSuccessPageAssignDomain' event (evid: 329)
 *
 * Event description: plan purchase success page - assign domain intent
 *
 * @param {planPurchaseViewSuccessPageAssignDomainParams} params - The parameters for this event
 * @property {string} abTest - success_page_assign_domain
 * @property {string} externalSessionId - session_id
 * @property {string} domain - domain (if applicable)
 * @property {number} cycleid - cycle_id
 * @property {GUID} siteid - site_id
 * @property {string} referralAdditionalInfo - referral
 * @property {number} productId - product_id
 * @property {GUID} packageId - package_id
 * @property {string} productGuid - product guid
 * @property {GUID} couponId - coupon_id
 * @return {LogObject<planPurchaseViewSuccessPageAssignDomainParams>} LogObject<planPurchaseViewSuccessPageAssignDomainParams>
 */
export function planPurchaseViewSuccessPageAssignDomain(params) {
    return { evid: 329, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aUpdatePaymentPageReady' event (evid: 3301)
 *
 * Event description: Frog -  A_UpdatePaymentPageReady
 *
 * @param {aUpdatePaymentPageReadyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aUpdatePaymentPageReadyParams>} LogObject<aUpdatePaymentPageReadyParams>
 */
export function aUpdatePaymentPageReady(params) {
    return { evid: 3301, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aUpdatePaymentSubmit' event (evid: 3302)
 *
 * Event description: Frog
 *
 * @param {aUpdatePaymentSubmitParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} cancelTextReason - cancel_text_reason
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aUpdatePaymentSubmitParams>} LogObject<aUpdatePaymentSubmitParams>
 */
export function aUpdatePaymentSubmit(params) {
    return { evid: 3302, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentSuccess' event (evid: 3303)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} services - List of updated services in case of UPM
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {GUID} billingAccountGuid - billing_account_guid
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - externalsessionid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} updateType - same_site/same_PM/all/only
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} billingAccountType - billing_account_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} initiatorName - initiator name from checkout
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} cancelTextReason - cancel_text_reason
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} invoiceId - invoice_ids of succesfull invoices
 * @return {LogObject<rUpdatePaymentSuccessParams>} LogObject<rUpdatePaymentSuccessParams>
 */
export function rUpdatePaymentSuccess(params) {
    return { evid: 3303, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentBusinessError' event (evid: 3304)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentBusinessErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rUpdatePaymentBusinessErrorParams>} LogObject<rUpdatePaymentBusinessErrorParams>
 */
export function rUpdatePaymentBusinessError(params) {
    return { evid: 3304, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentValidationError' event (evid: 3305)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentValidationErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rUpdatePaymentValidationErrorParams>} LogObject<rUpdatePaymentValidationErrorParams>
 */
export function rUpdatePaymentValidationError(params) {
    return { evid: 3305, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'rUpdatePaymentFatalError' event (evid: 3306)
 *
 * Event description: Frog
 *
 * @param {rUpdatePaymentFatalErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<rUpdatePaymentFatalErrorParams>} LogObject<rUpdatePaymentFatalErrorParams>
 */
export function rUpdatePaymentFatalError(params) {
    return { evid: 3306, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'updatePmSelectUpdateTypePopupView1st' event (evid: 3307)
 *
 * Event description: first page, when you have more than one active subscription
 *
 * @param {updatePmSelectUpdateTypePopupView1stParams} params - The parameters for this event
 * @property {string} viewMode - view_mode as of 11:28
 * @property {string} availableUpdateTypes - available options: same_site/same_PM/all/only
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} subscriptionType - subscriptionType
 * @property {GUID} msid - msid
 * @return {LogObject<updatePmSelectUpdateTypePopupView1stParams>} LogObject<updatePmSelectUpdateTypePopupView1stParams>
 */
export function updatePmSelectUpdateTypePopupView1st(params) {
    return { evid: 3307, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'updatePmSelectUpdateTypePopupClick' event (evid: 3308)
 *
 * Event description: first page, action click
 *
 * @param {updatePmSelectUpdateTypePopupClickParams} params - The parameters for this event
 * @property {string} services - Services the user chooses to update
 * @property {string} viewMode - view_mode as of 11:28
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - cancel/next/back
 * @property {string} subscriptionType - subscriptionType
 * @property {string} update_type - Update type the user choose ( from 17:3307)
 * @return {LogObject<updatePmSelectUpdateTypePopupClickParams>} LogObject<updatePmSelectUpdateTypePopupClickParams>
 */
export function updatePmSelectUpdateTypePopupClick(params) {
    return { evid: 3308, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'updatePmViewReviewSubscriptionsPopup2nd' event (evid: 3309)
 *
 * Event description: second page, review the subscriptions you about to update
 *
 * @param {updatePmViewReviewSubscriptionsPopup2ndParams} params - The parameters for this event
 * @property {string} services - Update type the user choose ( from 17:3307)
 * @property {string} viewMode - view_mode as of 11:28
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} subscriptionType - subscriptionType
 * @property {string} update_type - Update type the user choose ( from 17:3307)
 * @return {LogObject<updatePmViewReviewSubscriptionsPopup2ndParams>} LogObject<updatePmViewReviewSubscriptionsPopup2ndParams>
 */
export function updatePmViewReviewSubscriptionsPopup2nd(params) {
    return { evid: 3309, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aUpdatePaymentApplySameCard' event (evid: 3312)
 *
 * Event description: Frog
 *
 * @param {aUpdatePaymentApplySameCardParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscriptionType
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aUpdatePaymentApplySameCardParams>} LogObject<aUpdatePaymentApplySameCardParams>
 */
export function aUpdatePaymentApplySameCard(params) {
    return { evid: 3312, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'updatePmUpdateTypePopupSelectUpdateType' event (evid: 3319)
 *
 * Event description: first page, action click
 *
 * @param {updatePmUpdateTypePopupSelectUpdateTypeParams} params - The parameters for this event
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} updateType - available options: same_site/same_PM/all/only
 * @property {string} subscriptionType - subscriptionType
 * @return {LogObject<updatePmUpdateTypePopupSelectUpdateTypeParams>} LogObject<updatePmUpdateTypePopupSelectUpdateTypeParams>
 */
export function updatePmUpdateTypePopupSelectUpdateType(params) {
    return { evid: 3319, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowUpgradePageView' event (evid: 332)
 *
 * Event description: No-Checkout Flow > Upgrade page > View/click
 *
 * @param {noCheckoutFlowUpgradePageViewParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} state - 'upgrade', 'soft limit reached'
 * @property {string} clickType - activate plan, go to site dashboard, contact account manager, cancel, close ,kb, url, product:{product_name},cycle:{cycle}
 * @property {string} productTypeName - product_type_name - not sent!!
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product id
 * @property {number} limit - limit of subscriptions by the contract
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @property {boolean} isRecurring - distinguish between recurring flow (channels) and life time (Enterprise)
 * @property {number} limit_usage - number of activated subscriptions
 * @property {string} offering - offering type
 * @return {LogObject<noCheckoutFlowUpgradePageViewParams>} LogObject<noCheckoutFlowUpgradePageViewParams>
 */
export function noCheckoutFlowUpgradePageView(params) {
    return { evid: 332, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'updatePmReviewSubscriptionsPopupClick' event (evid: 3320)
 *
 * Event description: second page, review the subscriptions you about to update, click
 *
 * @param {updatePmReviewSubscriptionsPopupClickParams} params - The parameters for this event
 * @property {string} services - Update type the user choose ( from 17:3307)
 * @property {string} viewMode - view_mode as of 11:28
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - cancel /next /back
 * @property {string} subscriptionType - subscriptionType
 * @property {string} update_type - Update type the user choose ( from 17:3307)
 * @return {LogObject<updatePmReviewSubscriptionsPopupClickParams>} LogObject<updatePmReviewSubscriptionsPopupClickParams>
 */
export function updatePmReviewSubscriptionsPopupClick(params) {
    return { evid: 3320, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowSuccessPageView' event (evid: 333)
 *
 * Event description: No-Checkout Flow > Success page > View
 *
 * @param {noCheckoutFlowSuccessPageViewParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} externalSessionId - externalsessionid
 * @property {string} state - 'success', 'already premium'
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - activate plan, go to site dashboard, contact account manager, cancel, close
 * @property {string} productTypeName - product_type_name
 * @property {GUID} productInstanceId - product_instance_id
 * @property {string} cycleName - cycle name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @property {number} cycleId - cycle_id
 * @property {boolean} isRecurring - distinguish between recurring flow (channels) and life time (Enterprise)
 * @property {number} limit - limit of subscriptions by the contract
 * @property {number} limit_usage - number of activated subscriptions
 * @property {string} offering - offering type
 * @return {LogObject<noCheckoutFlowSuccessPageViewParams>} LogObject<noCheckoutFlowSuccessPageViewParams>
 */
export function noCheckoutFlowSuccessPageView(params) {
    return { evid: 333, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowSuccessModal' event (evid: 3331)
 *
 * Event description: after updating payment method in pay now, success modal appears with suggestion to update additional services on the same payment method
 *
 * @param {upmAfterPayNowSuccessModalParams} params - The parameters for this event
 * @property {string} services - other services that are relevant for UPM on the same PM
 * @property {GUID} billingAccountGuid - New credit card guid
 * @property {string} externalSessionId - Checkout SessionID
 * @property {GUID} assetId - old credit card guid
 * @property {GUID} subscriptionId - subscription_id
 * @property {number} assetIdType - Old Billing account type
 * @property {number} declinedServiceCount - Number of services on the same PM that are in decline status
 * @property {number} billingAccountType - New billingAccountType (PM)
 * @property {string} declinedServices - all the declined services that are on the same pm and relavent for pay now
 * @return {LogObject<upmAfterPayNowSuccessModalParams>} LogObject<upmAfterPayNowSuccessModalParams>
 */
export function upmAfterPayNowSuccessModal(params) {
    return { evid: 3331, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowClickOnReview' event (evid: 3332)
 *
 * Event description: Users clicks on review additional services to update
 *
 * @param {upmAfterPayNowClickOnReviewParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - 'Success modal' / 'Subscription page'
 * @property {string} externalSessionId - External Session_id from Checkout
 * @return {LogObject<upmAfterPayNowClickOnReviewParams>} LogObject<upmAfterPayNowClickOnReviewParams>
 */
export function upmAfterPayNowClickOnReview(params) {
    return { evid: 3332, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowCloseSuccessModal' event (evid: 3333)
 *
 * Event description: User closes the success modal
 *
 * @param {upmAfterPayNowCloseSuccessModalParams} params - The parameters for this event
 * @property {string} clickType - 'No thanks' / 'Close through X'
 * @property {string} externalSessionId - external_session_id from checkout
 * @return {LogObject<upmAfterPayNowCloseSuccessModalParams>} LogObject<upmAfterPayNowCloseSuccessModalParams>
 */
export function upmAfterPayNowCloseSuccessModal(params) {
    return { evid: 3333, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowAdditionalServicesModal' event (evid: 3334)
 *
 * Event description: modal with all the services that are attached to the old card that was updated
 *
 * @param {upmAfterPayNowAdditionalServicesModalParams} params - The parameters for this event
 * @property {string} services - string with all the objects in the list that are active (not declined), including the service that was paid through this session.
 * @property {GUID} billingAccountGuid - New billing account guid (PM)
 * @property {string} externalSessionId - external session id from checkout
 * @property {GUID} assetId - Old Billing account guid (PM)
 * @property {string} declinedServices - string with all the objects in the list that are in declined status
 * @return {LogObject<upmAfterPayNowAdditionalServicesModalParams>} LogObject<upmAfterPayNowAdditionalServicesModalParams>
 */
export function upmAfterPayNowAdditionalServicesModal(params) {
    return { evid: 3334, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowAdditionalServicesModalClick' event (evid: 3335)
 *
 * Event description: click on additional services modal (update or cancel)
 *
 * @param {upmAfterPayNowAdditionalServicesModalClickParams} params - The parameters for this event
 * @property {string} services - string with all the objects in the list (that are checked), including the original service that was paid through this session. excluding those in declined status
 * @property {string} externalSessionId - external_session_id from checkout
 * @property {string} clickType - 1='update' / 2='cancel' / 3='close through x'
 * @property {string} declinedServices - string with all the objects in the list that are in declined status (and are checked)
 * @return {LogObject<upmAfterPayNowAdditionalServicesModalClickParams>} LogObject<upmAfterPayNowAdditionalServicesModalClickParams>
 */
export function upmAfterPayNowAdditionalServicesModalClick(params) {
    return { evid: 3335, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'upmAfterPayNowAdditionalUpmSuccess' event (evid: 3336)
 *
 * Event description: After updating payment method in pay now, services on the same old payment method were updated successfully to the new payment method, and also paid in case of declined services.
 *
 * @param {upmAfterPayNowAdditionalUpmSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - New credit card guid
 * @property {boolean} isMobile - check if user arrived from mobile
 * @property {string} errorInfo - error message
 * @property {string} externalSessionId - Checkout Session
 * @property {GUID} assetId - old credit card guid
 * @property {string} is3ds - according to the result from shouldVerifyPaymentSource
 * @property {string} declinedServicesPaid - list of all the objects in the list that were in declined status and charged successfully
 * @property {number} assetIdType - Old billing account type
 * @property {string} declinedServicesFailed - list of all the objects in the list that were in declined status and failed to be charged
 * @property {number} numOfServicesUpdated - number of additional services that were paid or updated
 * @property {number} numOfDeclinedServicesPaid - number of additional declined services that were paid
 * @property {number} billingAccountType - New billing account Type
 * @property {string} initiatorName - initiator name
 * @property {string} servicesUpdated - List of all services that were not in a declined status and were successfully updated with the new BA (no charge attempt was needed).
 * @return {LogObject<upmAfterPayNowAdditionalUpmSuccessParams>} LogObject<upmAfterPayNowAdditionalUpmSuccessParams>
 */
export function upmAfterPayNowAdditionalUpmSuccess(params) {
    return { evid: 3336, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowDomainPurchasePremiumUpgradePopUp' event (evid: 336)
 *
 * Event description: No-Checkout Flow > Domain purchase > Premium Upgrade pop-up
 *
 * @param {noCheckoutFlowDomainPurchasePremiumUpgradePopUpParams} params - The parameters for this event
 * @property {string} viewMode - ‘accountLevel’, ‘siteLevel’
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} msid - msid
 * @property {string} action - view’, ‘upgrade’, ‘cancel’, ‘close’, ‘get domain’
 * @return {LogObject<noCheckoutFlowDomainPurchasePremiumUpgradePopUpParams>} LogObject<noCheckoutFlowDomainPurchasePremiumUpgradePopUpParams>
 */
export function noCheckoutFlowDomainPurchasePremiumUpgradePopUp(params) {
    return { evid: 336, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowDomainConnectPremiumUpgradePopUp' event (evid: 337)
 *
 * Event description: No-Checkout Flow > Domain Connect > Premium Upgrade pop-up
 *
 * @param {noCheckoutFlowDomainConnectPremiumUpgradePopUpParams} params - The parameters for this event
 * @property {string} viewMode - ‘accountLevel’, ‘siteLevel’
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} msid - msid
 * @property {string} action - ‘view’, ‘upgrade’, ‘cancel’, ‘close’
 * @return {LogObject<noCheckoutFlowDomainConnectPremiumUpgradePopUpParams>} LogObject<noCheckoutFlowDomainConnectPremiumUpgradePopUpParams>
 */
export function noCheckoutFlowDomainConnectPremiumUpgradePopUp(params) {
    return { evid: 337, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowNoPermissions' event (evid: 338)
 *
 * Event description: logged user has no permissions to upgrade message page, or there is a generic error or page not found
 *
 * @param {noCheckoutFlowNoPermissionsParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} errorInfo - error info if error page
 * @property {string} clickType - 'manage your website'
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {string} pageName - unauthorized, generic error, not found
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @return {LogObject<noCheckoutFlowNoPermissionsParams>} LogObject<noCheckoutFlowNoPermissionsParams>
 */
export function noCheckoutFlowNoPermissions(params) {
    return { evid: 338, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowReachedLimitPage' event (evid: 339)
 *
 * Event description: No-Checkout Flow > Reached limit page
 *
 * @param {noCheckoutFlowReachedLimitPageParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} clickType - 'go to site dashboard', cancel, contact account manager, close
 * @property {string} productTypeName - product_type_name - not being sent!
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} productId - product guid
 * @property {number} limit - hard limit
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @return {LogObject<noCheckoutFlowReachedLimitPageParams>} LogObject<noCheckoutFlowReachedLimitPageParams>
 */
export function noCheckoutFlowReachedLimitPage(params) {
    return { evid: 339, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainRolesAndPermissionsAccessDeniedPageView' event (evid: 340)
 *
 * Event description: It triggers if user sees access denied page
 *
 * @param {domainRolesAndPermissionsAccessDeniedPageViewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral
 * @property {string} place - place
 * @property {Url} referer - referral
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<domainRolesAndPermissionsAccessDeniedPageViewParams>} LogObject<domainRolesAndPermissionsAccessDeniedPageViewParams>
 */
export function domainRolesAndPermissionsAccessDeniedPageView(params) {
    return { evid: 340, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowErrorPageView' event (evid: 341)
 *
 * Event description: generic error page view
 *
 * @param {noCheckoutFlowErrorPageViewParams} params - The parameters for this event
 * @property {string} errorInfo - error info
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {GUID} msid - msid
 * @return {LogObject<noCheckoutFlowErrorPageViewParams>} LogObject<noCheckoutFlowErrorPageViewParams>
 */
export function noCheckoutFlowErrorPageView(params) {
    return { evid: 341, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'noCheckoutFlowNotFoundPageView' event (evid: 342)
 *
 * Event description: not found page view or click
 *
 * @param {noCheckoutFlowNotFoundPageViewParams} params - The parameters for this event
 * @property {string} viewMode - site_level, account_level
 * @property {string} clickType - click_type
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} productId - product_id
 * @property {GUID} msid - msid
 * @property {string} action - view, click
 * @return {LogObject<noCheckoutFlowNotFoundPageViewParams>} LogObject<noCheckoutFlowNotFoundPageViewParams>
 */
export function noCheckoutFlowNotFoundPageView(params) {
    return { evid: 342, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'registrarsAsResellersCannotTransferPageView' event (evid: 344)
 *
 * Event description: user viewed a page "Your domain cannot be transferred to Wix" after clicking transfer on My domains page
 *
 * @param {registrarsAsResellersCannotTransferPageViewParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {GUID} reseller - reseller guid
 * @return {LogObject<registrarsAsResellersCannotTransferPageViewParams>} LogObject<registrarsAsResellersCannotTransferPageViewParams>
 */
export function registrarsAsResellersCannotTransferPageView(params) {
    return { evid: 344, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'resellerRedirectFromDomainsPage' event (evid: 347)
 *
 * Event description: user was redirected to reseller after clicking purchase or connect on domains page/concierge
 *
 * @param {resellerRedirectFromDomainsPageParams} params - The parameters for this event
 * @property {Url} url - redirect url
 * @property {string} clickType - 'buy', 'connect'
 * @property {GUID} reseller - reseller guid
 * @return {LogObject<resellerRedirectFromDomainsPageParams>} LogObject<resellerRedirectFromDomainsPageParams>
 */
export function resellerRedirectFromDomainsPage(params) {
    return { evid: 347, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMsPurchaseStartSuccess' event (evid: 377)
 *
 * Event description: Start Purchase Load success
 *
 * @param {vMsPurchaseStartSuccessParams} params - The parameters for this event
 * @property {string} isNewPurchase - True, False
 * @property {string} domainName - Domain related to the mailbox
 * @property {string} additionalInfo - referral_additional_info
 * @return {LogObject<vMsPurchaseStartSuccessParams>} LogObject<vMsPurchaseStartSuccessParams>
 */
export function vMsPurchaseStartSuccess(params) {
    return { evid: 377, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMsnClickContinueSuccess' event (evid: 378)
 *
 * Event description: Click on Continue with no errors
 *
 * @param {vMsnClickContinueSuccessParams} params - The parameters for this event
 * @property {number} quantity - Quantity
 * @property {string} domainName - Domain related to the mailbox
 * @property {string} additionalInfo - ms_purchase_admin_details or ms_purchase_mailbox_plan
 * @return {LogObject<vMsnClickContinueSuccessParams>} LogObject<vMsnClickContinueSuccessParams>
 */
export function vMsnClickContinueSuccess(params) {
    return { evid: 378, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMsnPurchase1stStepValidationError' event (evid: 379)
 *
 * Event description: If 0 is chosen
 *
 * @param {aMsnPurchase1stStepValidationErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnPurchase1stStepValidationErrorParams>} LogObject<aMsnPurchase1stStepValidationErrorParams>
 */
export function aMsnPurchase1stStepValidationError(params) {
    return { evid: 379, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMsnPaymentDetailsLoad' event (evid: 380)
 *
 * Event description: When user see the Payment Step
 *
 * @param {vMsnPaymentDetailsLoadParams} params - The parameters for this event
 * @property {string} additionalInfo - From 2nd Step Or Direct (repurchase)
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<vMsnPaymentDetailsLoadParams>} LogObject<vMsnPaymentDetailsLoadParams>
 */
export function vMsnPaymentDetailsLoad(params) {
    return { evid: 380, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'dayfulPackagePickerViewCycleSelection2ndStep' event (evid: 3805)
 *
 * Event description: Dayful Plan PP - select product (and move to 2nd step)
 *
 * @param {dayfulPackagePickerViewCycleSelection2ndStepParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} pp_type - pp_type
 * @property {string} intent - intent
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} productid - extra_info
 * @property {string} eventAggregator - event_aggregator
 * @property {string} productTypeName - Dayful
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - 3/6
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} productTypeId - productTypeId
 * @property {string} offeringGuid - offering_guid
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {Url} referer - referral
 * @property {string} offeringType - Seasonal / Personal / Default
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - json
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<dayfulPackagePickerViewCycleSelection2ndStepParams>} LogObject<dayfulPackagePickerViewCycleSelection2ndStepParams>
 */
export function dayfulPackagePickerViewCycleSelection2ndStep(params) {
    return { evid: 3805, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMsnPurchaseAdminInfoValidationClientError' event (evid: 381)
 *
 * Event description: When Clicking Continue and there are client validation errors on form
 *
 * @param {aMsnPurchaseAdminInfoValidationClientErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnPurchaseAdminInfoValidationClientErrorParams>} LogObject<aMsnPurchaseAdminInfoValidationClientErrorParams>
 */
export function aMsnPurchaseAdminInfoValidationClientError(params) {
    return { evid: 381, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aNotVerticalClick' event (evid: 3810)
 *
 * Event description: when you get a vertical PP you can change to default by clicking "Not a store owner? Check out Wix Premium Plans for more options."
 *
 * @param {aNotVerticalClickParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aNotVerticalClickParams>} LogObject<aNotVerticalClickParams>
 */
export function aNotVerticalClick(params) {
    return { evid: 3810, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetPageLoad' event (evid: 3812)
 *
 * Event description: Refund Widget Loaded - one event per service
 *
 * @param {refundWidgetPageLoadParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial,no_services
 * @property {string} referralId - Source
 * @property {string} serviceState - pending request / no request
 * @return {LogObject<refundWidgetPageLoadParams>} LogObject<refundWidgetPageLoadParams>
 */
export function refundWidgetPageLoad(params) {
    return { evid: 3812, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetClickNextFirstStep' event (evid: 3813)
 *
 * Event description: Refund Widget View Not refundable page
 *
 * @param {refundWidgetClickNextFirstStepParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {boolean} selected - Is the service selected?
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetClickNextFirstStepParams>} LogObject<refundWidgetClickNextFirstStepParams>
 */
export function refundWidgetClickNextFirstStep(params) {
    return { evid: 3813, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetClickNextSecondStep' event (evid: 3814)
 *
 * Event description: Refund Widget Click Next Second Step
 *
 * @param {refundWidgetClickNextSecondStepParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} clickType - back / my account / request form url
 * @property {string} reason - Cancel free text
 * @property {string} productType - plan,mailbox,domain
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetClickNextSecondStepParams>} LogObject<refundWidgetClickNextSecondStepParams>
 */
export function refundWidgetClickNextSecondStep(params) {
    return { evid: 3814, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetSummaryView' event (evid: 3815)
 *
 * Event description: Refund Widget Summary View
 *
 * @param {refundWidgetSummaryViewParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetSummaryViewParams>} LogObject<refundWidgetSummaryViewParams>
 */
export function refundWidgetSummaryView(params) {
    return { evid: 3815, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetClickSubmit' event (evid: 3816)
 *
 * Event description: Refund Widget Click Submit
 *
 * @param {refundWidgetClickSubmitParams} params - The parameters for this event
 * @property {string} referralId - Source
 * @property {GUID} userGuid - user guid
 * @return {LogObject<refundWidgetClickSubmitParams>} LogObject<refundWidgetClickSubmitParams>
 */
export function refundWidgetClickSubmit(params) {
    return { evid: 3816, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetError' event (evid: 3817)
 *
 * Event description: Refund Widget error
 *
 * @param {refundWidgetErrorParams} params - The parameters for this event
 * @property {string} step - error step
 * @property {string} errorMsg - Error Message
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetErrorParams>} LogObject<refundWidgetErrorParams>
 */
export function refundWidgetError(params) {
    return { evid: 3817, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetSuccessPage' event (evid: 3818)
 *
 * Event description: Refund Widget Success page
 *
 * @param {refundWidgetSuccessPageParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs package_id
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetSuccessPageParams>} LogObject<refundWidgetSuccessPageParams>
 */
export function refundWidgetSuccessPage(params) {
    return { evid: 3818, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMsnClickOnSubmitPurchase' event (evid: 382)
 *
 * Event description: When clicking submit and no validations errors.
 *
 * @param {vMsnClickOnSubmitPurchaseParams} params - The parameters for this event
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<vMsnClickOnSubmitPurchaseParams>} LogObject<vMsnClickOnSubmitPurchaseParams>
 */
export function vMsnClickOnSubmitPurchase(params) {
    return { evid: 382, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetViewRequestForm' event (evid: 3821)
 *
 * Event description: Refund Widget  -  View request form
 *
 * @param {refundWidgetViewRequestFormParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial
 * @property {string} referralId - Source
 * @return {LogObject<refundWidgetViewRequestFormParams>} LogObject<refundWidgetViewRequestFormParams>
 */
export function refundWidgetViewRequestForm(params) {
    return { evid: 3821, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'refundWidgetEmptyStateClick' event (evid: 3822)
 *
 * Event description: Refund Widget > empty state >  click
 *
 * @param {refundWidgetEmptyStateClickParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} clickType - where is my pending request /how to get refund /where is my money/my account
 * @property {string} productType - plan,mailbox,domain
 * @property {GUID} sbsSId - Sbs Service Guid
 * @property {string} type - in_trial after_trial,no_services
 * @property {string} referralId - Source
 * @property {string} serviceState - pending request / no request
 * @return {LogObject<refundWidgetEmptyStateClickParams>} LogObject<refundWidgetEmptyStateClickParams>
 */
export function refundWidgetEmptyStateClick(params) {
    return { evid: 3822, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMsnPurchasePaymentValidationError' event (evid: 383)
 *
 * Event description: When Clicking Continue and there are validation errors
 *
 * @param {aMsnPurchasePaymentValidationErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @property {string} additionalInfo - additional info
 * @return {LogObject<aMsnPurchasePaymentValidationErrorParams>} LogObject<aMsnPurchasePaymentValidationErrorParams>
 */
export function aMsnPurchasePaymentValidationError(params) {
    return { evid: 383, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMsnPurchaseSuccess' event (evid: 384)
 *
 * Event description: When success page is loaded
 *
 * @param {vMsnPurchaseSuccessParams} params - The parameters for this event
 * @property {GUID} userPackageGuid - Package Guid
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<vMsnPurchaseSuccessParams>} LogObject<vMsnPurchaseSuccessParams>
 */
export function vMsnPurchaseSuccess(params) {
    return { evid: 384, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMsnClickActivate' event (evid: 385)
 *
 * Event description: When Clicking activate from text
 *
 * @param {aMsnClickActivateParams} params - The parameters for this event
 * @property {GUID} userPackageGuid - Package Guid
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnClickActivateParams>} LogObject<aMsnClickActivateParams>
 */
export function aMsnClickActivate(params) {
    return { evid: 385, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMsnActivateLoad' event (evid: 386)
 *
 * Event description: V_MsnActivateLoad.
 *
 * @param {vMsnActivateLoadParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMsnActivateLoadParams>} LogObject<vMsnActivateLoadParams>
 */
export function vMsnActivateLoad(params) {
    return { evid: 386, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMsnClickSubmitActivate' event (evid: 387)
 *
 * Event description: A_MsnClickSubmitActivate.
 *
 * @param {aMsnClickSubmitActivateParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMsnClickSubmitActivateParams>} LogObject<aMsnClickSubmitActivateParams>
 */
export function aMsnClickSubmitActivate(params) {
    return { evid: 387, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMsnActivateValidationError' event (evid: 388)
 *
 * Event description: A_MsnActivateValidationError.
 *
 * @param {aMsnActivateValidationErrorParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMsnActivateValidationErrorParams>} LogObject<aMsnActivateValidationErrorParams>
 */
export function aMsnActivateValidationError(params) {
    return { evid: 388, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMsnPurchaseAdminInfoValidationServerError' event (evid: 389)
 *
 * Event description: When Clicking Continue and there are server validation errors on the combination of state, postal, city
 *
 * @param {aMsnPurchaseAdminInfoValidationServerErrorParams} params - The parameters for this event
 * @property {string} errorInfo - Error with fields
 * @property {string} domainName - Domain related to the mailbox
 * @return {LogObject<aMsnPurchaseAdminInfoValidationServerErrorParams>} LogObject<aMsnPurchaseAdminInfoValidationServerErrorParams>
 */
export function aMsnPurchaseAdminInfoValidationServerError(params) {
    return { evid: 389, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerStickyHeaderInMobile' event (evid: 3903)
 *
 * Event description: Mobile PP: The user scrolled down so the title is sticky
 *
 * @param {packagePickerStickyHeaderInMobileParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - The product ID the user select when clicking the button
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<packagePickerStickyHeaderInMobileParams>} LogObject<packagePickerStickyHeaderInMobileParams>
 */
export function packagePickerStickyHeaderInMobile(params) {
    return { evid: 3903, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerSelectAPlanWithRadioButtonsMobile' event (evid: 3904)
 *
 * Event description: package picker >  select a plan with radio buttons (mobile).
 *
 * @param {packagePickerSelectAPlanWithRadioButtonsMobileParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - The product ID the user select when clicking the button
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<packagePickerSelectAPlanWithRadioButtonsMobileParams>} LogObject<packagePickerSelectAPlanWithRadioButtonsMobileParams>
 */
export function packagePickerSelectAPlanWithRadioButtonsMobile(params) {
    return { evid: 3904, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aPackagePickerEventAddInfoAction' event (evid: 3905)
 *
 * Event description: Plan PP - select product (and move to 2nd step)
 *
 * @param {aPackagePickerEventAddInfoActionParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - offering type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} clickType - click_type
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} cartFlow - cartFlow
 * @return {LogObject<aPackagePickerEventAddInfoActionParams>} LogObject<aPackagePickerEventAddInfoActionParams>
 */
export function aPackagePickerEventAddInfoAction(params) {
    return { evid: 3905, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aPackagePickerEventSelectCycle' event (evid: 3906)
 *
 * Event description: Plan PP - select cycle (and move to PurcahsePage)
 *
 * @param {aPackagePickerEventSelectCycleParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - offering type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} cartFlow - cartFlow
 * @return {LogObject<aPackagePickerEventSelectCycleParams>} LogObject<aPackagePickerEventSelectCycleParams>
 */
export function aPackagePickerEventSelectCycle(params) {
    return { evid: 3906, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'onePagePpHoverOnFeatures' event (evid: 3910)
 *
 * Event description: Client event
 * In the one page Package Picker, Hover  Hover  (more than 5 sec)
 *
 * @param {onePagePpHoverOnFeaturesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - in which step you are (select_plan,select_cycle_purchase_page)
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} featureKey - tool tip key
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<onePagePpHoverOnFeaturesParams>} LogObject<onePagePpHoverOnFeaturesParams>
 */
export function onePagePpHoverOnFeatures(params) {
    return { evid: 3910, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerClickOnQuestion' event (evid: 3917)
 *
 * Event description: The user clicks on show/ hide Frequently Asked
 * Questions.
 *
 * @param {packagePickerClickOnQuestionParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - show/ hide
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - website / business
 * @property {string} questionType - question title. e.g "How do I get my free domain?"
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerClickOnQuestionParams>} LogObject<packagePickerClickOnQuestionParams>
 */
export function packagePickerClickOnQuestion(params) {
    return { evid: 3917, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerShowFeature' event (evid: 3918)
 *
 * Event description: The user clicks on show features / hide features on the business PP tab.
 *
 * @param {packagePickerShowFeatureParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} showFeatureType - feature type
 * @property {string} clickType - show/ hide
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerShowFeatureParams>} LogObject<packagePickerShowFeatureParams>
 */
export function packagePickerShowFeature(params) {
    return { evid: 3918, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerShowAllFeatures' event (evid: 3919)
 *
 * Event description: package picker  > Show  All  features.
 *
 * @param {packagePickerShowAllFeaturesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - packagePickerType
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} clickType - show/ hide
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - website / business
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerShowAllFeaturesParams>} LogObject<packagePickerShowAllFeaturesParams>
 */
export function packagePickerShowAllFeatures(params) {
    return { evid: 3919, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerTooltipLinkClick' event (evid: 3920)
 *
 * Event description: Client event
 * In the Package Picker, click on the link provided in the feature tooltip
 *
 * @param {packagePickerTooltipLinkClickParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} fromStep - in which step you are (select_plan,select_cycle_purchase_page)
 * @property {string} packagePickerType - package_picker_type
 * @property {string} url - link
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} featureKey - tool tip key
 * @property {number} productId - productId
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<packagePickerTooltipLinkClickParams>} LogObject<packagePickerTooltipLinkClickParams>
 */
export function packagePickerTooltipLinkClick(params) {
    return { evid: 3920, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerCycleSelection2ndStepGoToCheckout' event (evid: 3921)
 *
 * Event description: Plan PP - select cycle and click to move to purchase page
 *
 * @param {packagePickerCycleSelection2ndStepGoToCheckoutParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} eventAggregator - eventAggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} cycle - cycle
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} additionalInfo - additionalInfo
 * @property {number} productId - productId
 * @property {GUID} siteGuid - siteGuid
 * @property {string} abTesting - abTesting
 * @return {LogObject<packagePickerCycleSelection2ndStepGoToCheckoutParams>} LogObject<packagePickerCycleSelection2ndStepGoToCheckoutParams>
 */
export function packagePickerCycleSelection2ndStepGoToCheckout(params) {
    return { evid: 3921, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerComparePlanFeatures' event (evid: 3922)
 *
 * Event description: The user clicks on Compare Plan Features button to see the entire grid (full plans comparison below the cards)
 *
 * @param {packagePickerComparePlanFeaturesParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} showFeatureType - feature type
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - pageview
 * @property {string} ppType - pp_type
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - pageview
 * @return {LogObject<packagePickerComparePlanFeaturesParams>} LogObject<packagePickerComparePlanFeaturesParams>
 */
export function packagePickerComparePlanFeatures(params) {
    return { evid: 3922, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domaingptOnSbumit' event (evid: 393)
 *
 * Event description: user interaction with the AI (on click)
 *
 * @param {domaingptOnSbumitParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {number} numberOfMessages - number of messages with AI so far
 * @property {GUID} uuid - user guid
 * @property {string} clickType - submit, find something better, refine based on my favorites
 * @property {string} error - error
 * @property {string} userInput - free text inserted by the user
 * @property {string} likedDomains - all domains user liked
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptOnSbumitParams>} LogObject<domaingptOnSbumitParams>
 */
export function domaingptOnSbumit(params) {
    return { evid: 393, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domaingptOnReceivedCompletion' event (evid: 394)
 *
 * Event description: result returned from AI (suggestions)
 *
 * @param {domaingptOnReceivedCompletionParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {number} numberOfMessages - number of messages with AI so far
 * @property {string} usage - token's parameter
 * @property {GUID} uuid - user guid
 * @property {string} result - array of suggested domains
 * @property {string} error - error
 * @property {string} userInput - free text inserted by the user
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptOnReceivedCompletionParams>} LogObject<domaingptOnReceivedCompletionParams>
 */
export function domaingptOnReceivedCompletion(params) {
    return { evid: 394, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domaingptActionsOnResult' event (evid: 395)
 *
 * Event description: actions done by the user on AI results - get it (=purchase), LIKE, UNLIKE
 *
 * @param {domaingptActionsOnResultParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {string} domain - domain
 * @property {GUID} uuid - user guid
 * @property {string} clickType - getIt, like, unlike, reset, selectTLD
 * @property {string} error - error
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptActionsOnResultParams>} LogObject<domaingptActionsOnResultParams>
 */
export function domaingptActionsOnResult(params) {
    return { evid: 395, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domaingptVisitExit' event (evid: 396)
 *
 * Event description: trigger when banner "go to GPT" is clicked or when "leave GPT" are clicked
 *
 * @param {domaingptVisitExitParams} params - The parameters for this event
 * @property {string} viewMode - concierge
 * @property {GUID} uuid - user guid
 * @property {string} clickType - enter , leave
 * @property {string} error - error
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptVisitExitParams>} LogObject<domaingptVisitExitParams>
 */
export function domaingptVisitExit(params) {
    return { evid: 396, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domaingptError' event (evid: 397)
 *
 * Event description: error appears
 *
 * @param {domaingptErrorParams} params - The parameters for this event
 * @property {string} viewMode - concierge
 * @property {GUID} uuid - user guid
 * @property {string} errorMsg - Error Message
 * @property {GUID} msid - msid
 * @return {LogObject<domaingptErrorParams>} LogObject<domaingptErrorParams>
 */
export function domaingptError(params) {
    return { evid: 397, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsSearchView' event (evid: 398)
 *
 * Event description: User viewed the Domain Search page
 * (in desktop accountLevel , in mobile - both accountLevel & siteLevel)
 *
 * @param {domainsSearchViewParams} params - The parameters for this event
 * @property {string} viewMode - mobile, accountLevel
 * @property {string} uuid - uuid
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {GUID} msid - site
 * @return {LogObject<domainsSearchViewParams>} LogObject<domainsSearchViewParams>
 */
export function domainsSearchView(params) {
    return { evid: 398, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteTosSectionShown' event (evid: 399)
 *
 * Event description: User was shown a TOS section in business email page
 *
 * @param {gSuiteTosSectionShownParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - /
 * @property {string} productGuid - product id
 * @property {GUID} msid - msid
 * @return {LogObject<gSuiteTosSectionShownParams>} LogObject<gSuiteTosSectionShownParams>
 */
export function gSuiteTosSectionShown(params) {
    return { evid: 399, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aClickOnCancel' event (evid: 4)
 *
 * Event description: click on "cancel plan", pop up open
 *
 * @param {aClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {GUID} siteid - site_id
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} subscriptionId - subscriptionId
 * @return {LogObject<aClickOnCancelParams>} LogObject<aClickOnCancelParams>
 */
export function aClickOnCancel(params) {
    return { evid: 4, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMail' event (evid: 400)
 *
 * Event description: G-suite > My mailboxes > Page load success.
 *
 * @param {vMailParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} VoiceCtaType - voice cta type
 * @property {boolean} IsVoiceSetUp - is_voice_set_up
 * @property {boolean} IsVoiceTos - is_voice_tos
 * @property {string} VoiceEligibility - Purchase, Entry point, etc.
 * @property {string} VoiceBanner - Pending, set up, renew, TOS, payment problem mailbox, payment problem voice
 *
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {string} nextStep - Next step type - Single Connected domain/  Multiple Connected domain /No connected domain
 * @property {number} accountTotalDomains - account_total_domains
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - empty_state/manage_state
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} voucher - True/False
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain name
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} pagetype - page_type
 * @property {string} device_type - device_type
 * @property {boolean} inSale - [yes / no]
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} isConnectedDomain - true, false
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} emailProvider - email_provider
 * @property {number} '36' - email_sku_id
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain name
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} pageView - site_level/account_level
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - current version of the page
 * @property {boolean} isPremium - is_premium
 * @property {string} pageName - current version of the page
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {number} '29' - initiator
 * @property {string} discount - discount
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} VoiceBannerType - connect_domain / buy_mailbox
 * @property {string} GwsStatus - gws_status
 * @property {string} BannerType - The type of banner when it appears
 *
 * @property {string} Recommended - What addons are offered
 * @property {string} ActiveVoices - Numbers of active google voice subscriptions
 * @property {string} ActiveGeminis - Number of active Gemini subscriptions
 *
 * @property {string} TotalMailboxAccounts - Total Business Email subscriptions user have (as shown on the page)
 *
 * @property {string} isAddonPopup - Did the user see any popup in the add-ons section.
 * @return {LogObject<vMailParams>} LogObject<vMailParams>
 */
export function vMail(params) {
    return { evid: 400, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainTestEvidForFed' event (evid: 4009)
 *
 * Event description: domain which holds many actions such as view, hover, clicks. for test purposes
 *
 * @param {domainTestEvidForFedParams} params - The parameters for this event
 * @property {number} responseSpeed - response_speed
 * @property {number} numOfSuggestions - number of suggestions appeared
 * @property {string} viewMode - concierge , purchase
 * @property {string} voucher - true | false
 * @property {string} conciergeStatus - search results error (only from concierge)
 * @property {number} numOfLabels - number of labeled suggestions appeared
 * @property {string} domain - domain
 * @property {string} searchTerm - searched domain
 * @property {string} result - array of suggested domains/available/error message
 * @property {string} connectionStatus - domain connection status
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} requestId - request
 * @property {string} suggestionsList - complex results
 * @property {string} type - suggestions/available/error/pending_transfer_completion
 * @property {GUID} msid - msid
 * @return {LogObject<domainTestEvidForFedParams>} LogObject<domainTestEvidForFedParams>
 */
export function domainTestEvidForFed(params) {
    return { evid: 4009, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vPayments' event (evid: 401)
 *
 * Event description: View_popup_after_cancellation
 *
 * @param {vPaymentsParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} popupType - popup_type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vPaymentsParams>} LogObject<vPaymentsParams>
 */
export function vPayments(params) {
    return { evid: 401, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMailClickOnCancel' event (evid: 402)
 *
 * Event description: A_Mail_ClickOnCancel
 *
 * @param {aMailClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} clickType - click_type
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} popupType - popup_type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailClickOnCancelParams>} LogObject<aMailClickOnCancelParams>
 */
export function aMailClickOnCancel(params) {
    return { evid: 402, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteEmptyStateError' event (evid: 4040)
 *
 * Event description: G-suite > empty state error
 *
 * @param {gSuiteEmptyStateErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error_info
 * @property {string} viewMode - view_mode
 * @property {string} domainName - domain_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {GUID} siteGuid - msid
 * @return {LogObject<gSuiteEmptyStateErrorParams>} LogObject<gSuiteEmptyStateErrorParams>
 */
export function gSuiteEmptyStateError(params) {
    return { evid: 4040, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myMailboxesClickOnAction' event (evid: 4100)
 *
 * Event description: My Mailboxes - click on the action connect a domain /  get a Mailbox
 *
 * @param {myMailboxesClickOnActionParams} params - The parameters for this event
 * @property {number} accountTotalDomains - No of domains in the account
 * @property {string} viewMode - empty_state / manage_state
 * @property {string} voucher - true/false
 * @property {boolean} hasLiveMailbox - live mailbox in another site
 * @property {number} siteTotalDomains - No of domains in the site
 * @property {string} clickType - connect a domain /  get a Mailbox
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - 1 OR 2
 * @property {number} siteConnectedDomains - No of domains connected to the site
 * @property {string} referralAdditionalInfo - make sure it's account or site
 * @property {boolean} isAccountPremium - free_account/premium_account
 * @property {boolean} isPremium - free_site/premium_site
 * @property {number} accountConnectedDomains - No of domains connected to the account
 * @property {string} discount - discount
 * @property {GUID} siteGuid - msid
 * @return {LogObject<myMailboxesClickOnActionParams>} LogObject<myMailboxesClickOnActionParams>
 */
export function myMailboxesClickOnAction(params) {
    return { evid: 4100, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myMailboxesBlockPage' event (evid: 4101)
 *
 * Event description: My Mailboxes > Block Page
 *
 * @param {myMailboxesBlockPageParams} params - The parameters for this event
 * @property {number} accountTotalDomains - /
 * @property {string} viewMode - /
 * @property {string} voucher - /
 * @property {string} errorInfo - restricted geo
 * @property {boolean} hasLiveMailbox - /
 * @property {number} siteTotalDomains - /
 * @property {string} domain - domain
 * @property {boolean} inSale - true, false
 * @property {string} emailProvider - /
 * @property {number} siteConnectedDomains - /
 * @property {number} '27' - /
 * @property {boolean} emailProvided - /
 * @property {string} referralAdditionalInfo - mydomains__domaininfotab
 * @property {boolean} isAccountPremium - true, false
 * @property {number} accountConnectedDomains - /
 * @property {number} discount - /
 * @property {GUID} siteGuid - /
 * @return {LogObject<myMailboxesBlockPageParams>} LogObject<myMailboxesBlockPageParams>
 */
export function myMailboxesBlockPage(params) {
    return { evid: 4101, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myMailboxesBlockPageClickLearnMore' event (evid: 4102)
 *
 * Event description: My Mailboxes > Block Page > click learn more
 *
 * @param {myMailboxesBlockPageClickLearnMoreParams} params - The parameters for this event
 * @property {number} accountTotalDomains - /
 * @property {string} viewMode - /
 * @property {string} voucher - /
 * @property {boolean} hasLiveMailbox - /
 * @property {number} siteTotalDomains - /
 * @property {string} domain - domain
 * @property {boolean} inSale - in sale
 * @property {number} siteConnectedDomains - /
 * @property {number} emailprovider - /
 * @property {boolean} discounts - /
 * @property {boolean} isAccountPremium - is account premium
 * @property {number} accountConnectedDomains - /
 * @property {string} errorinfo - /
 * @property {number} discount - /
 * @property {GUID} siteGuid - /
 * @property {string} referraladditionalinfo - /
 * @return {LogObject<myMailboxesBlockPageClickLearnMoreParams>} LogObject<myMailboxesBlockPageClickLearnMoreParams>
 */
export function myMailboxesBlockPageClickLearnMore(params) {
    return { evid: 4102, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseRestrictedDomain' event (evid: 4103)
 *
 * Event description: My Mailboxes > Block Page
 *
 * @param {gSuitePurchaseRestrictedDomainParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - /
 * @property {string} errorInfo - /
 * @property {number} emailSkuId - /
 * @property {string} flowType - flow_type
 * @property {string} errorInfoShown - domain tld restricted, domain subdomain restricted, domain char restricted
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - /
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} emailskuid - /
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - mydomains__domaininfotab
 * @property {Url} referer - referral
 * @property {boolean} domainSubdomainRestricted - false, true
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {boolean} domainCharRestricted - false, true
 * @property {number} cycleId - /
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {boolean} domainTldRestricted - false, true
 * @return {LogObject<gSuitePurchaseRestrictedDomainParams>} LogObject<gSuitePurchaseRestrictedDomainParams>
 */
export function gSuitePurchaseRestrictedDomain(params) {
    return { evid: 4103, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseRestrictedDomainClickBuyADomain' event (evid: 4104)
 *
 * Event description: Block Page >  buy a domain / go to domains. There are two events in restricted domains page. one is click buy a domain, and another one click go to domains. We can differentiatewith error_info field.
 *
 * @param {gSuitePurchaseRestrictedDomainClickBuyADomainParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - /
 * @property {string} errorInfo - BRAND, TLD , SUBDOMAIN
 * @property {number} emailSkuId - /
 * @property {string} flowType - Flow type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - /
 * @property {string} newPurchase - is_new_purchase
 * @property {number} cycleid - /
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} emailskuid - /
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - /
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchaseRestrictedDomainClickBuyADomainParams>} LogObject<gSuitePurchaseRestrictedDomainClickBuyADomainParams>
 */
export function gSuitePurchaseRestrictedDomainClickBuyADomain(params) {
    return { evid: 4104, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuitePurchaseSubmitBlockMessageView' event (evid: 4107)
 *
 * Event description: G-suite purchase > submit block message view.
 *
 * @param {gSuitePurchaseSubmitBlockMessageViewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - voucher
 * @property {string} errorInfo - error_info
 * @property {string} flowType - flow_type
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<gSuitePurchaseSubmitBlockMessageViewParams>} LogObject<gSuitePurchaseSubmitBlockMessageViewParams>
 */
export function gSuitePurchaseSubmitBlockMessageView(params) {
    return { evid: 4107, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myMailboxesPendingStateView' event (evid: 4108)
 *
 * Event description: My mailboxes - pending state view
 *
 * @param {myMailboxesPendingStateViewParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} actionName - setup_mailbox
 * @property {string} referraladditionalinfo - referral_additional_info
 * @return {LogObject<myMailboxesPendingStateViewParams>} LogObject<myMailboxesPendingStateViewParams>
 */
export function myMailboxesPendingStateView(params) {
    return { evid: 4108, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myMailboxesPendingStateResolvedView' event (evid: 4109)
 *
 * Event description: My mailboxes - pending state resolved  view
 *
 * @param {myMailboxesPendingStateResolvedViewParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} actionName - setup_mailbox
 * @property {string} referraladditionalinfo - referral_additional_info
 * @return {LogObject<myMailboxesPendingStateResolvedViewParams>} LogObject<myMailboxesPendingStateResolvedViewParams>
 */
export function myMailboxesPendingStateResolvedView(params) {
    return { evid: 4109, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteSelectADomainPageLoadSuccess' event (evid: 4112)
 *
 * Event description: G-suite > select a domain > Page load success
 *
 * @param {gSuiteSelectADomainPageLoadSuccessParams} params - The parameters for this event
 * @property {number} accountTotalDomains - account_total_domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - voucher
 * @property {boolean} hasLiveMailbox - has_live_mailbox
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site_total_domains
 * @property {string} domain - domain name
 * @property {number} expiredMailboxAccounts - expired_mailbox_accounts
 * @property {number} domainsAvailableForPurchase - domains_available_for_purchase
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - in_sale
 * @property {number} emailProvider - email_provider
 * @property {number} siteConnectedDomains - site_connected_domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} activeMailboxAccounts - number of active mailbox accounts
 * @property {boolean} isPremium - is_premium
 * @property {string} pageName - current version of the page
 * @property {number} accountConnectedDomains - account_connected_domains
 * @property {GUID} siteGuid - site_id
 * @return {LogObject<gSuiteSelectADomainPageLoadSuccessParams>} LogObject<gSuiteSelectADomainPageLoadSuccessParams>
 */
export function gSuiteSelectADomainPageLoadSuccess(params) {
    return { evid: 4112, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteSelectADomainClickOnAction' event (evid: 4113)
 *
 * Event description: G-suite > select a domain > click on action
 *
 * @param {gSuiteSelectADomainClickOnActionParams} params - The parameters for this event
 * @property {number} accountTotalDomains - account total domains
 * @property {string} viewMode - empty_state/manage_state
 * @property {string} voucher - True/False
 * @property {boolean} hasLiveMailbox - has live mailbox
 * @property {number} domainsNotAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {number} siteTotalDomains - site total domains
 * @property {string} domain - domain
 * @property {number} expiredMailboxAccounts - number of expired mailbox accounts
 * @property {number} domainsAvailableForPurchase - number of the domains in the account that are available for mailbox purchase
 * @property {string} clickType - Search bar => search Available Domain=> available _domain Desabled  Domain=> desabled_domain Restricted  Domain=> restricted _domain Select=> select  Cancel/X  =>  cancel
 * @property {string} pagetype - page_type
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - email provider
 * @property {number} siteConnectedDomains - site connected domains
 * @property {string} pageView - site_level/account_level
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - is account premium
 * @property {number} activeMailboxAccounts - active_mailbox_accounts
 * @property {boolean} isPremium - is premium
 * @property {string} pageName - current version of the page
 * @property {number} accountConnectedDomains - account connected domains
 * @property {string} discount - discount
 * @property {GUID} siteGuid - site id
 * @return {LogObject<gSuiteSelectADomainClickOnActionParams>} LogObject<gSuiteSelectADomainClickOnActionParams>
 */
export function gSuiteSelectADomainClickOnAction(params) {
    return { evid: 4113, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'alertWasTriggeredBySbs' event (evid: 4601)
 *
 * Event description: help us when we have a complex expuser event
 *
 * @param {alertWasTriggeredBySbsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} packagePickerType - package_picker_type
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} experimentValue - True/False
 * @property {GUID} userGuid - uuid
 * @property {number} paymentCycle - cycle_id
 * @property {string} newPurchase - is_new_purchase
 * @property {string} user_agent - user_agent
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} additionalData - what triggered the alert
 * @property {string} pagename - ab_test
 * @property {string} alertType - Alert name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - product_id
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<alertWasTriggeredBySbsParams>} LogObject<alertWasTriggeredBySbsParams>
 */
export function alertWasTriggeredBySbs(params) {
    return { evid: 4601, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'cancelFlowPriceGetCoupon' event (evid: 472)
 *
 * Event description: .
 *
 * @param {cancelFlowPriceGetCouponParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - packageGuid
 * @property {GUID} packageGuid - packageGuid
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - packageGuid
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<cancelFlowPriceGetCouponParams>} LogObject<cancelFlowPriceGetCouponParams>
 */
export function cancelFlowPriceGetCoupon(params) {
    return { evid: 472, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMailClickOnReduce' event (evid: 473)
 *
 * Event description: A_MailClickOnReduce.
 *
 * @param {aMailClickOnReduceParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {number} quantity - Total number of users
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} emailSkuId - email_sku_id
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {number} numInactiveUsers - Number of current inactive users
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} cycleName - cycle
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailClickOnReduceParams>} LogObject<aMailClickOnReduceParams>
 */
export function aMailClickOnReduce(params) {
    return { evid: 473, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aMailClickOnConfirmReduce' event (evid: 474)
 *
 * Event description: A_MailClickOnConfirmReduce.
 *
 * @param {aMailClickOnConfirmReduceParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referraladditionalinfo
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aMailClickOnConfirmReduceParams>} LogObject<aMailClickOnConfirmReduceParams>
 */
export function aMailClickOnConfirmReduce(params) {
    return { evid: 474, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'vMailReduceSuccess' event (evid: 475)
 *
 * Event description: V_MailReduceSuccess.
 *
 * @param {vMailReduceSuccessParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - packageId
 * @property {GUID} packageId - packageId
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {number} quantity - New number of seats
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} userGuid - uuid
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - packageId
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {string} referraladditionalinfo - referral_additional_info
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<vMailReduceSuccessParams>} LogObject<vMailReduceSuccessParams>
 */
export function vMailReduceSuccess(params) {
    return { evid: 475, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabViewBillingHistoryTab' event (evid: 4770)
 *
 * Event description: The user view the Billing History tab
 *
 * @param {billingHistoryTabViewBillingHistoryTabParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} userGuid - user guid
 * @property {string} pageView - empty_state/populated_state
 * @property {number} countInvoices - number of invoices
 * @return {LogObject<billingHistoryTabViewBillingHistoryTabParams>} LogObject<billingHistoryTabViewBillingHistoryTabParams>
 */
export function billingHistoryTabViewBillingHistoryTab(params) {
    return { evid: 4770, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabViewSingleInvoice' event (evid: 4771)
 *
 * Event description: The user opened an invoice
 *
 * @param {billingHistoryTabViewSingleInvoiceParams} params - The parameters for this event
 * @property {string} searchTerm - The term when clicking on the invoice. can be null.
 * @property {string} selectionType - 'view_link' / 'invoice_row'/ 'edit invoice toast'
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {GUID} sessionId - session_id
 * @return {LogObject<billingHistoryTabViewSingleInvoiceParams>} LogObject<billingHistoryTabViewSingleInvoiceParams>
 */
export function billingHistoryTabViewSingleInvoice(params) {
    return { evid: 4771, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabFilterSelection' event (evid: 4772)
 *
 * Event description: user changed the filters
 *
 * @param {billingHistoryTabFilterSelectionParams} params - The parameters for this event
 * @property {string} filterValue - 'month' / 'all' / 'paid'
 * @property {string} filterType - 'time ' /  'status' / 'site'  / 'Payment Method'
 * @property {string} selectionType - 'add' / 'remove'
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabFilterSelectionParams>} LogObject<billingHistoryTabFilterSelectionParams>
 */
export function billingHistoryTabFilterSelection(params) {
    return { evid: 4772, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabAdvancedFilterLink' event (evid: 4773)
 *
 * Event description: open or closed the Advanced filter link
 *
 * @param {billingHistoryTabAdvancedFilterLinkParams} params - The parameters for this event
 * @property {string} selectionType - 'open' / 'close'
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabAdvancedFilterLinkParams>} LogObject<billingHistoryTabAdvancedFilterLinkParams>
 */
export function billingHistoryTabAdvancedFilterLink(params) {
    return { evid: 4773, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabSearchTermWhenNoResult' event (evid: 4774)
 *
 * Event description: The user opened an invoice
 *
 * @param {billingHistoryTabSearchTermWhenNoResultParams} params - The parameters for this event
 * @property {string} searchTerm - The term when no results
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabSearchTermWhenNoResultParams>} LogObject<billingHistoryTabSearchTermWhenNoResultParams>
 */
export function billingHistoryTabSearchTermWhenNoResult(params) {
    return { evid: 4774, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabClickAboutThisCharge' event (evid: 4775)
 *
 * Event description: The user clicked on - "About This Charge"
 *
 * @param {billingHistoryTabClickAboutThisChargeParams} params - The parameters for this event
 * @property {string} invoiceId - invoice number
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabClickAboutThisChargeParams>} LogObject<billingHistoryTabClickAboutThisChargeParams>
 */
export function billingHistoryTabClickAboutThisCharge(params) {
    return { evid: 4775, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabViewAboutThisChargePopup' event (evid: 4776)
 *
 * Event description: view About This Charge Popup
 *
 * @param {billingHistoryTabViewAboutThisChargePopupParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {string} popupType - 'invoice' / 'select service'
 * @return {LogObject<billingHistoryTabViewAboutThisChargePopupParams>} LogObject<billingHistoryTabViewAboutThisChargePopupParams>
 */
export function billingHistoryTabViewAboutThisChargePopup(params) {
    return { evid: 4776, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabAboutThisChargePopupAction' event (evid: 4777)
 *
 * Event description: choose action in "About This Charge" Popup
 *
 * @param {billingHistoryTabAboutThisChargePopupActionParams} params - The parameters for this event
 * @property {string} selectionType - 'close' / 'got_it / 'select service XXX'
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {string} popupType - 'invoice' / 'select service'
 * @return {LogObject<billingHistoryTabAboutThisChargePopupActionParams>} LogObject<billingHistoryTabAboutThisChargePopupActionParams>
 */
export function billingHistoryTabAboutThisChargePopupAction(params) {
    return { evid: 4777, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabClickOnNfEInvoice' event (evid: 4778)
 *
 * Event description: BillingHistoryTab > click on NF-e Invoice
 *
 * @param {billingHistoryTabClickOnNfEInvoiceParams} params - The parameters for this event
 * @property {string} invoiceId - invoice number
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabClickOnNfEInvoiceParams>} LogObject<billingHistoryTabClickOnNfEInvoiceParams>
 */
export function billingHistoryTabClickOnNfEInvoice(params) {
    return { evid: 4778, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDownloadCsv' event (evid: 4779)
 *
 * Event description: The user clicked on download CSV
 *
 * @param {billingHistoryTabDownloadCsvParams} params - The parameters for this event
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabDownloadCsvParams>} LogObject<billingHistoryTabDownloadCsvParams>
 */
export function billingHistoryTabDownloadCsv(params) {
    return { evid: 4779, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'clickOnEditInvoiceDetails' event (evid: 4780)
 *
 * Event description: click on edit invoice details
 *
 * @param {clickOnEditInvoiceDetailsParams} params - The parameters for this event
 * @property {string} viewMode - Billing History Page, My Subscriptions Page, Site level - Subscription Page
 * @property {string} billingCountry - billing_country
 * @property {GUID} serviceGuid - service_guid
 * @property {string} domain - domain
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} invoiceId - invoice_id
 * @property {number} numberOfSubscriptions - number_of_subscriptions
 * @property {GUID} sessionId - session_id
 * @property {string} productName - product_name
 * @property {GUID} productId - product_guid
 * @property {string} subscriptionType - Premium Plan/ Ascend ...
 * @property {number} cycleId - cycle_id
 * @return {LogObject<clickOnEditInvoiceDetailsParams>} LogObject<clickOnEditInvoiceDetailsParams>
 */
export function clickOnEditInvoiceDetails(params) {
    return { evid: 4780, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDropdownClick' event (evid: 4781)
 *
 * Event description: The user clicked on the Dropdown menu
 *
 * @param {billingHistoryTabDropdownClickParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {string} domain - domain
 * @property {string} searchTerm - The term when clicking on the invoice. can be null.
 * @property {string} selectionType - 'view_link' / 'invoice_row'/ 'edit invoice toast'
 * @property {GUID} userGuid - user guid
 * @property {string} invoiceId - invoice number
 * @property {string} productName - productname
 * @property {string} subscriptionType - subscriptiontype
 * @property {string} type - click_type
 * @return {LogObject<billingHistoryTabDropdownClickParams>} LogObject<billingHistoryTabDropdownClickParams>
 */
export function billingHistoryTabDropdownClick(params) {
    return { evid: 4781, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabUnknownChargeView' event (evid: 4782)
 *
 * Event description: The user clicked 'Read more' on 'Can't find the charge you're looking for'
 *
 * @param {billingHistoryTabUnknownChargeViewParams} params - The parameters for this event
 * @property {string} pageView - empty_state/populated_state
 * @property {GUID} userGuid - user guid
 * @return {LogObject<billingHistoryTabUnknownChargeViewParams>} LogObject<billingHistoryTabUnknownChargeViewParams>
 */
export function billingHistoryTabUnknownChargeView(params) {
    return { evid: 4782, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'unknownChargeModalClickLogInToADifferentAccount' event (evid: 4783)
 *
 * Event description: The user clicked 'Log in to a different account' in the unknown charge modal
 *
 * @param {unknownChargeModalClickLogInToADifferentAccountParams} params - The parameters for this event
 * @property {string} pageView - empty_state/populated_state
 * @property {GUID} userGuid - user guid
 * @return {LogObject<unknownChargeModalClickLogInToADifferentAccountParams>} LogObject<unknownChargeModalClickLogInToADifferentAccountParams>
 */
export function unknownChargeModalClickLogInToADifferentAccount(params) {
    return { evid: 4783, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'unknownChargeModalClickUseEmailLocator' event (evid: 4784)
 *
 * Event description: The user clicked the footer (If you don’t remember your account details, you can try to find your login email using our email locator) in the unknown charge modal
 *
 * @param {unknownChargeModalClickUseEmailLocatorParams} params - The parameters for this event
 * @property {string} pageView - empty_state/populated_state
 * @property {GUID} userGuid - user guid
 * @return {LogObject<unknownChargeModalClickUseEmailLocatorParams>} LogObject<unknownChargeModalClickUseEmailLocatorParams>
 */
export function unknownChargeModalClickUseEmailLocator(params) {
    return { evid: 4784, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorLoad' event (evid: 4785)
 *
 * Event description: a user/anonymous views the charge locator
 *
 * @param {chargeLocatorLoadParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<chargeLocatorLoadParams>} LogObject<chargeLocatorLoadParams>
 */
export function chargeLocatorLoad(params) {
    return { evid: 4785, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorClickSearch' event (evid: 4786)
 *
 * Event description: a user/anonymous clicks search to find a charge in the charge locator
 *
 * @param {chargeLocatorClickSearchParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorClickSearchParams>} LogObject<chargeLocatorClickSearchParams>
 */
export function chargeLocatorClickSearch(params) {
    return { evid: 4786, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorFaqClick' event (evid: 4787)
 *
 * Event description: a user/anonymous opened one of the FAQs in the charge locator
 *
 * @param {chargeLocatorFaqClickParams} params - The parameters for this event
 * @property {string} content - the question string
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorFaqClickParams>} LogObject<chargeLocatorFaqClickParams>
 */
export function chargeLocatorFaqClick(params) {
    return { evid: 4787, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeDetailsView' event (evid: 4788)
 *
 * Event description: a user/anonymous views charge details
 *
 * @param {chargeLocatorChargeDetailsViewParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {number} paymentMethod - payment method
 * @property {GUID} subscriptionId - subscription id
 * @property {string} productTypeName - Premium Plan/Domain/Mailbox
 * @property {string} amount - transaction amount
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {DateTime} transactionDate - transaction date
 * @property {number} cycleId - cycle id
 * @return {LogObject<chargeLocatorChargeDetailsViewParams>} LogObject<chargeLocatorChargeDetailsViewParams>
 */
export function chargeLocatorChargeDetailsView(params) {
    return { evid: 4788, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeNotFoundView' event (evid: 4789)
 *
 * Event description: a user/anonymous sees a disclaimer that the requested charge was not found
 *
 * @param {chargeLocatorChargeNotFoundViewParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorChargeNotFoundViewParams>} LogObject<chargeLocatorChargeNotFoundViewParams>
 */
export function chargeLocatorChargeNotFoundView(params) {
    return { evid: 4789, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeNotFoundClickContactCustomerCare' event (evid: 4790)
 *
 * Event description: a user/anonymous clicked contact customer care after he saw that the requested charge was not found
 *
 * @param {chargeLocatorChargeNotFoundClickContactCustomerCareParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorChargeNotFoundClickContactCustomerCareParams>} LogObject<chargeLocatorChargeNotFoundClickContactCustomerCareParams>
 */
export function chargeLocatorChargeNotFoundClickContactCustomerCare(params) {
    return { evid: 4790, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorChargeDetailsClickSearchAgain' event (evid: 4791)
 *
 * Event description: a user/anonymous clicks search again after he viewed a result of a previous search
 *
 * @param {chargeLocatorChargeDetailsClickSearchAgainParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorChargeDetailsClickSearchAgainParams>} LogObject<chargeLocatorChargeDetailsClickSearchAgainParams>
 */
export function chargeLocatorChargeDetailsClickSearchAgain(params) {
    return { evid: 4791, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorConsolidatedInvoiceView' event (evid: 4792)
 *
 * Event description: a user/anonymous views a result of a consolidated invoice
 *
 * @param {chargeLocatorConsolidatedInvoiceViewParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @return {LogObject<chargeLocatorConsolidatedInvoiceViewParams>} LogObject<chargeLocatorConsolidatedInvoiceViewParams>
 */
export function chargeLocatorConsolidatedInvoiceView(params) {
    return { evid: 4792, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorError' event (evid: 4793)
 *
 * Event description: charge locator error toast
 *
 * @param {chargeLocatorErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error message translation key
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @return {LogObject<chargeLocatorErrorParams>} LogObject<chargeLocatorErrorParams>
 */
export function chargeLocatorError(params) {
    return { evid: 4793, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorBlockPageError' event (evid: 4794)
 *
 * Event description: Charge locator block page error (when we recognized an action which is not legit)
 *
 * @param {chargeLocatorBlockPageErrorParams} params - The parameters for this event
 * @property {string} invoiceNumber - invoice number
 * @return {LogObject<chargeLocatorBlockPageErrorParams>} LogObject<chargeLocatorBlockPageErrorParams>
 */
export function chargeLocatorBlockPageError(params) {
    return { evid: 4794, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorFaqClickContactCustomerCare' event (evid: 4795)
 *
 * Event description: a user/anonymous clicks contact customer care from one of the FAQs
 *
 * @param {chargeLocatorFaqClickContactCustomerCareParams} params - The parameters for this event
 * @return {LogObject<chargeLocatorFaqClickContactCustomerCareParams>} LogObject<chargeLocatorFaqClickContactCustomerCareParams>
 */
export function chargeLocatorFaqClickContactCustomerCare(params) {
    return { evid: 4795, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'chargeLocatorFaqCancelSubscription' event (evid: 4796)
 *
 * Event description: link to premium subscriptions page from the FAQ of the charge locator
 *
 * @param {chargeLocatorFaqCancelSubscriptionParams} params - The parameters for this event
 * @return {LogObject<chargeLocatorFaqCancelSubscriptionParams>} LogObject<chargeLocatorFaqCancelSubscriptionParams>
 */
export function chargeLocatorFaqCancelSubscription(params) {
    return { evid: 4796, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabHoverOnDownloadCsvPdf' event (evid: 4797)
 *
 * Event description: Hover on download csv/pdf
 *
 * @param {billingHistoryTabHoverOnDownloadCsvPdfParams} params - The parameters for this event
 * @property {string} externalSessionId - externalSessionId
 * @property {GUID} userGuid - user guid
 * @property {string} buttonName - export csv/download pdf
 * @property {boolean} isEnabled - is download Enabled
 * @property {number} countInvoices - count_invoices
 * @return {LogObject<billingHistoryTabHoverOnDownloadCsvPdfParams>} LogObject<billingHistoryTabHoverOnDownloadCsvPdfParams>
 */
export function billingHistoryTabHoverOnDownloadCsvPdf(params) {
    return { evid: 4797, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDownloadPdf' event (evid: 4798)
 *
 * Event description: BillingHistoryTab > download invoices Modal view (CSV/PDF)
 *
 * @param {billingHistoryTabDownloadPdfParams} params - The parameters for this event
 * @property {string} name - domain_name_filter
 * @property {string} modalType - csv/pdf
 * @property {string} externalSessionId - externalSessionId
 * @property {string} paymentMethod - payment_method_type_filter
 * @property {number} year - year_filter
 * @property {string} freeText - free_text_filter
 * @property {string} siteName - site_name_filter
 * @property {number} daysAgo - days_ago_filter
 * @property {string} status - status_filter
 * @property {number} countInvoices - number of invoices
 * @property {string} jsonData - jsonData
 * @property {string} metaSiteId - msid_filter
 * @return {LogObject<billingHistoryTabDownloadPdfParams>} LogObject<billingHistoryTabDownloadPdfParams>
 */
export function billingHistoryTabDownloadPdf(params) {
    return { evid: 4798, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabDownloadPdfModalResult' event (evid: 4799)
 *
 * Event description: BillingHistoryTab > download CSV/PDF Modal result
 * click on send download link\ Closed window\ Cancel (2 different modals, filtered by modal type
 *
 * @param {billingHistoryTabDownloadPdfModalResultParams} params - The parameters for this event
 * @property {string} name - domain_name_filter
 * @property {string} modalType - csv/pdf
 * @property {string} externalSessionId - externalSessionId
 * @property {string} filterType - date,paid,site,no filter etc
 * @property {string} paymentMethod - payment_method_type_filter
 * @property {number} year - year_filter
 * @property {string} clickType - closed window/ cancel/ download
 * @property {string} freeText - free_text_filter
 * @property {string} siteName - site_name_filter
 * @property {number} daysAgo - days_ago_filter
 * @property {string} status - status_filter
 * @property {number} countInvoices - number of invoices
 * @property {string} jsonData - json_data
 * @property {string} metaSiteId - msid_filter
 * @return {LogObject<billingHistoryTabDownloadPdfModalResultParams>} LogObject<billingHistoryTabDownloadPdfModalResultParams>
 */
export function billingHistoryTabDownloadPdfModalResult(params) {
    return { evid: 4799, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteHoverOnMailboxVoucher' event (evid: 4811)
 *
 * Event description: User hovers on the present icon on mailboxes tab
 *
 * @param {gSuiteHoverOnMailboxVoucherParams} params - The parameters for this event
 * @property {number} accountTotalDomains - number of account total domains
 * @property {string} viewMode - manage_state/empty_state
 * @property {string} voucher - true
 * @property {boolean} hasLiveMailbox - true/false
 * @property {number} siteTotalDomains - number of site total domains
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - number
 * @property {number} siteConnectedDomains - number of site connected domains
 * @property {string} referralAdditionalInfo - account-manager
 * @property {boolean} isAccountPremium - true/false
 * @property {boolean} isPremium - true/false
 * @property {number} accountConnectedDomains - number
 * @property {string} discount - value
 * @property {GUID} siteGuid - guid
 * @return {LogObject<gSuiteHoverOnMailboxVoucherParams>} LogObject<gSuiteHoverOnMailboxVoucherParams>
 */
export function gSuiteHoverOnMailboxVoucher(params) {
    return { evid: 4811, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteClickOnClaimVoucher' event (evid: 4812)
 *
 * Event description: User clicks on claim G-suite voucher from the pop-up
 *
 * @param {gSuiteClickOnClaimVoucherParams} params - The parameters for this event
 * @property {number} accountTotalDomains - number of account total domains
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} voucher - true/false
 * @property {boolean} hasLiveMailbox - true/false
 * @property {number} siteTotalDomains - number of site total domains
 * @property {boolean} inSale - [yes / no]
 * @property {number} emailProvider - number
 * @property {number} siteConnectedDomains - number of site connected domains
 * @property {string} referralAdditionalInfo - account-manager
 * @property {boolean} isAccountPremium - true/false
 * @property {boolean} isPremium - true/false
 * @property {number} accountConnectedDomains - number
 * @property {string} discount - value
 * @property {GUID} siteGuid - guid
 * @return {LogObject<gSuiteClickOnClaimVoucherParams>} LogObject<gSuiteClickOnClaimVoucherParams>
 */
export function gSuiteClickOnClaimVoucher(params) {
    return { evid: 4812, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickAssignToADifferentSitePopup' event (evid: 4815)
 *
 * Event description: Click assign/back/cancel/x/Learn more in the assign plan to a different site popup
 *
 * @param {mySubscriptionsClickAssignToADifferentSitePopupParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} clickType - assign/back/cancel/close/learnMore
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - fromMsid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickAssignToADifferentSitePopupParams>} LogObject<mySubscriptionsClickAssignToADifferentSitePopupParams>
 */
export function mySubscriptionsClickAssignToADifferentSitePopup(params) {
    return { evid: 4815, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsAssignToAnEditorXSitePopupView' event (evid: 4816)
 *
 * Event description: Viewing the second step of the assign to a different site popup, after choosing an editor X site
 *
 * @param {mySubscriptionsAssignToAnEditorXSitePopupViewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - from msid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - to msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsAssignToAnEditorXSitePopupViewParams>} LogObject<mySubscriptionsAssignToAnEditorXSitePopupViewParams>
 */
export function mySubscriptionsAssignToAnEditorXSitePopupView(params) {
    return { evid: 4816, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsAssignToAnEditorXSitePopupClick' event (evid: 4817)
 *
 * Event description: Clicking any of the options in the assign to a different site popup, after choosing an editor X site
 *
 * @param {mySubscriptionsAssignToAnEditorXSitePopupClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} clickType - close/back/cancel/compare_plans
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - from msid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - to msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsAssignToAnEditorXSitePopupClickParams>} LogObject<mySubscriptionsAssignToAnEditorXSitePopupClickParams>
 */
export function mySubscriptionsAssignToAnEditorXSitePopupClick(params) {
    return { evid: 4817, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickDeactivatePlan' event (evid: 4818)
 *
 * Event description: My Subscriptions > Click on Deactivate Plan from dropdown button
 *
 * @param {mySubscriptionsClickDeactivatePlanParams} params - The parameters for this event
 * @property {string} viewMode - accountLevel, siteLevel
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickDeactivatePlanParams>} LogObject<mySubscriptionsClickDeactivatePlanParams>
 */
export function mySubscriptionsClickDeactivatePlan(params) {
    return { evid: 4818, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsDeactivatePlanPopUpClick' event (evid: 4819)
 *
 * Event description: Click in Deactivate plan pop-up
 *
 * @param {mySubscriptionsDeactivatePlanPopUpClickParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel, accountLevel
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - ‘deactivate’, ‘close’, ‘cancel’
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsDeactivatePlanPopUpClickParams>} LogObject<mySubscriptionsDeactivatePlanPopUpClickParams>
 */
export function mySubscriptionsDeactivatePlanPopUpClick(params) {
    return { evid: 4819, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickUnassignPopup' event (evid: 4820)
 *
 * Event description: Click unassign/cancel/x/Learn more in the unassign popup
 *
 * @param {mySubscriptionsClickUnassignPopupParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} subscriptionId - subscriptionId
 * @property {string} clickType - unassign/cancel/close/learnMore
 * @property {string} productTypeName - productTypeName
 * @property {GUID} fromMsid - fromMsid
 * @property {GUID} siteid - siteid
 * @property {string} productTypeId - productTypeId
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - productId
 * @property {string} subscriptionType - subscriptionType
 * @property {string} type - partners/diy
 * @property {GUID} packageId - packageId
 * @property {string} productGuid - productGuid
 * @property {GUID} msid - msid
 * @property {number} cycleId - cycleId
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickUnassignPopupParams>} LogObject<mySubscriptionsClickUnassignPopupParams>
 */
export function mySubscriptionsClickUnassignPopup(params) {
    return { evid: 4820, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsErrorPage' event (evid: 4821)
 *
 * Event description: User got error page
 *
 * @param {mySubscriptionsErrorPageParams} params - The parameters for this event
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} userSitesCount - number of sites in the account
 * @property {string} pageView - error
 * @property {string} status_text - 'UPM after pay now - success' / 'UPM after pay now - review'
 * @property {string} siteId - site_id
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsErrorPageParams>} LogObject<mySubscriptionsErrorPageParams>
 */
export function mySubscriptionsErrorPage(params) {
    return { evid: 4821, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickOnManageAtResellerCta' event (evid: 4822)
 *
 * Event description: My Subscriptions  > user clicked on "Manage At Reseller"
 *
 * @param {mySubscriptionsClickOnManageAtResellerCtaParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {string} domain - domain
 * @property {string} actionName - manage at reseller
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} reseller - reseller guid if applicable
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @return {LogObject<mySubscriptionsClickOnManageAtResellerCtaParams>} LogObject<mySubscriptionsClickOnManageAtResellerCtaParams>
 */
export function mySubscriptionsClickOnManageAtResellerCta(params) {
    return { evid: 4822, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsHoverOnInfoSign' event (evid: 4823)
 *
 * Event description: This event should be triggered when user hovers on info sign for 1 second or more and sees a flying box.
 *
 * @param {mySubscriptionsHoverOnInfoSignParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} text - text
 * @property {string} reseller - reseller guid if applicable
 * @property {string} type - partners/diy
 * @property {GUID} msid - msid
 * @property {string} action - view
 * @return {LogObject<mySubscriptionsHoverOnInfoSignParams>} LogObject<mySubscriptionsHoverOnInfoSignParams>
 */
export function mySubscriptionsHoverOnInfoSign(params) {
    return { evid: 4823, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCardWidgetView' event (evid: 4824)
 *
 * Event description: The card was shown to the user
 *
 * @param {mySubscriptionsCardWidgetViewParams} params - The parameters for this event
 * @property {string} number - number shown on the card
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} pageView - no_subscriptions /unable_to_retrieve/active_subscriptions
 * @property {string} cardName - upcoming_renewals/unassigned_subscriptions/payment_problems
 * @property {GUID} msid - site_id
 * @property {boolean} failedToLoad - true if a card failed to load
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCardWidgetViewParams>} LogObject<mySubscriptionsCardWidgetViewParams>
 */
export function mySubscriptionsCardWidgetView(params) {
    return { evid: 4824, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCardWidgetClick' event (evid: 4825)
 *
 * Event description: User clicked inside a card
 *
 * @param {mySubscriptionsCardWidgetClickParams} params - The parameters for this event
 * @property {string} number - number shown on the card
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} clickName - filter/clear/refresh/current_month/next_week/next_30_days/next_90_days
 * @property {string} pageView - no_subscriptions /unable_to_retrieve/active_subscriptions
 * @property {string} cardName - upcoming_renewals/unassigned_subscriptions/payment_problems
 * @property {GUID} msid - site_id
 * @property {boolean} failedToLoad - true if a card failed to load
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCardWidgetClickParams>} LogObject<mySubscriptionsCardWidgetClickParams>
 */
export function mySubscriptionsCardWidgetClick(params) {
    return { evid: 4825, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsUseSearchBar' event (evid: 4827)
 *
 * Event description: user filters the page using search bar
 *
 * @param {mySubscriptionsUseSearchBarParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} filter - json filter name: filter value
 * @property {boolean} hasResult - 0/1 TRUE/FALSE
 * @property {string} type - partners/diy
 * @return {LogObject<mySubscriptionsUseSearchBarParams>} LogObject<mySubscriptionsUseSearchBarParams>
 */
export function mySubscriptionsUseSearchBar(params) {
    return { evid: 4827, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsViewMySubscriptionsTab' event (evid: 4870)
 *
 * Event description: The user view My Subscriptions tab
 *
 * @param {mySubscriptionsViewMySubscriptionsTabParams} params - The parameters for this event
 * @property {string} services - list of sbs
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} userSitesCount - number of sites in the account
 * @property {string} pageView - no_subscriptions /unable_to_retrieve/active_subscriptions
 * @property {string} status_text - 'UPM after pay now - success' / 'UPM after pay now - review'
 * @property {string} siteId - site_id
 * @property {string} type - partners/diy
 * @property {string} assetVersion - Indication- Cairo or old
 * @return {LogObject<mySubscriptionsViewMySubscriptionsTabParams>} LogObject<mySubscriptionsViewMySubscriptionsTabParams>
 */
export function mySubscriptionsViewMySubscriptionsTab(params) {
    return { evid: 4870, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsReclaimDomainClickContactSupport' event (evid: 4871)
 *
 * Event description: My Subscriptions  >  reclaim domain - click "Contact Support"
 *
 * @param {mySubscriptionsReclaimDomainClickContactSupportParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} domain - domain
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsReclaimDomainClickContactSupportParams>} LogObject<mySubscriptionsReclaimDomainClickContactSupportParams>
 */
export function mySubscriptionsReclaimDomainClickContactSupport(params) {
    return { evid: 4871, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickGoToSiteDashboard' event (evid: 4872)
 *
 * Event description: My Subscriptions  >  click "go to site dashboard"
 *
 * @param {mySubscriptionsClickGoToSiteDashboardParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickGoToSiteDashboardParams>} LogObject<mySubscriptionsClickGoToSiteDashboardParams>
 */
export function mySubscriptionsClickGoToSiteDashboard(params) {
    return { evid: 4872, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickAppSetting' event (evid: 4873)
 *
 * Event description: My Subscriptions  >  click "App Setting"
 *
 * @param {mySubscriptionsClickAppSettingParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickAppSettingParams>} LogObject<mySubscriptionsClickAppSettingParams>
 */
export function mySubscriptionsClickAppSetting(params) {
    return { evid: 4873, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsUseFilter' event (evid: 4874)
 *
 * Event description: My Subscriptions  >  use filter
 *
 * @param {mySubscriptionsUseFilterParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} preDefinedFilters - list of all pre-defined filters applied
 * @property {string} filter - json filter name: filter value
 * @property {string} search_term - searched term by the user
 * @property {boolean} hasResult - 0/1 TRUE/FALSE
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsUseFilterParams>} LogObject<mySubscriptionsUseFilterParams>
 */
export function mySubscriptionsUseFilter(params) {
    return { evid: 4874, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsDownloadCsv' event (evid: 4875)
 *
 * Event description: Download CSV
 *
 * @param {mySubscriptionsDownloadCsvParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} type - partners/diy
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsDownloadCsvParams>} LogObject<mySubscriptionsDownloadCsvParams>
 */
export function mySubscriptionsDownloadCsv(params) {
    return { evid: 4875, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickViewPlanFeatures' event (evid: 4876)
 *
 * Event description: My Subscriptions  > ”View_plan_features”
 *
 * @param {mySubscriptionsClickViewPlanFeaturesParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} assetVersion - indication - Cairo or old
 * @property {string} type - type
 * @return {LogObject<mySubscriptionsClickViewPlanFeaturesParams>} LogObject<mySubscriptionsClickViewPlanFeaturesParams>
 */
export function mySubscriptionsClickViewPlanFeatures(params) {
    return { evid: 4876, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickBanner' event (evid: 4878)
 *
 * Event description: My Subscriptions  > Click fall-back banner in case the dealer banner doesn't load (what's next banner)
 *
 * @param {mySubscriptionsClickBannerParams} params - The parameters for this event
 * @property {string} bannerName - banner name
 * @property {GUID} msid - msid
 * @return {LogObject<mySubscriptionsClickBannerParams>} LogObject<mySubscriptionsClickBannerParams>
 */
export function mySubscriptionsClickBanner(params) {
    return { evid: 4878, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickViewPaymentDetails' event (evid: 4879)
 *
 * Event description: My Subscriptions  > ”View_payment_details”
 *
 * @param {mySubscriptionsClickViewPaymentDetailsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} type - partners/diy
 * @property {GUID} msid - number
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickViewPaymentDetailsParams>} LogObject<mySubscriptionsClickViewPaymentDetailsParams>
 */
export function mySubscriptionsClickViewPaymentDetails(params) {
    return { evid: 4879, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickDropdown' event (evid: 4880)
 *
 * Event description: My Subscriptions  >  Click Dropdown
 *
 * @param {mySubscriptionsClickDropdownParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {boolean} canUpgrade - If the current mailbox package is eligible for upgrade
 * @property {string} domain - domain
 * @property {GUID} subscriptionId - Premium_guid
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} availableValue - availableValue
 * @property {boolean} isDeclinedCharge - true/false
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium_guid
 * @property {GUID} msid - number
 * @property {string} renewalStatus - renewal_status
 * @property {boolean} canReduce - If the current mailbox package is eligible for reduce seats
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickDropdownParams>} LogObject<mySubscriptionsClickDropdownParams>
 */
export function mySubscriptionsClickDropdown(params) {
    return { evid: 4880, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickChangeBillingCycle' event (evid: 4881)
 *
 * Event description: Click on "change billing cycle" from my subscriptions page (dropdown)
 *
 * @param {mySubscriptionsClickChangeBillingCycleParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} pendingBillingCycle - numeric/null
 * @property {GUID} subscriptionId - premium package id
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} subscriptionType - subscription type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium package Id
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - on / off
 * @property {number} cycleId - cycle id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickChangeBillingCycleParams>} LogObject<mySubscriptionsClickChangeBillingCycleParams>
 */
export function mySubscriptionsClickChangeBillingCycle(params) {
    return { evid: 4881, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickChangeBackToCurrentCycle' event (evid: 4887)
 *
 * Event description: Click 'Change back to current cycle' from the subscriptions page
 *
 * @param {mySubscriptionsClickChangeBackToCurrentCycleParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - site_level / account_level
 * @property {string} packagePickerType - package_picker_type
 * @property {number} pendingBillingCycle - pending billing cycle
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - premium package id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {Url} referer - referral
 * @property {string} subscriptionType - subscription type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - premium package id
 * @property {string} productGuid - product id
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - renewal status
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {number} cycleId - current cycle id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickChangeBackToCurrentCycleParams>} LogObject<mySubscriptionsClickChangeBackToCurrentCycleParams>
 */
export function mySubscriptionsClickChangeBackToCurrentCycle(params) {
    return { evid: 4887, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToast' event (evid: 4888)
 *
 * Event description: Toast indicating that a pending billing cycle was created successfully. (The change will take place at the end of period)
 *
 * @param {mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToastParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} pendingBillingCycle - pending cycle id
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan')
 * @property {string} referralAdditionalInfo - Referral Additional Info
 * @property {string} subscriptionType - subscription type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - premium package id
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - renewal status
 * @property {number} cycleId - current cycle id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToastParams>} LogObject<mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToastParams>
 */
export function mySubscriptionsChangeBillingCycleViewCreatePendingBillingCycleToast(params) {
    return { evid: 4888, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToast' event (evid: 4889)
 *
 * Event description: Cancel pending billing cycle success. Changed back to original cycle
 *
 * @param {mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToastParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} pendingBillingCycle - pending cycle id
 * @property {GUID} subscriptionId - premium package id
 * @property {string} productTypeName - hard coded 'Premium Plan'
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} subscriptionType - subscription_type
 * @property {string} type - partners/diy
 * @property {GUID} packageId - premium package id
 * @property {string} productGuid - product guid
 * @property {GUID} msid - msid
 * @property {string} renewalStatus - renewal_status
 * @property {number} cycleId - current cycle Id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToastParams>} LogObject<mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToastParams>
 */
export function mySubscriptionsChangeBillingCycleViewCancelPendingBillingCycleToast(params) {
    return { evid: 4889, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickOnManageSpendingLimit' event (evid: 4892)
 *
 * Event description: My Subscriptions > Click  on Manage Spending Limit
 *
 * @param {mySubscriptionsClickOnManageSpendingLimitParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} app_def_id - app_def_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isDeclinedCharge - true/false
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium_guid
 * @property {GUID} msid - number
 * @property {string} renewalStatus - renewal_status
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickOnManageSpendingLimitParams>} LogObject<mySubscriptionsClickOnManageSpendingLimitParams>
 */
export function mySubscriptionsClickOnManageSpendingLimit(params) {
    return { evid: 4892, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsSpendingLimitChangeSaved' event (evid: 4893)
 *
 * Event description: My Subscriptions > Spending Limit change Saved for custom charge subscriptions
 *
 * @param {mySubscriptionsSpendingLimitChangeSavedParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {string} chargeLimit - new charge limit
 * @property {GUID} appInstanceId - app_instance_id
 * @property {GUID} app_def_id - app_def_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isDeclinedCharge - true/false
 * @property {string} subscriptionType - Plan/Domain/Mailbox
 * @property {string} oldChargeLimit - old_charge_limit
 * @property {string} type - partners/diy
 * @property {GUID} packageId - Premium_guid
 * @property {GUID} msid - number
 * @property {string} renewalStatus - renewal_status
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsSpendingLimitChangeSavedParams>} LogObject<mySubscriptionsSpendingLimitChangeSavedParams>
 */
export function mySubscriptionsSpendingLimitChangeSaved(params) {
    return { evid: 4893, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewPaymentMethodsTab' event (evid: 4970)
 *
 * Event description: The user view Payment Methods tab
 *
 * @param {paymentMethodsViewPaymentMethodsTabParams} params - The parameters for this event
 * @property {string} viewMode - i.e. team/contributors
 * @property {GUID} billingAccountGuid - list of billing account guids
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @property {string} allBillingAccountGuids - list of billing account guids
 * @return {LogObject<paymentMethodsViewPaymentMethodsTabParams>} LogObject<paymentMethodsViewPaymentMethodsTabParams>
 */
export function paymentMethodsViewPaymentMethodsTab(params) {
    return { evid: 4970, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodView' event (evid: 4971)
 *
 * Event description: The user clicked on add payment method, and a pop-up was opened. For team page - second step after viewing the teammates with billing permissions
 *
 * @param {paymentMethodsAddPaymentMethodViewParams} params - The parameters for this event
 * @property {string} viewMode - team/regular
 * @return {LogObject<paymentMethodsAddPaymentMethodViewParams>} LogObject<paymentMethodsAddPaymentMethodViewParams>
 */
export function paymentMethodsAddPaymentMethodView(params) {
    return { evid: 4971, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'viewInvoiceFromActiveSubscriptions' event (evid: 4972)
 *
 * Event description: The user clicked save in the add payment method pop-up
 *
 * @param {viewInvoiceFromActiveSubscriptionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {number} invoiceId - Invoice Id
 * @property {string} origin - active_subscriptions/update_payment_method
 * @return {LogObject<viewInvoiceFromActiveSubscriptionsParams>} LogObject<viewInvoiceFromActiveSubscriptionsParams>
 */
export function viewInvoiceFromActiveSubscriptions(params) {
    return { evid: 4972, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodCancel' event (evid: 4973)
 *
 * Event description: The user closed the add payment method pop-up
 *
 * @param {paymentMethodsAddPaymentMethodCancelParams} params - The parameters for this event
 * @property {string} clickType - cancel/close
 * @return {LogObject<paymentMethodsAddPaymentMethodCancelParams>} LogObject<paymentMethodsAddPaymentMethodCancelParams>
 */
export function paymentMethodsAddPaymentMethodCancel(params) {
    return { evid: 4973, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodSuccess' event (evid: 4974)
 *
 * Event description: Add payment method success
 *
 * @param {paymentMethodsAddPaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsAddPaymentMethodSuccessParams>} LogObject<paymentMethodsAddPaymentMethodSuccessParams>
 */
export function paymentMethodsAddPaymentMethodSuccess(params) {
    return { evid: 4974, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodView' event (evid: 4975)
 *
 * Event description: The user clicked on delete payment method and viewed the pop-up
 *
 * @param {paymentMethodsRemovePaymentMethodViewParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsRemovePaymentMethodViewParams>} LogObject<paymentMethodsRemovePaymentMethodViewParams>
 */
export function paymentMethodsRemovePaymentMethodView(params) {
    return { evid: 4975, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsClickOnActions' event (evid: 4976)
 *
 * Event description: The user clicked on "actions" button from one of the payment methods
 *
 * @param {paymentMethodsClickOnActionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} availableValue - e.g update payment method/remove payment method
 * @return {LogObject<paymentMethodsClickOnActionsParams>} LogObject<paymentMethodsClickOnActionsParams>
 */
export function paymentMethodsClickOnActions(params) {
    return { evid: 4976, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodCancel' event (evid: 4977)
 *
 * Event description: The user clicked cancel in the remove payment method pop-up
 *
 * @param {paymentMethodsRemovePaymentMethodCancelParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} clickType - cancel/close
 * @return {LogObject<paymentMethodsRemovePaymentMethodCancelParams>} LogObject<paymentMethodsRemovePaymentMethodCancelParams>
 */
export function paymentMethodsRemovePaymentMethodCancel(params) {
    return { evid: 4977, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodSuccess' event (evid: 4978)
 *
 * Event description: Remove payment method success
 *
 * @param {paymentMethodsRemovePaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsRemovePaymentMethodSuccessParams>} LogObject<paymentMethodsRemovePaymentMethodSuccessParams>
 */
export function paymentMethodsRemovePaymentMethodSuccess(params) {
    return { evid: 4978, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewActiveSubscriptions' event (evid: 4979)
 *
 * Event description: View the active subscriptions that are attached to the payment method (after clicking "x active subscriptions" button)
 *
 * @param {paymentMethodsViewActiveSubscriptionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsViewActiveSubscriptionsParams>} LogObject<paymentMethodsViewActiveSubscriptionsParams>
 */
export function paymentMethodsViewActiveSubscriptions(params) {
    return { evid: 4979, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsClickManageSubscriptions' event (evid: 4980)
 *
 * Event description: Click Manage Subscriptions > Move from the payment method tab to the account level subscriptions tab
 *
 * @param {paymentMethodsClickManageSubscriptionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsClickManageSubscriptionsParams>} LogObject<paymentMethodsClickManageSubscriptionsParams>
 */
export function paymentMethodsClickManageSubscriptions(params) {
    return { evid: 4980, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodView' event (evid: 4981)
 *
 * Event description: The user clicked on update payment method and view the update payment method pop-up
 *
 * @param {paymentMethodsUpdatePaymentMethodViewParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} services - List of eligible services to update which are under the same payment method
 * @return {LogObject<paymentMethodsUpdatePaymentMethodViewParams>} LogObject<paymentMethodsUpdatePaymentMethodViewParams>
 */
export function paymentMethodsUpdatePaymentMethodView(params) {
    return { evid: 4981, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodNext' event (evid: 4982)
 *
 * Event description: The user clicked next in the update payment method pop-up
 *
 * @param {paymentMethodsUpdatePaymentMethodNextParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsUpdatePaymentMethodNextParams>} LogObject<paymentMethodsUpdatePaymentMethodNextParams>
 */
export function paymentMethodsUpdatePaymentMethodNext(params) {
    return { evid: 4982, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodCancel' event (evid: 4984)
 *
 * Event description: The user clicked on cancel in the update payment method pop-up
 *
 * @param {paymentMethodsUpdatePaymentMethodCancelParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} clickType - cancel/close
 * @return {LogObject<paymentMethodsUpdatePaymentMethodCancelParams>} LogObject<paymentMethodsUpdatePaymentMethodCancelParams>
 */
export function paymentMethodsUpdatePaymentMethodCancel(params) {
    return { evid: 4984, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodSuccess' event (evid: 4985)
 *
 * Event description: Update payment method success
 *
 * @param {paymentMethodsUpdatePaymentMethodSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsUpdatePaymentMethodSuccessParams>} LogObject<paymentMethodsUpdatePaymentMethodSuccessParams>
 */
export function paymentMethodsUpdatePaymentMethodSuccess(params) {
    return { evid: 4985, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewPaymentMethodsError' event (evid: 4986)
 *
 * Event description: Payment Methods tab did not load successfully
 *
 * @param {paymentMethodsViewPaymentMethodsErrorParams} params - The parameters for this event
 * @property {string} errorInfo - The error info
 * @return {LogObject<paymentMethodsViewPaymentMethodsErrorParams>} LogObject<paymentMethodsViewPaymentMethodsErrorParams>
 */
export function paymentMethodsViewPaymentMethodsError(params) {
    return { evid: 4986, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodsError' event (evid: 4987)
 *
 * Event description: Update payment method failed
 *
 * @param {paymentMethodsAddPaymentMethodsErrorParams} params - The parameters for this event
 * @return {LogObject<paymentMethodsAddPaymentMethodsErrorParams>} LogObject<paymentMethodsAddPaymentMethodsErrorParams>
 */
export function paymentMethodsAddPaymentMethodsError(params) {
    return { evid: 4987, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsRemovePaymentMethodError' event (evid: 4988)
 *
 * Event description: Remove payment method failed
 *
 * @param {paymentMethodsRemovePaymentMethodErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsRemovePaymentMethodErrorParams>} LogObject<paymentMethodsRemovePaymentMethodErrorParams>
 */
export function paymentMethodsRemovePaymentMethodError(params) {
    return { evid: 4988, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsUpdatePaymentMethodError' event (evid: 4989)
 *
 * Event description: Update payment method failed
 *
 * @param {paymentMethodsUpdatePaymentMethodErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsUpdatePaymentMethodErrorParams>} LogObject<paymentMethodsUpdatePaymentMethodErrorParams>
 */
export function paymentMethodsUpdatePaymentMethodError(params) {
    return { evid: 4989, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteAddSeats' event (evid: 499)
 *
 * Event description: G-suite > add seats
 *
 * @param {gSuiteAddSeatsParams} params - The parameters for this event
 * @property {number} numSetUpSeats - num_setup_seats
 * @property {string} viewMode - empty_state / manage_state
 * @property {number} emailSkuId - email Sku Id
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {number} totalSeats - total_seats
 * @property {string} domain - domain
 * @property {string} pageView - site_level / account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {GUID} product_type_id - product_type_id
 * @property {GUID} productId - 	product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteAddSeatsParams>} LogObject<gSuiteAddSeatsParams>
 */
export function gSuiteAddSeats(params) {
    return { evid: 499, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewTeammatesWithBillingPermissions' event (evid: 4990)
 *
 * Event description: The user clicked on 'teammates with billing permissions' add the modal opened.
 *
 * @param {paymentMethodsViewTeammatesWithBillingPermissionsParams} params - The parameters for this event
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @return {LogObject<paymentMethodsViewTeammatesWithBillingPermissionsParams>} LogObject<paymentMethodsViewTeammatesWithBillingPermissionsParams>
 */
export function paymentMethodsViewTeammatesWithBillingPermissions(params) {
    return { evid: 4990, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodViewTeammates' event (evid: 4991)
 *
 * Event description: The account owner clicked on add payment method and the list of teammates with billing permissions is shown
 *
 * @param {paymentMethodsAddPaymentMethodViewTeammatesParams} params - The parameters for this event
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @return {LogObject<paymentMethodsAddPaymentMethodViewTeammatesParams>} LogObject<paymentMethodsAddPaymentMethodViewTeammatesParams>
 */
export function paymentMethodsAddPaymentMethodViewTeammates(params) {
    return { evid: 4991, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsAddPaymentMethodConfirmAuthorization' event (evid: 4992)
 *
 * Event description: The account owner checked the box of giving other team members permission to use the payment method
 *
 * @param {paymentMethodsAddPaymentMethodConfirmAuthorizationParams} params - The parameters for this event
 * @property {string} pageView - no_payment_methods /active_payment_methods
 * @return {LogObject<paymentMethodsAddPaymentMethodConfirmAuthorizationParams>} LogObject<paymentMethodsAddPaymentMethodConfirmAuthorizationParams>
 */
export function paymentMethodsAddPaymentMethodConfirmAuthorization(params) {
    return { evid: 4992, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsView' event (evid: 4993)
 *
 * Event description: View manage permissions page for specific payment method
 *
 * @param {paymentMethodsManagePermissionsViewParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} pageView - no permissions / x permissions
 * @property {string} referralAdditionalInfo - actions / card permissions (what was the entry point to view the modal)
 * @return {LogObject<paymentMethodsManagePermissionsViewParams>} LogObject<paymentMethodsManagePermissionsViewParams>
 */
export function paymentMethodsManagePermissionsView(params) {
    return { evid: 4993, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep1' event (evid: 4994)
 *
 * Event description: Site selector loaded after clicking add permissions
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep1Params} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep1Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep1Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep1(params) {
    return { evid: 4994, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep2' event (evid: 4995)
 *
 * Event description: Click the site selector page while adding permissions
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep2Params} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedMsid - Selected MSID
 * @property {string} clickType - cancel/next/close
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep2Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep2Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep2(params) {
    return { evid: 4995, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep3' event (evid: 4996)
 *
 * Event description: Click the user selector page while giving permissions
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep3Params} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} clickType - cancel/next/close
 * @property {string} selectedUuids - list of selected uuids (separated by comas)
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep3Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep3Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep3(params) {
    return { evid: 4996, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsStep4' event (evid: 4997)
 *
 * Event description: add permissions final step
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsStep4Params} params - The parameters for this event
 * @property {string} clickType - back/cancel/confirm/close
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsStep4Params>} LogObject<paymentMethodsManagePermissionsAddPermissionsStep4Params>
 */
export function paymentMethodsManagePermissionsAddPermissionsStep4(params) {
    return { evid: 4997, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsSuccess' event (evid: 4998)
 *
 * Event description: add permissions success
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedMsid - Selected MSID
 * @property {string} selectedUuids - list of UUIDs
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsSuccessParams>} LogObject<paymentMethodsManagePermissionsAddPermissionsSuccessParams>
 */
export function paymentMethodsManagePermissionsAddPermissionsSuccess(params) {
    return { evid: 4998, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsAddPermissionsError' event (evid: 4999)
 *
 * Event description: add permissions failure
 *
 * @param {paymentMethodsManagePermissionsAddPermissionsErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} errorInfo - error info
 * @property {GUID} selectedMsid - Selected MSID
 * @property {string} selectedUuids - list of UUIDs
 * @return {LogObject<paymentMethodsManagePermissionsAddPermissionsErrorParams>} LogObject<paymentMethodsManagePermissionsAddPermissionsErrorParams>
 */
export function paymentMethodsManagePermissionsAddPermissionsError(params) {
    return { evid: 4999, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsViewCardPermissions' event (evid: 49991)
 *
 * Event description: View card permissions
 *
 * @param {paymentMethodsViewCardPermissionsParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsViewCardPermissionsParams>} LogObject<paymentMethodsViewCardPermissionsParams>
 */
export function paymentMethodsViewCardPermissions(params) {
    return { evid: 49991, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionView' event (evid: 49992)
 *
 * Event description: User Clicked remove permission cta
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionViewParams} params - The parameters for this event
 * @property {GUID} selectedUser - uuid of selected user
 * @property {GUID} billingAccountGuid - billing account guid
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionViewParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionViewParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionView(params) {
    return { evid: 49992, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionClick' event (evid: 49993)
 *
 * Event description: Remove permission click
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionClickParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedUser - uuid of selected user
 * @property {string} selectedMsids - list of msids
 * @property {string} clickType - cancel/remove/close
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionClickParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionClickParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionClick(params) {
    return { evid: 49993, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionSuccess' event (evid: 49994)
 *
 * Event description: Remove permission success
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionSuccessParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {GUID} selectedUser - uuid of selected user
 * @property {string} selectedMsids - list of msids
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionSuccessParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionSuccessParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionSuccess(params) {
    return { evid: 49994, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsRemovePermissionError' event (evid: 49995)
 *
 * Event description: Remove permission failure
 *
 * @param {paymentMethodsManagePermissionsRemovePermissionErrorParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} errorInfo - error info
 * @property {GUID} selectedUser - uuid of selected user
 * @property {string} selectedMsids - list of msids
 * @return {LogObject<paymentMethodsManagePermissionsRemovePermissionErrorParams>} LogObject<paymentMethodsManagePermissionsRemovePermissionErrorParams>
 */
export function paymentMethodsManagePermissionsRemovePermissionError(params) {
    return { evid: 49995, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'paymentMethodsManagePermissionsLearnMore' event (evid: 49996)
 *
 * Event description: Click learn more on manage permissions page
 *
 * @param {paymentMethodsManagePermissionsLearnMoreParams} params - The parameters for this event
 * @property {GUID} billingAccountGuid - billing account guid
 * @property {string} pageView - no permissions / x permissions
 * @property {string} referralAdditionalInfo - Referral Additional Info
 * @return {LogObject<paymentMethodsManagePermissionsLearnMoreParams>} LogObject<paymentMethodsManagePermissionsLearnMoreParams>
 */
export function paymentMethodsManagePermissionsLearnMore(params) {
    return { evid: 49996, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainNoSitesModal' event (evid: 49997)
 *
 * Event description: Triggers when free users with no sites click on Connect Purchse Domain button in the empty state
 *
 * @param {domainNoSitesModalParams} params - The parameters for this event
 * @property {string} viewMode - Account | Site level
 * @property {string} flowType - Connect | Purchase
 * @property {boolean} hasSites - If the user has sites in the accuont
 * @property {string} referralAdditionalInfo - Where user came from
 * @property {string} action - view | create_your_site| close | get_domain_without_site | learn_more | hover_info | tooltip_click | expand_footer
 * @return {LogObject<domainNoSitesModalParams>} LogObject<domainNoSitesModalParams>
 */
export function domainNoSitesModal(params) {
    return { evid: 49997, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsConciergeClickOnSuggestedTld' event (evid: 49998)
 *
 * Event description: User clicked on suggested TLD
 *
 * @param {domainsConciergeClickOnSuggestedTldParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} suggestedTlds - array of suggested TLDs and notes (voucher included etc)
 * @property {string} viewmode - .
 * @property {string} locale - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {boolean} isAccountPremium - is_account_premium
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} tld - The TLD that was selected
 * @property {boolean} isSale - is_sale
 * @return {LogObject<domainsConciergeClickOnSuggestedTldParams>} LogObject<domainsConciergeClickOnSuggestedTldParams>
 */
export function domainsConciergeClickOnSuggestedTld(params) {
    return { evid: 49998, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'copyOfDomainsConciergeHoverOverSuggestedTld' event (evid: 49999)
 *
 * Event description: User hovered on suggested TLD
 *
 * @param {copyOfDomainsConciergeHoverOverSuggestedTldParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} suggestedTlds - array of suggested TLDs and notes (voucher included etc)
 * @property {string} text - The hover content test
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} tld - The TLD that was selected
 * @property {boolean} isSale - true. false
 * @return {LogObject<copyOfDomainsConciergeHoverOverSuggestedTldParams>} LogObject<copyOfDomainsConciergeHoverOverSuggestedTldParams>
 */
export function copyOfDomainsConciergeHoverOverSuggestedTld(params) {
    return { evid: 49999, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteUpgradeClick' event (evid: 50011)
 *
 * Event description: Upgrade Click - currently only for migratoin flow
 *
 * @param {gSuiteUpgradeClickParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} clickType - upgrade
 * @property {string} viewmode - view mode
 * @property {string} newPurchase - is_new_purchase
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {string} type - type
 * @property {GUID} msid - msid
 * @property {GUID} productTypeId - product_type_id
 * @property {string} productId - product_id (the catalog didn't let me create product_id as a name)
 * @property {string} subscriptionId - subscription_id
 * @return {LogObject<gSuiteUpgradeClickParams>} LogObject<gSuiteUpgradeClickParams>
 */
export function gSuiteUpgradeClick(params) {
    return { evid: 50011, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMigrationLearnMoreClick' event (evid: 50012)
 *
 * Event description: G-suite > Migration Learn More Click
 *
 * @param {gSuiteMigrationLearnMoreClickParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email_package_guid
 * @property {string} flowType - flow_type
 * @property {string} positionName - position_name
 * @property {string} domain - domain
 * @property {string} clickType - click_type
 * @property {string} newPurchase - is_new_purchase
 * @property {string} pageView - page_view
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} recommendedPlan - recommended_plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuiteMigrationLearnMoreClickParams>} LogObject<gSuiteMigrationLearnMoreClickParams>
 */
export function gSuiteMigrationLearnMoreClick(params) {
    return { evid: 50012, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMigrationUpgradeBanner' event (evid: 50013)
 *
 * Event description: G-suite > Migration Upgrade Banner
 *
 * @param {gSuiteMigrationUpgradeBannerParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} clickType - upgrade
 * @property {string} viewmode - view mode
 * @property {string} newPurchase - is_new_purchase
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuiteMigrationUpgradeBannerParams>} LogObject<gSuiteMigrationUpgradeBannerParams>
 */
export function gSuiteMigrationUpgradeBanner(params) {
    return { evid: 50013, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'googleMailDeleteUsersModalLoad' event (evid: 50014)
 *
 * Event description: Google Mail Delete users modal load
 *
 * @param {googleMailDeleteUsersModalLoadParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} quantity - Total number of users
 * @property {number} emailSkuId - email_sku_id
 * @property {string} domain - domain
 * @property {number} numInactiveUsers - Number of current inactive users
 * @property {string} cycleName - cyclecycle_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} subscriptionType - subscription_type
 * @property {GUID} packageId - package_id
 * @property {GUID} msid - msid
 * @return {LogObject<googleMailDeleteUsersModalLoadParams>} LogObject<googleMailDeleteUsersModalLoadParams>
 */
export function googleMailDeleteUsersModalLoad(params) {
    return { evid: 50014, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'googleMailDeleteUsersModalClick' event (evid: 50015)
 *
 * Event description: Google Mail Delete users modal clock
 *
 * @param {googleMailDeleteUsersModalClickParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} quantity - Total number of users
 * @property {number} emailSkuId - email_sku_id
 * @property {string} domain - domain
 * @property {string} clickType - Learn more / renew with active only / submit / renew active only
 * @property {number} numInactiveUsers - Number of current inactive users
 * @property {string} cycleName - cyclecycle_name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} subscriptionType - subscription_type
 * @property {GUID} packageId - package_id
 * @property {GUID} msid - msid
 * @return {LogObject<googleMailDeleteUsersModalClickParams>} LogObject<googleMailDeleteUsersModalClickParams>
 */
export function googleMailDeleteUsersModalClick(params) {
    return { evid: 50015, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuitePpLoaded' event (evid: 50016)
 *
 * Event description: When the GWS package picker load on the client
 *
 * @param {gSuitePpLoadedParams} params - The parameters for this event
 * @property {string} viewMode - site_level/account_level
 * @property {number} quantity - quantity
 * @property {number} emailSkuId - emailSkuId
 * @property {string} domain - domain
 * @property {string} planType - starter/standard/plus
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {GUID} packageId - packageId
 * @property {GUID} msid - msid
 * @return {LogObject<gSuitePpLoadedParams>} LogObject<gSuitePpLoadedParams>
 */
export function gSuitePpLoaded(params) {
    return { evid: 50016, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuite2ndUpgradeUpgradeButtonAppearing' event (evid: 50017)
 *
 * Event description: Upgrade button appearing on Business Email Page - a per domain event
 *
 * @param {gSuite2ndUpgradeUpgradeButtonAppearingParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} viewmode - view mode
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuite2ndUpgradeUpgradeButtonAppearingParams>} LogObject<gSuite2ndUpgradeUpgradeButtonAppearingParams>
 */
export function gSuite2ndUpgradeUpgradeButtonAppearing(params) {
    return { evid: 50017, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuite2ndUpgradeHighestPlanError' event (evid: 50018)
 *
 * Event description: G-suite > 2nd upgrade > Highest plan error
 *
 * @param {gSuite2ndUpgradeHighestPlanErrorParams} params - The parameters for this event
 * @property {number} quantity - quantity
 * @property {GUID} emailPackageGuid - email Package Guid
 * @property {string} flowType - Migration
 * @property {string} positionName - Context-menu Marketing-banner section-helper
 * @property {string} domain - domain name
 * @property {string} viewmode - view mode
 * @property {string} pageView - site_level, account_level
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} recommendedPlan - Recommended Plan
 * @property {string} referrer - referrer
 * @property {GUID} msid - msid
 * @return {LogObject<gSuite2ndUpgradeHighestPlanErrorParams>} LogObject<gSuite2ndUpgradeHighestPlanErrorParams>
 */
export function gSuite2ndUpgradeHighestPlanError(params) {
    return { evid: 50018, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'gSuiteMyMailboxesGoogleVoicePageCtaClick' event (evid: 50019)
 *
 * Event description: Click on the CTA of the Google voice page
 *
 * @param {gSuiteMyMailboxesGoogleVoicePageCtaClickParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} referralAdditionalInfo - where the user came from
 * @property {GUID} siteGuid - msid
 * @return {LogObject<gSuiteMyMailboxesGoogleVoicePageCtaClickParams>} LogObject<gSuiteMyMailboxesGoogleVoicePageCtaClickParams>
 */
export function gSuiteMyMailboxesGoogleVoicePageCtaClick(params) {
    return { evid: 50019, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'billingHistoryTabCsvFileIsReadyToDownload' event (evid: 5014)
 *
 * Event description: BillingHistoryTab > CSV file is ready to download after 17:4799 when user clicked on export csv there is a loader and then a green toast of "ready file".. this event will be fired when the file is ready
 *
 * @param {billingHistoryTabCsvFileIsReadyToDownloadParams} params - The parameters for this event
 * @property {string} name - domain_name_filter
 * @property {string} externalSessionId - externalSessionId
 * @property {string} paymentMethod - payment_method_type_filter
 * @property {number} year - year_filter
 * @property {string} clickType - closed window/ cancel/ download
 * @property {string} freeText - free_text_filter
 * @property {string} siteName - site_name_filter
 * @property {string} clickName - closed window/ cancel/ download
 * @property {number} daysAgo - days_ago_filter
 * @property {string} status - status_filter
 * @property {number} countInvoices - number of invoices
 * @property {string} jsonData - json_data
 * @property {string} metaSiteId - msid_filter
 * @property {string} modalType - modal_type
 * @return {LogObject<billingHistoryTabCsvFileIsReadyToDownloadParams>} LogObject<billingHistoryTabCsvFileIsReadyToDownloadParams>
 */
export function billingHistoryTabCsvFileIsReadyToDownload(params) {
    return { evid: 5014, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsFedMonitoring' event (evid: 509)
 *
 * Event description: event for FED monitoring
 *
 * @param {myDomainsFedMonitoringParams} params - The parameters for this event
 * @property {string} tabId - tab_id
 * @property {Url} parentUrl - parent url
 * @property {Url} fullUrl - full url
 * @property {string} errorName - error name
 * @property {string} additionalInfo - error_info
 * @return {LogObject<myDomainsFedMonitoringParams>} LogObject<myDomainsFedMonitoringParams>
 */
export function myDomainsFedMonitoring(params) {
    return { evid: 509, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsActions' event (evid: 513)
 *
 * Event description: Any actions with domains on My Domains Page.
 *
 * @param {myDomainsActionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} location - dropdown | details | name | button | domain_statuses | etc
 * @property {string} tab - assigned | unassigned | inactive
 * @property {string} domain - domain name
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {string} label - live | offline
 * @property {string} domains - list of domains
 * @property {string} elementText - the text on the element - buy a mailbox | assign to a different site | open_dropdown
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} emptyState - true,false
 * @property {boolean} isPublished - is site published or not
 * @property {string} redeemStatus - can_redeem, redeem_in_process, redeem_failed
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} status - status path
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {string} referralAdditionalInfo - where users came form
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {string} reseller - reseller guid (if applicable)
 * @property {boolean} hasApi - whether domain has Redeem API - true, false
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid | NULL if domain unassigned
 * @return {LogObject<myDomainsActionsParams>} LogObject<myDomainsActionsParams>
 */
export function myDomainsActions(params) {
    return { evid: 513, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep1' event (evid: 514)
 *
 * Event description: First screens in assign flow: one free site, one free site with unassigned premium, one premium site, premium and free sites
 *
 * @param {myDomainsAssignFlowStep1Params} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {DateTime} datetimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - 0 - free | 1 - premium (for actions next, assign, assign_an_existing_plan,  upgrade_to_premium)
 * @property {string} referralAdditionalInfo - where users came form
 * @property {boolean} isPremium - Does a user have an unassigned premium package
 * @property {string} domainLevel - primary | secondary
 * @property {string} totalSites - Number of sites
 * @property {string} totalFreeSites - Number of free sites
 * @property {string} action - view | close | cancel | next | assign| assign_an_existing_plan | upgrade_to_premium
 * @property {string} totalPremiumSites - Number of premium sites
 * @return {LogObject<myDomainsAssignFlowStep1Params>} LogObject<myDomainsAssignFlowStep1Params>
 */
export function myDomainsAssignFlowStep1(params) {
    return { evid: 514, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep2' event (evid: 515)
 *
 * Event description: Second screens in assign flow:
 * 1. one free site with unassigned premium > Assign Existing Plan
 * 2. one premium site > Confirmation wo domain | Choose what to do with domain
 * 3. premium and free sites >  free > Assign Premium Plan
 * 4. premium and free sites >  premium > Confirmation wo domain | Choose what to do with domain
 *
 * @param {myDomainsAssignFlowStep2Params} params - The parameters for this event
 * @property {DateTime} dateTimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} toMsid - to which site user assigns a domain
 * @property {string} label - live | offline
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - 0 - free | 1 - premium
 * @property {string} premium - Is the premium plan is assigned to a site. unassigned | assigned
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - assign_premium_plan | has_domain | no_domains
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | cancel | next | assign | back
 * @return {LogObject<myDomainsAssignFlowStep2Params>} LogObject<myDomainsAssignFlowStep2Params>
 */
export function myDomainsAssignFlowStep2(params) {
    return { evid: 515, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep3' event (evid: 516)
 *
 * Event description: Third screens in assign flow:
 * 1. one free site with unassigned premium > Assign Existing Plan > Confirmation
 * 2. one premium site > Confirmation wo domain | Choose what to do with domain > Success
 * 3. 4. premium and free sites >  premium > Confirmation wo domain | Choose what to do with domain > Success
 * 4. premium and free sites >  free > Assign Premium Plan > Confirmation wo domain | Choose what to do with domain | unassigned_plan
 *
 * @param {myDomainsAssignFlowStep3Params} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} toMsid - to which site user assigns a domain
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {DateTime} datetimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - free | premium
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - has_domain | no_domains | unassigned_plan | success
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | back | cancel | assign |  view_your_site | go_to_editor | skip_for_now
 * @return {LogObject<myDomainsAssignFlowStep3Params>} LogObject<myDomainsAssignFlowStep3Params>
 */
export function myDomainsAssignFlowStep3(params) {
    return { evid: 516, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsAssignFlowStep4' event (evid: 517)
 *
 * Event description: Forth screens in assign flow:
 * 1. one free site with unassigned premium > Assign Existing Plan > Confirmation > Success
 * 4. premium and free sites >  free > Assign Premium Plan > Confirmation wo domain | Choose what to do with domain | unassigned_plan > Success
 *
 * @param {myDomainsAssignFlowStep4Params} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} toMsid - to which site user assigns a domain
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {DateTime} datetimeSent - Precise event timestamp from client side. Technical field to avoid wrong event order, when event in funnel are captured almost instantly.
 * @property {string} domainStatus - status of the domain from messages
 * @property {number} siteType - free | premium
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - has_domain | no_domains | unassigned_plan | success
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | back | cancel | assign |  view_your_site | go_to_editor | skip_for_now
 * @return {LogObject<myDomainsAssignFlowStep4Params>} LogObject<myDomainsAssignFlowStep4Params>
 */
export function myDomainsAssignFlowStep4(params) {
    return { evid: 517, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsUnassignFlow' event (evid: 518)
 *
 * Event description: Unassign domain from the site
 *
 * @param {myDomainsUnassignFlowParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {GUID} fromMsid - msid | NULL means that domain was unassigned
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {string} action - view | close | unassign
 * @return {LogObject<myDomainsUnassignFlowParams>} LogObject<myDomainsUnassignFlowParams>
 */
export function myDomainsUnassignFlow(params) {
    return { evid: 518, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsTransferAwayFromWixFlow' event (evid: 519)
 *
 * Event description: Transfer domain away from Wix. User requests AUTH code.
 *
 * @param {myDomainsTransferAwayFromWixFlowParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} step - 1 | 2
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} type - icann-lock | eligible_for_transfer
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid | NULL means that domain was unassigned
 * @property {string} action - view | close | cancel | transfer_domain | keep_domain_at_wix | still_want_to_transfer | learn_more | got_it
 * @property {string} clickText - ipsTag the user chose
 * @return {LogObject<myDomainsTransferAwayFromWixFlowParams>} LogObject<myDomainsTransferAwayFromWixFlowParams>
 */
export function myDomainsTransferAwayFromWixFlow(params) {
    return { evid: 519, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsSetAsPrimary' event (evid: 520)
 *
 * Event description: Set secondary domain as primary
 *
 * @param {myDomainsSetAsPrimaryParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} action - view | close | set_as_primary
 * @return {LogObject<myDomainsSetAsPrimaryParams>} LogObject<myDomainsSetAsPrimaryParams>
 */
export function myDomainsSetAsPrimary(params) {
    return { evid: 520, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsConnectExternalMailbox' event (evid: 521)
 *
 * Event description: Connect External Mailbox
 *
 * @param {myDomainsConnectExternalMailboxParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} action - view | close | connect_mailbox | click_on_dns_records | add_another | change_email_provider
 * @return {LogObject<myDomainsConnectExternalMailboxParams>} LogObject<myDomainsConnectExternalMailboxParams>
 */
export function myDomainsConnectExternalMailbox(params) {
    return { evid: 521, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectExternalBusinessEmailActions' event (evid: 5210)
 *
 * Event description: Different actions in the connect domain wizard
 *
 * @param {connectExternalBusinessEmailActionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} action - step 1 view / step 1 continue / step 2 view / step 2 continue / step 3 view / step 3 continue/ step 4 view / step 3 done/ step 4 done
 * @return {LogObject<connectExternalBusinessEmailActionsParams>} LogObject<connectExternalBusinessEmailActionsParams>
 */
export function connectExternalBusinessEmailActions(params) {
    return { evid: 5210, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectExternalBusinessEmailEditTxtActions' event (evid: 5211)
 *
 * Event description: The user edits TXT record via the connect EBE wizard
 *
 * @param {connectExternalBusinessEmailEditTxtActionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} recordType - TXT
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} action - add_record/ remove / edit / cancel / save
 * @property {string} record - JSON with attributes and their values for different record types domain
 * @return {LogObject<connectExternalBusinessEmailEditTxtActionsParams>} LogObject<connectExternalBusinessEmailEditTxtActionsParams>
 */
export function connectExternalBusinessEmailEditTxtActions(params) {
    return { evid: 5211, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectExternalBusinessEmailError' event (evid: 5212)
 *
 * Event description: Error in connect EBE flow
 *
 * @param {connectExternalBusinessEmailErrorParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} recordType - TXT
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain name
 * @property {string} label - live | offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} emailProvider - GoDaddy | GSuite | Other
 * @property {string} domainStatus - status of the domain from messages
 * @property {string} referralAdditionalInfo - where users came form
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} value - comma separated user values
 * @property {string} record - JSON with attributes and their values for different record types domain
 * @return {LogObject<connectExternalBusinessEmailErrorParams>} LogObject<connectExternalBusinessEmailErrorParams>
 */
export function connectExternalBusinessEmailError(params) {
    return { evid: 5212, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsContactFormActions' event (evid: 522)
 *
 * Event description: My Domains  Contact Form Actions
 *
 * @param {myDomainsContactFormActionsParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} fieldsUpdated - list of updated fields
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} type - update | create
 * @property {string} action - view | cancel | back | submit
 * @property {boolean} emailChanged - Email was changed or not
 * @return {LogObject<myDomainsContactFormActionsParams>} LogObject<myDomainsContactFormActionsParams>
 */
export function myDomainsContactFormActions(params) {
    return { evid: 522, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsContactFormValidationErrorsOnSubmit' event (evid: 523)
 *
 * Event description: Contact Form Validation Errors on Submit
 *
 * @param {myDomainsContactFormValidationErrorsOnSubmitParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} invalidFields - comma separated empty invalid fields
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} type - update | create
 * @property {string} emptyFields - comma separated empty fields
 * @return {LogObject<myDomainsContactFormValidationErrorsOnSubmitParams>} LogObject<myDomainsContactFormValidationErrorsOnSubmitParams>
 */
export function myDomainsContactFormValidationErrorsOnSubmit(params) {
    return { evid: 523, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsNetworkCallError' event (evid: 524)
 *
 * Event description: Triggers if the session expires. Event is deprecated from 15/08/2019! From 18.02.20 - event for investigation. From 20.11.20 - network investigation.
 *
 * @param {myDomainsNetworkCallErrorParams} params - The parameters for this event
 * @property {string} sessionId - screenRecorderSessionId
 * @property {string} type - getUserDetailsCallFailure | initialCallsFailure
 * @property {string} value - error_info
 * @return {LogObject<myDomainsNetworkCallErrorParams>} LogObject<myDomainsNetworkCallErrorParams>
 */
export function myDomainsNetworkCallError(params) {
    return { evid: 524, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsEditDnsPopUp' event (evid: 525)
 *
 * Event description: Pop-ups interactions on Manage DNS page
 *
 * @param {myDomainsEditDnsPopUpParams} params - The parameters for this event
 * @property {string} recordType - aname| cname | txt | spf | srv | mx
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} type - dns_modal_edit_warning | dns_modal_save_confirmation | dns_modal_remove_confirmation
 * @property {string} action - open | cancel | ok | close | learn_more
 * @return {LogObject<myDomainsEditDnsPopUpParams>} LogObject<myDomainsEditDnsPopUpParams>
 */
export function myDomainsEditDnsPopUp(params) {
    return { evid: 525, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsEditDnsPageClicks' event (evid: 526)
 *
 * Event description: Clicks on Manage DNS page
 *
 * @param {myDomainsEditDnsPageClicksParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} action - back | edit_mx_settings | here | buy_a_new_one | learn_more_about_dns_records
 * @return {LogObject<myDomainsEditDnsPageClicksParams>} LogObject<myDomainsEditDnsPageClicksParams>
 */
export function myDomainsEditDnsPageClicks(params) {
    return { evid: 526, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsDomainVoucherInteractions' event (evid: 527)
 *
 * Event description: This event is triggered when user hovers on "Gift box" button for 1 second of more, clicks the icon or hits "Claim Voucher"
 *
 * @param {myDomainsDomainVoucherInteractionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {string} totalDomains - The number of domains on the page, if 0 - then empty state
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site or account level (check on the site level)
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} action - view(triggers on hover) | click
 * @return {LogObject<myDomainsDomainVoucherInteractionsParams>} LogObject<myDomainsDomainVoucherInteractionsParams>
 */
export function myDomainsDomainVoucherInteractions(params) {
    return { evid: 527, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsHoverOnBuyMailbox' event (evid: 528)
 *
 * Event description: This event should be triggered when user hovers on “Buy a Mailbox” button for 1 second or more. From 17.03.20 we removed this event
 *
 * @param {myDomainsHoverOnBuyMailboxParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - the number of unassigned domains in the page
 * @property {string} tab - assigned|unassigned|inactive
 * @property {string} totalInactiveDomains - the number of inactive domains in the page
 * @property {string} label - live|offline
 * @property {string} totalDomains - The number of domains on the page, if 0 - then empty state
 * @property {boolean} isPublished - true | false (is site published or not)
 * @property {string} registrar - wix | non-wix
 * @property {string} domainStatus - Domain status info. Replace “NULL” value to connected domain.
 * @property {string} totalConnectedDomains - the number of active domains in the page that are connected
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site or account level (check on the site level)
 * @property {string} totalAssignedDomains - the number of assigned domains in the page
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @return {LogObject<myDomainsHoverOnBuyMailboxParams>} LogObject<myDomainsHoverOnBuyMailboxParams>
 */
export function myDomainsHoverOnBuyMailbox(params) {
    return { evid: 528, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsRemoveYourDomainFromWix' event (evid: 529)
 *
 * Event description: Remove Your Domain\Subdomain pop-up on new My Domains page
 *
 * @param {myDomainsRemoveYourDomainFromWixParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain
 * @property {string} label - live|offline
 * @property {boolean} isPublished - is site published or not
 * @property {string} domainStatus - Domain status info. Replace “NULL” value to connected domain
 * @property {string} referralAdditionalInfo - where users came from
 * @property {string} domainLevel - primary | secondary
 * @property {GUID} msid - msid
 * @property {string} action - view | close | cancel | remove_domain | keep_domain_at_wix | keep_subdomain_at_wix
 * @return {LogObject<myDomainsRemoveYourDomainFromWixParams>} LogObject<myDomainsRemoveYourDomainFromWixParams>
 */
export function myDomainsRemoveYourDomainFromWix(params) {
    return { evid: 529, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsEditDnsActions' event (evid: 530)
 *
 * Event description: Edit DNS actions on Manage DNS page
 *
 * @param {myDomainsEditDnsActionsParams} params - The parameters for this event
 * @property {string} validationMessage - ok | error (exact error text)
 * @property {string} recordType - aname| cname | txt | spf | srv | mx
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} action - edit | cancel | remove | add_record | save (fact of adding a new record)
 * @property {string} record - JSON with attributes and their values for different record types
 * @return {LogObject<myDomainsEditDnsActionsParams>} LogObject<myDomainsEditDnsActionsParams>
 */
export function myDomainsEditDnsActions(params) {
    return { evid: 530, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'transferInIntroPage' event (evid: 531)
 *
 * Event description: Event for Intro page in new Transfer In flow
 *
 * @param {transferInIntroPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true | false
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - where users came from
 * @property {Url} referer - referral
 * @property {string} userType - free | premium
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInIntroPageParams>} LogObject<transferInIntroPageParams>
 */
export function transferInIntroPage(params) {
    return { evid: 531, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'transferInDomainPage' event (evid: 532)
 *
 * Event description: Event is generated when the user opens "Domain" page in Transfer In flow
 *
 * @param {transferInDomainPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} errorInfo - Error message, should be 'ok' for successes
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar for a domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - where users come from
 * @property {Url} referer - referral
 * @property {string} userType - free | premium
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - view | continue
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInDomainPageParams>} LogObject<transferInDomainPageParams>
 */
export function transferInDomainPage(params) {
    return { evid: 532, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'transferInPopUpInteractions' event (evid: 533)
 *
 * Event description: This event is generated on different modals in new Transfer In flow
 *
 * @param {transferInPopUpInteractionsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar for the  domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - domain_is_unavailable, cannot_transfer_domain, cannot_transfer_domain_without_sites
 * @property {string} popupType - domain_is_unavailable, cannot_transfer_domain, cannot_transfer_domain_without_sites
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInPopUpInteractionsParams>} LogObject<transferInPopUpInteractionsParams>
 */
export function transferInPopUpInteractions(params) {
    return { evid: 533, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'transferInClickEvents' event (evid: 534)
 *
 * Event description: Event is generated when a user interacts with different checkboxes and links on "Prepare" page of the new Transfer In flow
 *
 * @param {transferInClickEventsParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar for the domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {string} type - log_in, logged_in, unlocked_it, still_locked
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - log_in, logged_in, unlocked_it, still_locked
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInClickEventsParams>} LogObject<transferInClickEventsParams>
 */
export function transferInClickEvents(params) {
    return { evid: 534, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'transferInPreparePage' event (evid: 535)
 *
 * Event description: This event is generated when a user opens or interacts with buttons on "Prepare" page in the new Transfer In flow
 *
 * @param {transferInPreparePageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - Domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - Chosen registrar of the domain
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - view | continue
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInPreparePageParams>} LogObject<transferInPreparePageParams>
 */
export function transferInPreparePage(params) {
    return { evid: 535, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsPrivacyToggleActions' event (evid: 536)
 *
 * Event description: This event is triggered by changing the privacy on the Edit Contact Info page.
 *
 * @param {myDomainsPrivacyToggleActionsParams} params - The parameters for this event
 * @property {string} location - privacy_form | toast
 * @property {string} domain - Domain name
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} action - turn_on | turn_off | keep_privacy | close | open_turnoff_modal
 * @property {string} privacyType - privacy, privacy and DNSSEC
 * @return {LogObject<myDomainsPrivacyToggleActionsParams>} LogObject<myDomainsPrivacyToggleActionsParams>
 */
export function myDomainsPrivacyToggleActions(params) {
    return { evid: 536, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsRedemptionPopUp' event (evid: 537)
 *
 * Event description: Pop-ups interactions on redemption pop-up
 *
 * @param {myDomainsRedemptionPopUpParams} params - The parameters for this event
 * @property {DateTime} expirationDate - date of domain expiration
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {GUID} msid - msid
 * @property {string} action - view | redeemDomain
 * @return {LogObject<myDomainsRedemptionPopUpParams>} LogObject<myDomainsRedemptionPopUpParams>
 */
export function myDomainsRedemptionPopUp(params) {
    return { evid: 537, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsConciergeView' event (evid: 538)
 *
 * Event description: User viewed the Concierge page
 *
 * @param {domainsConciergeViewParams} params - The parameters for this event
 * @property {number} accountNumOfPropagatedDomains - account level
 * @property {string} viewMode - .
 * @property {string} voucher - true , false
 * @property {number} siteNumOfPropagatedDomains - site level
 * @property {string} locale - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {boolean} isSale - true, false
 * @return {LogObject<domainsConciergeViewParams>} LogObject<domainsConciergeViewParams>
 */
export function domainsConciergeView(params) {
    return { evid: 538, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeViewReadMoreClick' event (evid: 539)
 *
 * Event description: some actions inside the concierge
 *
 * @param {conciergeViewReadMoreClickParams} params - The parameters for this event
 * @property {string} viewMode - .
 * @property {string} voucher - true , false
 * @property {string} locale - .
 * @property {boolean} isPremiumSite - .
 * @property {string} actionName - learn more, contact support, hover (com.br hover)
 * @property {string} hasValidVouchers - .
 * @property {string} referralAdditionalInfo - .
 * @property {GUID} msid - site
 * @property {string} domain - The domain that was searched by the user
 * @return {LogObject<conciergeViewReadMoreClickParams>} LogObject<conciergeViewReadMoreClickParams>
 */
export function conciergeViewReadMoreClick(params) {
    return { evid: 539, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeViewIOwnClick' event (evid: 540)
 *
 * Event description: User clicked on "i own this domain"
 *
 * @param {conciergeViewIOwnClickParams} params - The parameters for this event
 * @property {string} viewMode - cocnierge, focusWidget, focusWidgetModal
 * @property {string} voucher - true , false
 * @property {string} voucherSupportedTlds - .
 * @property {GUID} siteOwnerId - .
 * @property {string} domainPermissions - .
 * @property {string} domain - domain name
 * @property {string} locale - .
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isEligibleForTransfer - true, false
 * @property {boolean} isPremiumPlansOnSale - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {string} sites - .
 * @property {string} hosting - .
 * @property {number} limit - .
 * @property {GUID} msid - site
 * @property {boolean} isSale - true, false
 * @property {string} referraladditionalinfo - referral
 * @return {LogObject<conciergeViewIOwnClickParams>} LogObject<conciergeViewIOwnClickParams>
 */
export function conciergeViewIOwnClick(params) {
    return { evid: 540, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumShowcaseClickToOnCtaToStartThePurchaseFlow' event (evid: 541)
 *
 * Event description: User clicked the CTA in the premium showcase to start the purchase flow.
 *
 * @param {premiumShowcaseClickToOnCtaToStartThePurchaseFlowParams} params - The parameters for this event
 * @property {string} offerType - product name (dynamic and not dynamic)
 * @return {LogObject<premiumShowcaseClickToOnCtaToStartThePurchaseFlowParams>} LogObject<premiumShowcaseClickToOnCtaToStartThePurchaseFlowParams>
 */
export function premiumShowcaseClickToOnCtaToStartThePurchaseFlow(params) {
    return { evid: 541, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumShowcaseClickedOnCarouselSlider' event (evid: 542)
 *
 * Event description: Premium Showcase -> clicked on Carousel Slider.
 *
 * @param {premiumShowcaseClickedOnCarouselSliderParams} params - The parameters for this event
 * @property {string} offerType - product name (dynamic and not dynamic)
 * @return {LogObject<premiumShowcaseClickedOnCarouselSliderParams>} LogObject<premiumShowcaseClickedOnCarouselSliderParams>
 */
export function premiumShowcaseClickedOnCarouselSlider(params) {
    return { evid: 542, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumShowcaseShowcaseLoaded' event (evid: 543)
 *
 * Event description: The user was exposed to premium showcase
 *
 * @param {premiumShowcaseShowcaseLoadedParams} params - The parameters for this event
 * @property {string} offerType - product name (dynamic and not dynamic)
 * @return {LogObject<premiumShowcaseShowcaseLoadedParams>} LogObject<premiumShowcaseShowcaseLoadedParams>
 */
export function premiumShowcaseShowcaseLoaded(params) {
    return { evid: 543, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeLittleHelper' event (evid: 544)
 *
 * Event description: Concierge Little Helper.
 *
 * @param {conciergeLittleHelperParams} params - The parameters for this event
 * @property {string} entryPoint - real entry point
 * @property {string} referringUrl - url where the user came from
 * @property {boolean} isVoucher - if the user has a domain voucher in the account
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {boolean} isAccountPremium - is the account premium
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - msid
 * @return {LogObject<conciergeLittleHelperParams>} LogObject<conciergeLittleHelperParams>
 */
export function conciergeLittleHelper(params) {
    return { evid: 544, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsTransferInDomainPopUp' event (evid: 545)
 *
 * Event description: User had an interaction with the transfer domain pop up in my domains
 *
 * @param {myDomainsTransferInDomainPopUpParams} params - The parameters for this event
 * @property {string} viewMode - account / site level
 * @property {string} domain - domain name
 * @property {boolean} isHover - is the view was from hover or from initial pop-up
 * @property {GUID} msid - site guid
 * @property {string} action - transfer / close / view
 * @return {LogObject<myDomainsTransferInDomainPopUpParams>} LogObject<myDomainsTransferInDomainPopUpParams>
 */
export function myDomainsTransferInDomainPopUp(params) {
    return { evid: 545, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsConciergeClickBack' event (evid: 546)
 *
 * Event description: user clicked back button in concierge page
 *
 * @param {domainsConciergeClickBackParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @return {LogObject<domainsConciergeClickBackParams>} LogObject<domainsConciergeClickBackParams>
 */
export function domainsConciergeClickBack(params) {
    return { evid: 546, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'searchDomainTransferInPopUp' event (evid: 547)
 *
 * Event description: In search domain, when user clicks on "I own this domain" and domain is eligible for transfer & site is premium
 *
 * @param {searchDomainTransferInPopUpParams} params - The parameters for this event
 * @property {string} viewMode - concierge, focusWidget
 * @property {string} voucher - true, false
 * @property {boolean} isConnectedDomainModal - true, false
 * @property {string} domain - domain
 * @property {string} locale - .
 * @property {string} registrar - registrar
 * @property {boolean} isVoucherModal - true, false
 * @property {boolean} isModal - true, false (is viewed via modal)
 * @property {boolean} isPremiumSite - true, false
 * @property {string} actionName - start_domain_transfer /connect_cta/no_thanks
 * @property {boolean} isVoucher - true, false
 * @property {string} hasValidVouchers - .
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {GUID} msid - msid
 * @property {boolean} isSale - true, false
 * @property {string} referraladditionalinfo - referral
 * @return {LogObject<searchDomainTransferInPopUpParams>} LogObject<searchDomainTransferInPopUpParams>
 */
export function searchDomainTransferInPopUp(params) {
    return { evid: 547, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'transferInDomainPageClickConnectDomaind' event (evid: 548)
 *
 * Event description: User clicked "Connecting your domain" in Transfer In Domains Page
 *
 * @param {transferInDomainPageClickConnectDomaindParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true , false
 * @property {string} domain - domain name
 * @property {GUID} uuid - uuid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {string} registrar - registrar
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {GUID} msid - site
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} action - action
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<transferInDomainPageClickConnectDomaindParams>} LogObject<transferInDomainPageClickConnectDomaindParams>
 */
export function transferInDomainPageClickConnectDomaind(params) {
    return { evid: 548, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'showDomainStatusMessageUi' event (evid: 549)
 *
 * Event description: User viewed the Domain Status message in UI (such as: "domain taken in wix" , "can connect", etc.)
 *
 * @param {showDomainStatusMessageUiParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} clickType - null , clicked_next, clicked_prev, clicked _link
 * @property {boolean} isPremiumSite - true, false
 * @property {string} isConcierge - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} uiStatus - ui domain status (can connect, domain is taken in WIX, etc.)
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {boolean} isSale - true. false
 * @property {string} referraladditionalinfo - user is referred from
 * @return {LogObject<showDomainStatusMessageUiParams>} LogObject<showDomainStatusMessageUiParams>
 */
export function showDomainStatusMessageUi(params) {
    return { evid: 549, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingView' event (evid: 550)
 *
 * Event description: Connect Domain Onboarding View  [Q.A: Don't see referral_additional_info. Maybe because there isn't in the test zone] [ event is fired for every search. don't need this as event 553 is there for this reason]
 *
 * @param {connectDomainOnboardingViewParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {GUID} userGuid - uuid
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingViewParams>} LogObject<connectDomainOnboardingViewParams>
 */
export function connectDomainOnboardingView(params) {
    return { evid: 550, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickNext' event (evid: 551)
 *
 * Event description: ConnectDomain > Onboarding Click Next
 *
 * @param {connectDomainOnboardingClickNextParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} rawInput - the raw value (domain name) that user entered in the search bar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainOnboardingClickNextParams>} LogObject<connectDomainOnboardingClickNextParams>
 */
export function connectDomainOnboardingClickNext(params) {
    return { evid: 551, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickBack' event (evid: 552)
 *
 * Event description: ConnectDomain > Onboarding Click Back
 *
 * @param {connectDomainOnboardingClickBackParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickBackParams>} LogObject<connectDomainOnboardingClickBackParams>
 */
export function connectDomainOnboardingClickBack(params) {
    return { evid: 552, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingSearchResult' event (evid: 553)
 *
 * Event description: ConnectDomain > Onboarding Search Result (All types)
 *
 * @param {connectDomainOnboardingSearchResultParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {string} result - The result (can be an error or not)
 * @property {boolean} wixdomain - true | false
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainOnboardingSearchResultParams>} LogObject<connectDomainOnboardingSearchResultParams>
 */
export function connectDomainOnboardingSearchResult(params) {
    return { evid: 553, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickChangeConnectMethod' event (evid: 554)
 *
 * Event description: ConnectDomain > Onboarding Click Change Connect Method
 *
 * @param {connectDomainOnboardingClickChangeConnectMethodParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickChangeConnectMethodParams>} LogObject<connectDomainOnboardingClickChangeConnectMethodParams>
 */
export function connectDomainOnboardingClickChangeConnectMethod(params) {
    return { evid: 554, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainChangeConnectMethodPopUpConfirm' event (evid: 555)
 *
 * Event description: ConnectDomain > Change Connect Method PopUp Confirm
 *
 * @param {connectDomainChangeConnectMethodPopUpConfirmParams} params - The parameters for this event
 * @property {string} method - pointing (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainChangeConnectMethodPopUpConfirmParams>} LogObject<connectDomainChangeConnectMethodPopUpConfirmParams>
 */
export function connectDomainChangeConnectMethodPopUpConfirm(params) {
    return { evid: 555, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainChangeConnectMethodPopUpCancel' event (evid: 556)
 *
 * Event description: ConnectDomain > Change Connect Method PopUp cancel or X
 *
 * @param {connectDomainChangeConnectMethodPopUpCancelParams} params - The parameters for this event
 * @property {string} method - pointing (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainChangeConnectMethodPopUpCancelParams>} LogObject<connectDomainChangeConnectMethodPopUpCancelParams>
 */
export function connectDomainChangeConnectMethodPopUpCancel(params) {
    return { evid: 556, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageView' event (evid: 557)
 *
 * Event description: ConnectDomain > Confirmation Page View Pop-Up.
 * From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageViewParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageViewParams>} LogObject<connectDomainGoDaddyConfirmationPageViewParams>
 */
export function connectDomainGoDaddyConfirmationPageView(params) {
    return { evid: 557, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickYes' event (evid: 558)
 *
 * Event description: Confirmation Page View Pop-Up > User clicked 'Yes, it's from "Registrar Name" '.
 * From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageClickYesParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickYesParams>} LogObject<connectDomainGoDaddyConfirmationPageClickYesParams>
 */
export function connectDomainGoDaddyConfirmationPageClickYes(params) {
    return { evid: 558, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickBack' event (evid: 559)
 *
 * Event description: Confirmation Page View Pop-Up > User clicked "Back" in the left bottom of the screen.  From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageClickBackParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickBackParams>} LogObject<connectDomainGoDaddyConfirmationPageClickBackParams>
 */
export function connectDomainGoDaddyConfirmationPageClickBack(params) {
    return { evid: 559, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuide' event (evid: 560)
 *
 * Event description: Confirmation Page View Pop-Up > User clicked 'No" ' From 08.08.2018 we have added field registrar (earlier we had only GoDaddy).
 *
 * @param {connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuideParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuideParams>} LogObject<connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuideParams>
 */
export function connectDomainGoDaddyConfirmationPageClickNoAndUseGenericGuide(params) {
    return { evid: 560, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainTutorialView' event (evid: 561)
 *
 * Event description: ConnectDomain > Tutorial View
 *
 * @param {connectDomainTutorialViewParams} params - The parameters for this event
 * @property {number} responseSpeed - How long is user waiting to see the tutorial page? (from 30 sec loader)
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} screenResolution - screen resolution
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainTutorialViewParams>} LogObject<connectDomainTutorialViewParams>
 */
export function connectDomainTutorialView(params) {
    return { evid: 561, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainTutorialClickSwitchType' event (evid: 562)
 *
 * Event description: ConnectDomain > Tutorial Click Switch Type
 *
 * @param {connectDomainTutorialClickSwitchTypeParams} params - The parameters for this event
 * @property {string} method - dns
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text ]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [Video tutorial / Textual tutorial] (the method you chose to change to)
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainTutorialClickSwitchTypeParams>} LogObject<connectDomainTutorialClickSwitchTypeParams>
 */
export function connectDomainTutorialClickSwitchType(params) {
    return { evid: 562, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainTutorialBack' event (evid: 563)
 *
 * Event description: ConnectDomain > Tutorial Back
 *
 * @param {connectDomainTutorialBackParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} screenResolution - screen resolution
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {string} place - top | bottom
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainTutorialBackParams>} LogObject<connectDomainTutorialBackParams>
 */
export function connectDomainTutorialBack(params) {
    return { evid: 563, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainClickGoToGoDaddy' event (evid: 564)
 *
 * Event description: ConnectDomain > Click go to GoDaddy
 *
 * @param {connectDomainClickGoToGoDaddyParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainClickGoToGoDaddyParams>} LogObject<connectDomainClickGoToGoDaddyParams>
 */
export function connectDomainClickGoToGoDaddy(params) {
    return { evid: 564, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainClickVerifyConnection' event (evid: 565)
 *
 * Event description: ConnectDomain > Click Verify Connection
 *
 * @param {connectDomainClickVerifyConnectionParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @return {LogObject<connectDomainClickVerifyConnectionParams>} LogObject<connectDomainClickVerifyConnectionParams>
 */
export function connectDomainClickVerifyConnection(params) {
    return { evid: 565, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainVerifyConnectionResultPageView' event (evid: 566)
 *
 * Event description: ConnectDomain > Verify  Connection Result
 *
 * @param {connectDomainVerifyConnectionResultPageViewParams} params - The parameters for this event
 * @property {number} responseSpeed - How long is user waiting to see the connection result page? (from click_verify)
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic] ((the tutorial that lead to this page)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {string} result - final result
 * @property {boolean} wixdomain - true | false
 * @property {GUID} userGuid - uuid
 * @property {string} mailbox - Has mailbox - true / false
 * @property {string} coupon - Currently, this field is used to understand if the user encounter free mailbox voucher banner
 * @property {boolean} isPublished - true | false
 * @property {string} subdomain - subdomain
 * @property {string} registrar - domain registrar
 * @property {string} expectedResult - the expected result originally
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} emailSale - 1 | 0
 * @property {string} tld - Top level domain (com, net, co.uk, etc)
 * @property {string} flowname - flow name (manual, entri)
 * @property {boolean} SawMailboxCTA - saw_mailbox_cta
 * @return {LogObject<connectDomainVerifyConnectionResultPageViewParams>} LogObject<connectDomainVerifyConnectionResultPageViewParams>
 */
export function connectDomainVerifyConnectionResultPageView(params) {
    return { evid: 566, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainResultPageClick' event (evid: 567)
 *
 * Event description: ConnectDomain > Result page click [Go to my Domains / Learn more / Back / Go to Editor / Buy a Mailbox / Change Connection to NS]
 *
 * @param {connectDomainResultPageClickParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic] (the tutorial that lead to this page)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {string} result - page name
 * @property {GUID} userGuid - uuid
 * @property {string} mailbox - saw mailbox promo - true / false
 * @property {boolean} isPublished - true | false
 * @property {string} clickType - string from button (buy a mailbox..)
 * @property {string} subdomain - subdomain
 * @property {string} registrar - registrar
 * @property {string} expectedResult - .
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} emailSale - 1 | 0
 * @property {string} tld - tld
 * @property {string} flowname - flow name (entri, manual)
 * @return {LogObject<connectDomainResultPageClickParams>} LogObject<connectDomainResultPageClickParams>
 */
export function connectDomainResultPageClick(params) {
    return { evid: 567, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyVideoClick' event (evid: 568)
 *
 * Event description: ConnectDomain > GoDaddy Video Click Play
 *
 * @param {connectDomainGoDaddyVideoClickParams} params - The parameters for this event
 * @property {string} method - dns
 * @property {number} step - [0,1,2,3,4,5]
 * @property {string} tutorialType - GoDaddy Video
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [start/ play / next step / replay]
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyVideoClickParams>} LogObject<connectDomainGoDaddyVideoClickParams>
 */
export function connectDomainGoDaddyVideoClick(params) {
    return { evid: 568, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainCopyData' event (evid: 569)
 *
 * Event description: ConnectDomain > Copy Data
 *
 * @param {connectDomainCopyDataParams} params - The parameters for this event
 * @property {string} method - pointing/dns
 * @property {string} tutorialType - [GoDaddy Video / GoDaddy Text / Generic]
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [DNS / A Record / CNAME Record]
 * @property {boolean} isSuccess - deprecated
 * @property {string} subdomain - subdomain
 * @property {string} recordLabel - the specific record being copied
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainCopyDataParams>} LogObject<connectDomainCopyDataParams>
 */
export function connectDomainCopyData(params) {
    return { evid: 569, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickGetDomainFromWix' event (evid: 570)
 *
 * Event description: ConnectDomain > Onboarding Click Get Domain From Wix A_onboardingClickPurchaseDomainLink
 *
 * @param {connectDomainOnboardingClickGetDomainFromWixParams} params - The parameters for this event
 * @property {string} method - pointing/dns (the method you chose to change to)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickGetDomainFromWixParams>} LogObject<connectDomainOnboardingClickGetDomainFromWixParams>
 */
export function connectDomainOnboardingClickGetDomainFromWix(params) {
    return { evid: 570, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingClickLearnMore' event (evid: 571)
 *
 * Event description: ConnectDomain > Onboarding Click Learn More
 *
 * @param {connectDomainOnboardingClickLearnMoreParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingClickLearnMoreParams>} LogObject<connectDomainOnboardingClickLearnMoreParams>
 */
export function connectDomainOnboardingClickLearnMore(params) {
    return { evid: 571, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUp' event (evid: 572)
 *
 * Event description: ConnectDomain > GoDaddy Confirmation Page Click I'm Not Sure  / Click Ok in the POP UP / Click close the POP UP.
 *
 * @param {connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUpParams} params - The parameters for this event
 * @property {string} method - pointing/dns (show the method you are in)
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain, can be null
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [open , ok , close]
 * @property {string} subdomain - subdomain
 * @property {string} registrar - Name of the Registrar
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUpParams>} LogObject<connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUpParams>
 */
export function connectDomainGoDaddyConfirmationPageClickImNotSureAndItSPopUp(params) {
    return { evid: 572, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainSiteSelectorView' event (evid: 573)
 *
 * Event description: Entering the connect domain flow from account level when you have more than one premium site
 *
 * @param {connectDomainSiteSelectorViewParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid , can be null
 * @return {LogObject<connectDomainSiteSelectorViewParams>} LogObject<connectDomainSiteSelectorViewParams>
 */
export function connectDomainSiteSelectorView(params) {
    return { evid: 573, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'copyOfConnectDomainSiteSelectorClick' event (evid: 574)
 *
 * Event description: Entering the connect domain flow from account level when you have more than one premium site
 *
 * @param {copyOfConnectDomainSiteSelectorClickParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - [choose_site / unchoose_site / next / back / learn_more]
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid , can be null
 * @return {LogObject<copyOfConnectDomainSiteSelectorClickParams>} LogObject<copyOfConnectDomainSiteSelectorClickParams>
 */
export function copyOfConnectDomainSiteSelectorClick(params) {
    return { evid: 574, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainChangeDomainSubHierarchyFlow' event (evid: 575)
 *
 * Event description: A user changes a flow from domain to a subdomain (or vice versa)
 *
 * @param {connectDomainChangeDomainSubHierarchyFlowParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain. User changed flow to ...
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - connect a subdomain/connect a domain
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainChangeDomainSubHierarchyFlowParams>} LogObject<connectDomainChangeDomainSubHierarchyFlowParams>
 */
export function connectDomainChangeDomainSubHierarchyFlow(params) {
    return { evid: 575, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingLearnMoreAboutSubdomain' event (evid: 576)
 *
 * Event description: A user clicks on Learn More button (connect subdomain page)
 *
 * @param {connectDomainOnboardingLearnMoreAboutSubdomainParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainOnboardingLearnMoreAboutSubdomainParams>} LogObject<connectDomainOnboardingLearnMoreAboutSubdomainParams>
 */
export function connectDomainOnboardingLearnMoreAboutSubdomain(params) {
    return { evid: 576, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainPopUpInteractions' event (evid: 577)
 *
 * Event description: A user interacts(cancel/confirm) with Pop-up banners.
 *
 * @param {connectDomainPopUpInteractionsParams} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {string} result - connection status
 * @property {GUID} userGuid - uuid
 * @property {string} clickType - cancel/confirm
 * @property {string} subdomain - subdomain
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainPopUpInteractionsParams>} LogObject<connectDomainPopUpInteractionsParams>
 */
export function connectDomainPopUpInteractions(params) {
    return { evid: 577, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainSupportArticleClick' event (evid: 578)
 *
 * Event description: A user interacts with links to support articles.
 *
 * @param {connectDomainSupportArticleClickParams} params - The parameters for this event
 * @property {string} method - dns/pointing
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain part
 * @property {string} registrar - registrar
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} articleId - article Id
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainSupportArticleClickParams>} LogObject<connectDomainSupportArticleClickParams>
 */
export function connectDomainSupportArticleClick(params) {
    return { evid: 578, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainWixAnswersLoader' event (evid: 579)
 *
 * Event description: It tells us if the Wix Answers page was successfully loaded. (LOADING_SUCCEED, SHOULD_NOT_LOAD, LOADING_FAILED
 * )
 *
 * @param {connectDomainWixAnswersLoaderParams} params - The parameters for this event
 * @property {string} method - dns/pointing
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - can be null if user didn't enter a domain/subdomain name
 * @property {GUID} userGuid - uuid
 * @property {string} subdomain - subdomain part
 * @property {string} registrar - registrar
 * @property {string} status - LOADING_SUCCEED, SHOULD_NOT_LOAD, LOADING_FAILED
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @return {LogObject<connectDomainWixAnswersLoaderParams>} LogObject<connectDomainWixAnswersLoaderParams>
 */
export function connectDomainWixAnswersLoader(params) {
    return { evid: 579, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainFatalErrorPageView' event (evid: 580)
 *
 * Event description: Users see Fatal Error Page 'Looks something went wrong'.
 *
 * @param {connectDomainFatalErrorPageViewParams} params - The parameters for this event
 * @property {string} errorInfo - Javascript code for Devs
 * @property {GUID} userGuid - uuid
 * @property {string} screenResolution - screen resolution
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null
 * @property {string} previousStep - /search-domain, /confirm-domain, etc
 * @return {LogObject<connectDomainFatalErrorPageViewParams>} LogObject<connectDomainFatalErrorPageViewParams>
 */
export function connectDomainFatalErrorPageView(params) {
    return { evid: 580, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainUnassignedDomains' event (evid: 582)
 *
 * Event description: If a user has unassigned successfully connected domains we will show to him the list of them
 *
 * @param {connectDomainUnassignedDomainsParams} params - The parameters for this event
 * @property {string} voucher - true, false
 * @property {string} domain - domain names comma separated
 * @property {string} viewmode - .
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {string} action - view | show | hide | choose_domain
 * @property {boolean} isSale - true, false
 * @return {LogObject<connectDomainUnassignedDomainsParams>} LogObject<connectDomainUnassignedDomainsParams>
 */
export function connectDomainUnassignedDomains(params) {
    return { evid: 582, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'supportChatInDomainFunnels' event (evid: 583)
 *
 * Event description: Support Chat appears in different funnels in domain flow, tool tip appears after chat in 5 seconds
 *
 * @param {supportChatInDomainFunnelsParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} place - connect_domain | domain_search | transfer_in
 * @property {string} type - chat | tooltip
 * @property {string} action - view | open | close | started_chat
 * @return {LogObject<supportChatInDomainFunnelsParams>} LogObject<supportChatInDomainFunnelsParams>
 */
export function supportChatInDomainFunnels(params) {
    return { evid: 583, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainOnboardingBreadcrumbsClick' event (evid: 584)
 *
 * Event description: It fires when a user clicks on breadcrumbs.
 *
 * @param {connectDomainOnboardingBreadcrumbsClickParams} params - The parameters for this event
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} text - breadcrumbs text
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} place - onboarding | tutorial | etc
 * @property {GUID} msid - msid
 * @return {LogObject<connectDomainOnboardingBreadcrumbsClickParams>} LogObject<connectDomainOnboardingBreadcrumbsClickParams>
 */
export function connectDomainOnboardingBreadcrumbsClick(params) {
    return { evid: 584, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomainEmptyStateClickReadMor' event (evid: 585)
 *
 * Event description: Click Read More in the Connect Domain Empty State
 *
 * @param {connectDomainEmptyStateClickReadMorParams} params - The parameters for this event
 * @property {string} viewMode - accountLevel, siteLevel
 * @property {string} voucher - true, false
 * @property {string} totalUnassignedDomains - number of domains
 * @property {string} totalInactiveDomains - number of domains
 * @property {GUID} userGuid - uuid
 * @property {string} domains - list of all domains
 * @property {string} totalDomains - number of domains
 * @property {boolean} emptyState - true, false
 * @property {boolean} isPublished - true, false
 * @property {string} clickType - which article the user clicked
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} totalConnectedDomains - number of domains
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {boolean} isAccountPremium - true, false
 * @property {boolean} isPremium - true, false
 * @property {string} totalAssignedDomains - number of domains
 * @property {GUID} msid - msid, can be null
 * @property {boolean} isSale - true, false
 * @return {LogObject<connectDomainEmptyStateClickReadMorParams>} LogObject<connectDomainEmptyStateClickReadMorParams>
 */
export function connectDomainEmptyStateClickReadMor(params) {
    return { evid: 585, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainConnectPopupDomainIsAssignedToAnotherWixAccount' event (evid: 586)
 *
 * Event description: Domain popup in concierge - domain is assigned to another wix account
 *
 * @param {domainConnectPopupDomainIsAssignedToAnotherWixAccountParams} params - The parameters for this event
 * @property {GUID} userGuid - uuid
 * @property {string} domain - domain, can be null
 * @property {string} uuid - uuid
 * @property {string} referralAdditionalInfo - The original referral additional info of the flow
 * @property {GUID} msid - msid, can be null
 * @property {string} action - view, close, learn_more
 * @return {LogObject<domainConnectPopupDomainIsAssignedToAnotherWixAccountParams>} LogObject<domainConnectPopupDomainIsAssignedToAnotherWixAccountParams>
 */
export function domainConnectPopupDomainIsAssignedToAnotherWixAccount(params) {
    return { evid: 586, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsHoverOnInfoSign' event (evid: 587)
 *
 * Event description: This event should be triggered when user hovers on info sign and sees a flying box.
 *
 * @param {myDomainsHoverOnInfoSignParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} text - transfer to wix, extend
 * @property {GUID} msid - msid
 * @property {string} action - view
 * @return {LogObject<myDomainsHoverOnInfoSignParams>} LogObject<myDomainsHoverOnInfoSignParams>
 */
export function myDomainsHoverOnInfoSign(params) {
    return { evid: 587, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeReAssignDomainModal' event (evid: 588)
 *
 * Event description: re-assign domain modal between sites
 *
 * @param {conciergeReAssignDomainModalParams} params - The parameters for this event
 * @property {string} viewMode - concierge , purchase
 * @property {string} voucher - true | false
 * @property {GUID} targetMsid - targeted msid
 * @property {string} uuid - uuid
 * @property {string} search_term - domain searched
 * @property {boolean} isPremiumSite - true / false
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {boolean} isAccountPremium - true / false
 * @property {boolean} isPremium - true / false
 * @property {boolean} isSiteEqualTargetedSite - true / false
 * @property {GUID} msid - msid
 * @return {LogObject<conciergeReAssignDomainModalParams>} LogObject<conciergeReAssignDomainModalParams>
 */
export function conciergeReAssignDomainModal(params) {
    return { evid: 588, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'entriEligibilityLittleHelper' event (evid: 589)
 *
 * Event description: little helper to indicate that the domain is eligible to be connected via Entri (for test purposes)
 *
 * @param {entriEligibilityLittleHelperParams} params - The parameters for this event
 * @property {string} entryPoint - i_own_this_domain, transfer_modal_click_connect
 * @property {string} domain - domain
 * @property {boolean} isEligible - is eligible to entri
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @return {LogObject<entriEligibilityLittleHelperParams>} LogObject<entriEligibilityLittleHelperParams>
 */
export function entriEligibilityLittleHelper(params) {
    return { evid: 589, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'whoisPageView' event (evid: 590)
 *
 * Event description: Users saw WHOIS page
 *
 * @param {whoisPageViewParams} params - The parameters for this event
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @return {LogObject<whoisPageViewParams>} LogObject<whoisPageViewParams>
 */
export function whoisPageView(params) {
    return { evid: 590, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeWatchVideoCta' event (evid: 591)
 *
 * Event description: user click on "watch video" in concierge (best domain search tutorial)
 *
 * @param {conciergeWatchVideoCtaParams} params - The parameters for this event
 * @property {string} voucher - voucher
 * @property {string} uuid - uuid
 * @property {boolean} isPremiumSite - true, false
 * @property {number} totalPlayTime - time watch in seconds
 * @property {GUID} msid - site
 * @property {string} action - view, play, pause, close
 * @property {string} referraladditionalinfo - refereal
 * @return {LogObject<conciergeWatchVideoCtaParams>} LogObject<conciergeWatchVideoCtaParams>
 */
export function conciergeWatchVideoCta(params) {
    return { evid: 591, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'whoisClickSubmit' event (evid: 592)
 *
 * Event description: User clicked on submit button
 *
 * @param {whoisClickSubmitParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @return {LogObject<whoisClickSubmitParams>} LogObject<whoisClickSubmitParams>
 */
export function whoisClickSubmit(params) {
    return { evid: 592, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'whoisClickSubmitResult' event (evid: 593)
 *
 * Event description: Result after Submit click
 *
 * @param {whoisClickSubmitResultParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} result - success/failure
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {string} resultCode - server results
 * @return {LogObject<whoisClickSubmitResultParams>} LogObject<whoisClickSubmitResultParams>
 */
export function whoisClickSubmitResult(params) {
    return { evid: 593, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsConciergeVideoPopupActionsBestDomainSearch' event (evid: 594)
 *
 * Event description: Best domain search video actions (in Concierge)
 *
 * @param {domainsConciergeVideoPopupActionsBestDomainSearchParams} params - The parameters for this event
 * @property {string} voucher - true , false
 * @property {string} uuid - uuid
 * @property {number} fractionWatched - time watched / video duration
 * @property {string} referralAdditionalInfo - concierge
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} action - view, play, pause, close_popup
 * @return {LogObject<domainsConciergeVideoPopupActionsBestDomainSearchParams>} LogObject<domainsConciergeVideoPopupActionsBestDomainSearchParams>
 */
export function domainsConciergeVideoPopupActionsBestDomainSearch(params) {
    return { evid: 594, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsCtas' event (evid: 595)
 *
 * Event description: clicks & views in Domains pages
 *
 * @param {domainsCtasParams} params - The parameters for this event
 * @property {string} viewMode - account level, site level
 * @property {string} voucher - true, false
 * @property {string} conciergeStatus - search results error (only from concierge)
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} clickType - click type
 * @property {string} status - domain status
 * @property {boolean} isPremiumSite - true, false
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - site
 * @return {LogObject<domainsCtasParams>} LogObject<domainsCtasParams>
 */
export function domainsCtas(params) {
    return { evid: 595, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeFonzyResellerView' event (evid: 596)
 *
 * Event description: User viewed Fonzy page (Concierge for resellers)
 *
 * @param {conciergeFonzyResellerViewParams} params - The parameters for this event
 * @property {number} accountNumOfPropagatedDomains - account level
 * @property {string} voucher - true , false
 * @property {number} siteNumOfPropagatedDomains - site level
 * @property {string} intent - connect domain
 * @property {string} referralAdditionalInfo - domain_connect_domain , buy_a_domain , connect_domain_you_already_own , domains-item
 * @property {string} pageType - reseller
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @return {LogObject<conciergeFonzyResellerViewParams>} LogObject<conciergeFonzyResellerViewParams>
 */
export function conciergeFonzyResellerView(params) {
    return { evid: 596, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeFonzyResellerAction' event (evid: 597)
 *
 * Event description: actions in Fonzy page (Concierge for resellers)
 *
 * @param {conciergeFonzyResellerActionParams} params - The parameters for this event
 * @property {string} conciergeStatus - concierge status
 * @property {string} errorInfo - error (if applicable)
 * @property {string} domain - domain
 * @property {string} availabilityStatus - status of domain
 * @property {string} connectionStatus - domain connection status
 * @property {string} pageType - reseller
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} action - lets_go
 * @return {LogObject<conciergeFonzyResellerActionParams>} LogObject<conciergeFonzyResellerActionParams>
 */
export function conciergeFonzyResellerAction(params) {
    return { evid: 597, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'conciergeFonzyResellerModal' event (evid: 598)
 *
 * Event description: modal & actions in Fonzy page (Concierge for resellers)
 *
 * @param {conciergeFonzyResellerModalParams} params - The parameters for this event
 * @property {string} modalType - modal type
 * @property {string} domain - domain
 * @property {string} pageType - reseller
 * @property {boolean} isPremium - is the site premium
 * @property {GUID} msid - site
 * @property {string} action - action type
 * @return {LogObject<conciergeFonzyResellerModalParams>} LogObject<conciergeFonzyResellerModalParams>
 */
export function conciergeFonzyResellerModal(params) {
    return { evid: 598, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'new9000' event (evid: 61)
 *
 * Event description: Domain status which users see on My Domain Page. It fires after event 40 and when we receive information from back/front end.
 *
 * @param {new9000Params} params - The parameters for this event
 * @property {string} domainHierarchy - main-domain / sub-domain
 * @property {string} domain - domain
 * @property {GUID} userGuid - uuid
 * @property {string} registrar - name of the domain registrar
 * @property {string} status - Domain status info. 'null' also means that a domain is managed by WIX (connected, not assigned, etc) or we don't have any message there (like a connected domain successfully connected)
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {string} domainLevel - level of the domain (primary / secondary). It also returns value if a domain not assigned to a site on the account level.
 * @property {GUID} msid - msid,  if a user looks on the domain from the account level msid will be null
 * @return {LogObject<new9000Params>} LogObject<new9000Params>
 */
export function new9000(params) {
    return { evid: 61, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'new9001' event (evid: 62)
 *
 * Event description: 1. When a user clicks on "Edit DNS" we will show him the Warning pop-up.
 * 2. When a user change/edit or delete A +/or CNAME records and click "Save DNS" we will show Confirm pop-up.
 *
 * @param {new9001Params} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {GUID} uuid - user id
 * @property {string} clickType - open| cancel | confirm | learn more
 * @property {string} popup_type - editing your dns records | save dns record changes
 * @property {string} status - domain status
 * @property {string} referralAdditionalInfo - where did he get to this page
 * @property {GUID} msid - msid, can be null if a user look on domain from account level
 * @return {LogObject<new9001Params>} LogObject<new9001Params>
 */
export function new9001(params) {
    return { evid: 62, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aTpaClickOnCancel' event (evid: 620)
 *
 * Event description: A_TpaClickOnCancel
 *
 * @param {aTpaClickOnCancelParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {GUID} tpaSkuId - tpa_sku_guid
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aTpaClickOnCancelParams>} LogObject<aTpaClickOnCancelParams>
 */
export function aTpaClickOnCancel(params) {
    return { evid: 620, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageView' event (evid: 636)
 *
 * Event description: Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainSuccessPageViewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @return {LogObject<redeemDomainSuccessPageViewParams>} LogObject<redeemDomainSuccessPageViewParams>
 */
export function redeemDomainSuccessPageView(params) {
    return { evid: 636, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsToastShown' event (evid: 637)
 *
 * Event description: MyDomains > toast shown (Success, payment success, failed, etc.)
 *
 * @param {myDomainsToastShownParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {string} type - domain_redeem_payment_success
 * @return {LogObject<myDomainsToastShownParams>} LogObject<myDomainsToastShownParams>
 */
export function myDomainsToastShown(params) {
    return { evid: 637, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'redeemDomainPageView' event (evid: 638)
 *
 * Event description: Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainPageViewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - domain_already_active, redeem_in_process, redeem_temporary_fail, redeem_failed
 * @return {LogObject<redeemDomainPageViewParams>} LogObject<redeemDomainPageViewParams>
 */
export function redeemDomainPageView(params) {
    return { evid: 638, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'redeemDomainPageCta' event (evid: 639)
 *
 * Event description: CTA click in Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainPageCtaParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {string} clickType - go_to_my_domains, contact_customer_care
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - domain_already_active, redeem_in_process, redeem_temporary_fail, redeem_failed
 * @return {LogObject<redeemDomainPageCtaParams>} LogObject<redeemDomainPageCtaParams>
 */
export function redeemDomainPageCta(params) {
    return { evid: 639, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'copyNsRecords' event (evid: 64)
 *
 * Event description: Copy NS records from tutorial widget
 *
 * @param {copyNsRecordsParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {boolean} isSuccess - success for Copy NS records
 * @property {string} place - domain_level
 * @return {LogObject<copyNsRecordsParams>} LogObject<copyNsRecordsParams>
 */
export function copyNsRecords(params) {
    return { evid: 64, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsPixelCheck' event (evid: 640)
 *
 * Event description: We check if a user can access his domain through the Internet.
 *
 * @param {domainsPixelCheckParams} params - The parameters for this event
 * @property {boolean} success - true/false
 * @property {string} domain - domain name
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} details - ONE_OR_BOTH_NOT_RESOLVING |ALL_RESOLVING
 * @property {string} place - connect_domain_flow/domain_management
 * @property {GUID} msid - msid of the site that we check
 * @return {LogObject<domainsPixelCheckParams>} LogObject<domainsPixelCheckParams>
 */
export function domainsPixelCheck(params) {
    return { evid: 640, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'manageDomainsRedemptionPopUp' event (evid: 641)
 *
 * Event description: Redemption Pop-up for Unpaid .com.br, .mx, .me domains in the Last 4-3 Days Prior to Expiry. We don't send this event if a user clicks on 'close' icon (technical restriction).
 *
 * @param {manageDomainsRedemptionPopUpParams} params - The parameters for this event
 * @property {string} domain - domain name
 * @property {string} popup_type - redemption_pop_up
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {GUID} msid - msid
 * @property {string} action - view/close/cancel/learn_how
 * @return {LogObject<manageDomainsRedemptionPopUpParams>} LogObject<manageDomainsRedemptionPopUpParams>
 */
export function manageDomainsRedemptionPopUp(params) {
    return { evid: 641, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageCta' event (evid: 642)
 *
 * Event description: CTA click in Redeem page after trying to redeem your domain
 *
 * @param {redeemDomainSuccessPageCtaParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {string} uuid - user guid
 * @property {string} clickType - go_to_my_domains
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @return {LogObject<redeemDomainSuccessPageCtaParams>} LogObject<redeemDomainSuccessPageCtaParams>
 */
export function redeemDomainSuccessPageCta(params) {
    return { evid: 642, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageViewNew' event (evid: 643)
 *
 * Event description: Redeem page after trying to redeem your domain (new)
 *
 * @param {redeemDomainSuccessPageViewNewParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} packagePickerType - package_picker_type
 * @property {string} domain - domain name
 * @property {GUID} uuid - user guid
 * @property {string} acceptLang - accept_lng
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {Url} referer - referral
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @return {LogObject<redeemDomainSuccessPageViewNewParams>} LogObject<redeemDomainSuccessPageViewNewParams>
 */
export function redeemDomainSuccessPageViewNew(params) {
    return { evid: 643, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'redeemDomainSuccessPageCtaNew' event (evid: 644)
 *
 * Event description: CTA click in Redeem page after trying to redeem your domain (new)
 *
 * @param {redeemDomainSuccessPageCtaNewParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} domain - domain name
 * @property {GUID} uuid - user guid
 * @property {string} clickType - go_to_my_domains
 * @property {boolean} hasApi - whether domain has redeem API - true, false
 * @property {string} type - redeem_success
 * @return {LogObject<redeemDomainSuccessPageCtaNewParams>} LogObject<redeemDomainSuccessPageCtaNewParams>
 */
export function redeemDomainSuccessPageCtaNew(params) {
    return { evid: 644, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'new402' event (evid: 65)
 *
 * Event description: Get current NS records from New API (Check Task results).
 *
 * @param {new402Params} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} aName - A Name
 * @property {string} wixNs - true/false/null(not resolving, propagation)
 * @property {string} cName - C Name
 * @property {string} nsRecords - NS records
 * @property {string} referralAdditionalInfo - referral additional info
 * @return {LogObject<new402Params>} LogObject<new402Params>
 */
export function new402(params) {
    return { evid: 65, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainManagementGetNsWithCheckTaskError' event (evid: 66)
 *
 * Event description: Get current NS records from New API - Error.
 *
 * @param {domainManagementGetNsWithCheckTaskErrorParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} type - type of the error
 * @return {LogObject<domainManagementGetNsWithCheckTaskErrorParams>} LogObject<domainManagementGetNsWithCheckTaskErrorParams>
 */
export function domainManagementGetNsWithCheckTaskError(params) {
    return { evid: 66, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkCreatePaymentRequestTooltip' event (evid: 671)
 *
 * Event description: View/click inside the create a payment request tooltip.
 *
 * @param {payLinkCreatePaymentRequestTooltipParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {string} clickType - null (for view), ‘close’, ‘create a payment request’
 * @property {DateTime} payByDate - client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - is_coupon_used - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkCreatePaymentRequestTooltipParams>} LogObject<payLinkCreatePaymentRequestTooltipParams>
 */
export function payLinkCreatePaymentRequestTooltip(params) {
    return { evid: 671, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkSendRequestConfirmationModalViewClick' event (evid: 672)
 *
 * Event description: View/click inside the create a payment request Send Request confirmation modal.
 *
 * @param {payLinkSendRequestConfirmationModalViewClickParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {string} clickType - null (for view), ‘send request’, ‘close’, ‘x’
 * @property {DateTime} payByDate - pay_by_date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkSendRequestConfirmationModalViewClickParams>} LogObject<payLinkSendRequestConfirmationModalViewClickParams>
 */
export function payLinkSendRequestConfirmationModalViewClick(params) {
    return { evid: 672, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestSendSuccessPageView' event (evid: 673)
 *
 * Event description: View Payment request send success page
 *
 * @param {payLinkPaymentRequestSendSuccessPageViewParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {string} pageType - whatever
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - request_creator_account_id
 * @property {string} productname - product_name
 * @return {LogObject<payLinkPaymentRequestSendSuccessPageViewParams>} LogObject<payLinkPaymentRequestSendSuccessPageViewParams>
 */
export function payLinkPaymentRequestSendSuccessPageView(params) {
    return { evid: 673, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestSentSuccessPageClick' event (evid: 674)
 *
 * Event description: Click inside Payment request send success page
 *
 * @param {payLinkPaymentRequestSentSuccessPageClickParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {string} clickType - 'copy link', 'refreshing this page'
 * @property {DateTime} payByDate - pay_by_date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - is_coupon_used
 * @property {string} productId - product_guid
 * @property {string} pageType - page type
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - request_creator_account_id
 * @property {string} productname - product_name
 * @return {LogObject<payLinkPaymentRequestSentSuccessPageClickParams>} LogObject<payLinkPaymentRequestSentSuccessPageClickParams>
 */
export function payLinkPaymentRequestSentSuccessPageClick(params) {
    return { evid: 674, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestErrorModal' event (evid: 675)
 *
 * Event description: User got an error message after trying to send a pay link payment request
 *
 * @param {payLinkPaymentRequestErrorModalParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {string} clickType - null (if no click), ‘Refresh the page’, ‘Send Request’, close, ‘x’
 * @property {string} errorType - ‘technical issue’, ‘network issue’, ‘server issue’, etc.
 * @property {DateTime} payByDate - pay_by_date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - is_coupon_used
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestErrorModalParams>} LogObject<payLinkPaymentRequestErrorModalParams>
 */
export function payLinkPaymentRequestErrorModal(params) {
    return { evid: 675, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestCompletedSuccessPageView' event (evid: 676)
 *
 * Event description: Payment request completed success page view
 *
 * @param {payLinkPaymentRequestCompletedSuccessPageViewParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productName - product name
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - partner who created the pay link request -account id
 * @return {LogObject<payLinkPaymentRequestCompletedSuccessPageViewParams>} LogObject<payLinkPaymentRequestCompletedSuccessPageViewParams>
 */
export function payLinkPaymentRequestCompletedSuccessPageView(params) {
    return { evid: 676, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestCompletedSuccessPageClick' event (evid: 677)
 *
 * Event description: click on Payment request completed success page
 *
 * @param {payLinkPaymentRequestCompletedSuccessPageClickParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - 'Premium Subscriptions'
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productName - product_name
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @property {GUID} requestCreatorAccountId - partner who created the request
 * @return {LogObject<payLinkPaymentRequestCompletedSuccessPageClickParams>} LogObject<payLinkPaymentRequestCompletedSuccessPageClickParams>
 */
export function payLinkPaymentRequestCompletedSuccessPageClick(params) {
    return { evid: 677, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'payLinkPaymentRequestClientSideErrorPage' event (evid: 678)
 *
 * Event description: client side Payment request client side error page
 *
 * @param {payLinkPaymentRequestClientSideErrorPageParams} params - The parameters for this event
 * @property {string} externalSessionId - external_session_id
 * @property {GUID} paymentRequestId - payment_request_id
 * @property {string} clickType - 'refresh'
 * @property {string} errorType - 'email don't have permissions', 'request expired', 'already premium', 'site deleted', 'load error', 'service not available',
 * @property {DateTime} payByDate - pay_by_date, client can pay by date
 * @property {string} cycleName - cycle_name
 * @property {boolean} isCouponUsed - true if coupon was injected
 * @property {string} productId - product_guid
 * @property {GUID} msid - msid
 * @return {LogObject<payLinkPaymentRequestClientSideErrorPageParams>} LogObject<payLinkPaymentRequestClientSideErrorPageParams>
 */
export function payLinkPaymentRequestClientSideErrorPage(params) {
    return { evid: 678, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'voucherClickOnHowToClaim' event (evid: 680)
 *
 * Event description: Click on "how do I claim my vouchers"
 *
 * @param {voucherClickOnHowToClaimParams} params - The parameters for this event
 * @property {string} voucherType - domain/google/bing/local_listing_US/local_listing_CA/Yandex
 * @return {LogObject<voucherClickOnHowToClaimParams>} LogObject<voucherClickOnHowToClaimParams>
 */
export function voucherClickOnHowToClaim(params) {
    return { evid: 680, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'voucherClickOnClaimVoucher' event (evid: 681)
 *
 * Event description: click on 'get your domain/list your business/claim voucher'
 *
 * @param {voucherClickOnClaimVoucherParams} params - The parameters for this event
 * @property {string} reseller - reseller guid if applicable
 * @property {string} pageType - default, reseller
 * @property {string} voucherType - domain/google/bing/local_listing_US/local_listing_CA/Yandex
 * @return {LogObject<voucherClickOnClaimVoucherParams>} LogObject<voucherClickOnClaimVoucherParams>
 */
export function voucherClickOnClaimVoucher(params) {
    return { evid: 681, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'voucherClickDropDown' event (evid: 682)
 *
 * Event description: Click on the drop-down to see more vouchers (the page opens with one visible voucher from each voucher type, you have to click the drop-down arrow to see the rest)
 *
 * @param {voucherClickDropDownParams} params - The parameters for this event
 * @property {string} clickType - open/close
 * @property {string} voucherType - domain/google/bing/local_listing_US/local_listing_CA/Yandex
 * @return {LogObject<voucherClickDropDownParams>} LogObject<voucherClickDropDownParams>
 */
export function voucherClickDropDown(params) {
    return { evid: 682, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'entriIntroModal' event (evid: 685)
 *
 * Event description: little helper to indicate that the domain is eligible to be connected via Entri (for test purposes)
 *
 * @param {entriIntroModalParams} params - The parameters for this event
 * @property {string} action_name - view, continue, go_to_our_manual_setup, learn_more, close
 * @property {string} domain - domain
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @return {LogObject<entriIntroModalParams>} LogObject<entriIntroModalParams>
 */
export function entriIntroModal(params) {
    return { evid: 685, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'entriFlowResult' event (evid: 686)
 *
 * Event description: The onEntriClose callback is triggered, and this is the result
 *
 * @param {entriFlowResultParams} params - The parameters for this event
 * @property {string} provider - provider detected
 * @property {string} domain - domain
 * @property {string} errorMsg - error message if existed
 * @property {boolean} isSuccess - true, false
 * @property {string} setupType - entri setup type
 * @property {string} lastStep - last step the user experienced
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @return {LogObject<entriFlowResultParams>} LogObject<entriFlowResultParams>
 */
export function entriFlowResult(params) {
    return { evid: 686, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'entriFlowLeaveFunnel' event (evid: 687)
 *
 * Event description: when user clicks "go to our manual setup" or close the modal
 *
 * @param {entriFlowLeaveFunnelParams} params - The parameters for this event
 * @property {string} domain - domain
 * @property {string} lastStep - the step the user clicks and left the flow
 * @property {string} referralAdditionalInfo - original referral additional info
 * @property {GUID} msid - msid
 * @property {string} action_type - close, go_to_our_manual_flow
 * @return {LogObject<entriFlowLeaveFunnelParams>} LogObject<entriFlowLeaveFunnelParams>
 */
export function entriFlowLeaveFunnel(params) {
    return { evid: 687, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'entriStepView' event (evid: 688)
 *
 * Event description: This event is triggered each time a different screen is shown within the Entri configuration process
 *
 * @param {entriStepViewParams} params - The parameters for this event
 * @property {string} provider - provider, if known
 * @property {string} domain - domain
 * @property {string} stepName - Entri step
 * @property {GUID} msid - msid, if known
 * @property {string} errorMsg - error message
 * @return {LogObject<entriStepViewParams>} LogObject<entriStepViewParams>
 */
export function entriStepView(params) {
    return { evid: 688, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aOpenMicrosoftActivateDlg' event (evid: 724)
 *
 * Event description: A_OpenMicrosoftActivateDlg.
 *
 * @param {aOpenMicrosoftActivateDlgParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<aOpenMicrosoftActivateDlgParams>} LogObject<aOpenMicrosoftActivateDlgParams>
 */
export function aOpenMicrosoftActivateDlg(params) {
    return { evid: 724, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCancelSubscriptionLoaded' event (evid: 7770)
 *
 * Event description: My Subscriptions >  cancel popup > loaded
 *
 * @param {mySubscriptionsCancelSubscriptionLoadedParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isInTrial - true /false
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCancelSubscriptionLoadedParams>} LogObject<mySubscriptionsCancelSubscriptionLoadedParams>
 */
export function mySubscriptionsCancelSubscriptionLoaded(params) {
    return { evid: 7770, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsClickCancel' event (evid: 7773)
 *
 * Event description: My Subscriptions >  click "Cancel"
 * dynamic (like 4)
 *
 * @param {mySubscriptionsClickCancelParams} params - The parameters for this event
 * @property {string} viewMode - accountLevel / siteLevel
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isInTrial - is_in_trial
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {GUID} msid - msid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsClickCancelParams>} LogObject<mySubscriptionsClickCancelParams>
 */
export function mySubscriptionsClickCancel(params) {
    return { evid: 7773, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCancelPopupClick' event (evid: 7774)
 *
 * Event description: My Subscriptions >  cancel popup > click
 *
 * @param {mySubscriptionsCancelPopupClickParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - keep / cancel / close X
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isinTrial - true /false
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} choice - Keep, auto-renew-off, Cancel now
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {GUID} msid - msid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCancelPopupClickParams>} LogObject<mySubscriptionsCancelPopupClickParams>
 */
export function mySubscriptionsCancelPopupClick(params) {
    return { evid: 7774, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'mySubscriptionsCancelPopup2ndStepClick' event (evid: 7775)
 *
 * Event description: My Subscriptions >  cancel popup  2nd step > click
 *
 * @param {mySubscriptionsCancelPopup2ndStepClickParams} params - The parameters for this event
 * @property {string} viewMode - view_mode
 * @property {GUID} subscriptionId - subscription_id
 * @property {string} clickType - Keep, auto-renew-off,Cancel now
 * @property {string} productTypeName - product_type_name
 * @property {boolean} isInTrial - is_in_trial
 * @property {string} productTypeId - product_type_id
 * @property {string} productName - product_name
 * @property {string} type - partners/diy
 * @property {string} productGuid - product_guid
 * @property {GUID} msid - msid
 * @property {string} referraladditionalinfo - referraladditionalinfo
 * @property {number} cycleId - cycle_id
 * @property {string} assetVersion - indication - Cairo or old
 * @return {LogObject<mySubscriptionsCancelPopup2ndStepClickParams>} LogObject<mySubscriptionsCancelPopup2ndStepClickParams>
 */
export function mySubscriptionsCancelPopup2ndStepClick(params) {
    return { evid: 7775, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsDnsErrorByApi' event (evid: 779)
 *
 * Event description: Triggered when the new API for DNS service fails, and fallback to old service takes place. Can be in create, edit or delete DNS
 *
 * @param {myDomainsDnsErrorByApiParams} params - The parameters for this event
 * @property {string} validationMessage - ok | error (exact error text)
 * @property {string} recordType - aname| cname | txt | spf | srv | mx
 * @property {string} errorMessage - Response from server in case of exceptions during “Save” action. Should be null, otherwise indicates that server responded with error
 * @property {string} domain - domain
 * @property {string} uuid - uuid
 * @property {string} mgmtType - 0,1 = connect  , 2 = purchase
 * @property {string} flowName - flow from where the API was called
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {string} record - JSON with attributes and their values for different record types
 * @return {LogObject<myDomainsDnsErrorByApiParams>} LogObject<myDomainsDnsErrorByApiParams>
 */
export function myDomainsDnsErrorByApi(params) {
    return { evid: 779, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020IntroPageView' event (evid: 780)
 *
 * Event description: Intro Page View
 *
 * @param {connectDomain2020IntroPageViewParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @property {number} loadingDuration - time to load the page in ms
 * @return {LogObject<connectDomain2020IntroPageViewParams>} LogObject<connectDomain2020IntroPageViewParams>
 */
export function connectDomain2020IntroPageView(params) {
    return { evid: 780, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020IntroPageInteractions' event (evid: 781)
 *
 * Event description: ConnectDomain [2020] > Intro Page Interactions.
 *
 * @param {connectDomain2020IntroPageInteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/back_bottom/back_top
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020IntroPageInteractionsParams>} LogObject<connectDomain2020IntroPageInteractionsParams>
 */
export function connectDomain2020IntroPageInteractions(params) {
    return { evid: 781, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step1ViewLogInToYourDomainProvider' event (evid: 782)
 *
 * Event description: Step 1 View (Log in to your domain Provider)
 *
 * @param {connectDomain2020Step1ViewLogInToYourDomainProviderParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step1ViewLogInToYourDomainProviderParams>} LogObject<connectDomain2020Step1ViewLogInToYourDomainProviderParams>
 */
export function connectDomain2020Step1ViewLogInToYourDomainProvider(params) {
    return { evid: 782, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step1Interactions' event (evid: 783)
 *
 * Event description: Step 1  Interactions (Log in to your domain Provider)
 *
 * @param {connectDomain2020Step1InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where users come from
 * @property {GUID} msid - msid
 * @property {string} action - next/hint
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step1InteractionsParams>} LogObject<connectDomain2020Step1InteractionsParams>
 */
export function connectDomain2020Step1Interactions(params) {
    return { evid: 783, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step2ViewFindYourDomainSettingsPage' event (evid: 784)
 *
 * Event description: ConnectDomain [2020] > Step 2 View (Find your domain settings page).
 *
 * @param {connectDomain2020Step2ViewFindYourDomainSettingsPageParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top-level domain name
 * @return {LogObject<connectDomain2020Step2ViewFindYourDomainSettingsPageParams>} LogObject<connectDomain2020Step2ViewFindYourDomainSettingsPageParams>
 */
export function connectDomain2020Step2ViewFindYourDomainSettingsPage(params) {
    return { evid: 784, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step2Interactions' event (evid: 785)
 *
 * Event description: Step 2  Interactions (Find your domain settings page)
 *
 * @param {connectDomain2020Step2InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/hint
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step2InteractionsParams>} LogObject<connectDomain2020Step2InteractionsParams>
 */
export function connectDomain2020Step2Interactions(params) {
    return { evid: 785, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step3ViewFindYourRecords' event (evid: 786)
 *
 * Event description: Step 3 View (Find your records (nameservers/pointing))
 *
 * @param {connectDomain2020Step3ViewFindYourRecordsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step3ViewFindYourRecordsParams>} LogObject<connectDomain2020Step3ViewFindYourRecordsParams>
 */
export function connectDomain2020Step3ViewFindYourRecords(params) {
    return { evid: 786, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step3Interactions' event (evid: 787)
 *
 * Event description: Step 3  Interactions (Find your records)
 *
 * @param {connectDomain2020Step3InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/hint/hover
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step3InteractionsParams>} LogObject<connectDomain2020Step3InteractionsParams>
 */
export function connectDomain2020Step3Interactions(params) {
    return { evid: 787, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step4ViewReplaceYourRecords' event (evid: 788)
 *
 * Event description: Step 4 View (Replace your records (nameservers/pointing))
 *
 * @param {connectDomain2020Step4ViewReplaceYourRecordsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step4ViewReplaceYourRecordsParams>} LogObject<connectDomain2020Step4ViewReplaceYourRecordsParams>
 */
export function connectDomain2020Step4ViewReplaceYourRecords(params) {
    return { evid: 788, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020Step4Interactions' event (evid: 789)
 *
 * Event description: Step 4  Interactions (Replace your records)
 *
 * @param {connectDomain2020Step4InteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - next/hint/copy/hover
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020Step4InteractionsParams>} LogObject<connectDomain2020Step4InteractionsParams>
 */
export function connectDomain2020Step4Interactions(params) {
    return { evid: 789, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020SwitchConnectionMethod' event (evid: 790)
 *
 * Event description: Switch Connection Method (to pointing/nameservers)
 *
 * @param {connectDomain2020SwitchConnectionMethodParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - time from step view to action in ms
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {string} place - 'tutorial' | 'onboarding'
 * @property {string} type - pointing / nameservers
 * @property {GUID} msid - msid
 * @property {string} action - view/close/continue/switch
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020SwitchConnectionMethodParams>} LogObject<connectDomain2020SwitchConnectionMethodParams>
 */
export function connectDomain2020SwitchConnectionMethod(params) {
    return { evid: 790, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'changePlanPopupOpened' event (evid: 7900)
 *
 * Event description: change plan popup opened - data from server with event_aggregator
 *
 * @param {changePlanPopupOpenedParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {string} paymentStatus - CHARGE_FAILURE
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<changePlanPopupOpenedParams>} LogObject<changePlanPopupOpenedParams>
 */
export function changePlanPopupOpened(params) {
    return { evid: 7900, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'clickConfirmPlanChange' event (evid: 7901)
 *
 * Event description: user is clicking on “confirm plan change” in the popup
 *
 * @param {clickConfirmPlanChangeParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {string} paymentStatus - payment_status
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<clickConfirmPlanChangeParams>} LogObject<clickConfirmPlanChangeParams>
 */
export function clickConfirmPlanChange(params) {
    return { evid: 7901, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'clickCancelChangePlan' event (evid: 7902)
 *
 * Event description: user is clicking on “cancel ”  or X in the popup
 *
 * @param {clickCancelChangePlanParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {string} paymentStatus - payment_status
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<clickCancelChangePlanParams>} LogObject<clickCancelChangePlanParams>
 */
export function clickCancelChangePlan(params) {
    return { evid: 7902, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'clickPremiumChangePlan' event (evid: 7903)
 *
 * Event description: change plan > click on change plan.
 *
 * @param {clickPremiumChangePlanParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageId - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - siteLevel/accountLevel
 * @property {number} '8' - product_id
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} '21' - cancel_site_type
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {GUID} siteid - site_id
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {string} '18' - ab_test
 * @property {string} subscriptionType - subscription_type
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} type - type
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {number} '28' - billing_system
 * @property {number} cycleId - cycle_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<clickPremiumChangePlanParams>} LogObject<clickPremiumChangePlanParams>
 */
export function clickPremiumChangePlan(params) {
    return { evid: 7903, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'viewOtherPackagePickerOffers' event (evid: 7904)
 *
 * Event description: user is opening the list to view other PP options
 *
 * @param {viewOtherPackagePickerOffersParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {number} newCycle - new cycle id
 * @property {GUID} uuid - user Guid
 * @property {string} acceptLang - accept_lng
 * @property {string} changeType - Extend/Grace_period
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - newPurchase
 * @property {number} site_type - site_type
 * @property {number} newProductId - new product id
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - user package guid
 * @property {number} cycle - current billing cycle
 * @property {string} pagename - ab_test
 * @property {string} referralAdditionalInfo - referralAdditionalInfo
 * @property {number} productId - current Product Id
 * @property {Url} referer - referral
 * @property {GUID} packageId - user package guid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - msid
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - ab_test
 * @return {LogObject<viewOtherPackagePickerOffersParams>} LogObject<viewOtherPackagePickerOffersParams>
 */
export function viewOtherPackagePickerOffers(params) {
    return { evid: 7904, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'connectDomain2020TutorialInteractions' event (evid: 791)
 *
 * Event description: Interactions with tutorial (clicks on tabs, click on back)
 *
 * @param {connectDomain2020TutorialInteractionsParams} params - The parameters for this event
 * @property {string} method - connection method [pointing | dns]
 * @property {string} step - active step [ 1 | 2 | 3 | 4 ]
 * @property {string} tutorialType - GoDaddy | Generic | Dedicated | Subdomains
 * @property {number} durationToAction - duration_to_action
 * @property {string} domain - domain name
 * @property {string} screenResolution - hardware screen resolution
 * @property {string} registrar - domain registrar
 * @property {string} referralAdditionalInfo - where do users come from? [pop_up | search | my_domains_area]
 * @property {GUID} msid - msid
 * @property {string} action - [step_1 | step_2 | step_3 | step_4 ]
 * @property {string} tld - top level domain name
 * @return {LogObject<connectDomain2020TutorialInteractionsParams>} LogObject<connectDomain2020TutorialInteractionsParams>
 */
export function connectDomain2020TutorialInteractions(params) {
    return { evid: 791, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsDomainInfoView' event (evid: 793)
 *
 * Event description: Triggered when users see domain info
 *
 * @param {myDomainsDomainInfoViewParams} params - The parameters for this event
 * @property {string} method - pointing/dns
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - true | false
 * @property {string} totalUnassignedDomains - totalUnassignedDomains
 * @property {string} domain - domain name
 * @property {string} totalInactiveDomains - totalInactiveDomains
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {string} registrar - wix/non-wix
 * @property {string} domainStatus - domain status
 * @property {string} totalConnectedDomains - totalConnectedDomains
 * @property {string} referralAdditionalInfo - where users came from
 * @property {DateTime} end - when do we promise connection result
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - totalAssignedDomains
 * @property {string} domainLevel - primary/secondary
 * @property {DateTime} start - last connect domain attempt
 * @property {GUID} msid - msid | NULL if domain unassigned
 * @return {LogObject<myDomainsDomainInfoViewParams>} LogObject<myDomainsDomainInfoViewParams>
 */
export function myDomainsDomainInfoView(params) {
    return { evid: 793, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsCongratulationMessageView' event (evid: 794)
 *
 * Event description: Users see congratulation message about successful domain connection.
 *
 * @param {myDomainsCongratulationMessageViewParams} params - The parameters for this event
 * @property {string} method - pointing/dns
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} voucher - true | false
 * @property {string} domain - domain name
 * @property {string} elementText - view_site | go_to_site_editor | assign_domain_to_a_site
 * @property {string} totalDomains - the number of domains on the page, if 0 - then empty state
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {string} registrar - wix/non-wix
 * @property {string} flow - connect_domain | purchase |transfer-in | extend
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} type - unassigned | unpublished | published
 * @property {string} domainLevel - primary/secondary
 * @property {GUID} msid - msid | NULL if domain unassigned
 * @property {string} action - view | click
 * @return {LogObject<myDomainsCongratulationMessageViewParams>} LogObject<myDomainsCongratulationMessageViewParams>
 */
export function myDomainsCongratulationMessageView(params) {
    return { evid: 794, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'domainsServerAppRequestFailure' event (evid: 797)
 *
 * Event description: Triggers in case server fails with 500 error (instead of app)
 *
 * @param {domainsServerAppRequestFailureParams} params - The parameters for this event
 * @property {string} errorInfo - error info
 * @property {string} referralAdditionalInfo - where did users come from
 * @property {string} app - my-domains | get-domain | etc
 * @property {string} requestId - request id
 * @return {LogObject<domainsServerAppRequestFailureParams>} LogObject<domainsServerAppRequestFailureParams>
 */
export function domainsServerAppRequestFailure(params) {
    return { evid: 797, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'myDomainsStartAppLoad' event (evid: 798)
 *
 * Event description: This events will fire when we start to download MyDomains app. We need it to see cases when the MyDomains page didn't load. In the future we will need to add here EmptyState too. For now we can't do it on old Empty state.
 *
 * @param {myDomainsStartAppLoadParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} referralAdditionalInfo - where users came from
 * @property {GUID} msid - msid for site level, null for account
 * @return {LogObject<myDomainsStartAppLoadParams>} LogObject<myDomainsStartAppLoadParams>
 */
export function myDomainsStartAppLoad(params) {
    return { evid: 798, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'emptyStateInteractions' event (evid: 799)
 *
 * Event description: Interactions (clicks) on Empty state
 *
 * @param {emptyStateInteractionsParams} params - The parameters for this event
 * @property {string} viewMode - siteLevel | accountLevel
 * @property {string} name - 'buy_a_domain' | 'connect_domain_you_already_own' | 'learn_more' | 'transfer_in'
 * @property {string} voucher - user has at least one domain voucher
 * @property {string} totalUnassignedDomains - number of domains
 * @property {string} totalInactiveDomains - number of domains
 * @property {string} totalDomains - number of domains
 * @property {boolean} emptyState - true, false
 * @property {boolean} isPublished - sitelevel - true | false, account level - NULL
 * @property {boolean} hasSites - If the user has sites in the account
 * @property {boolean} isPremiumSite - true, false
 * @property {boolean} isVoucher - true, false
 * @property {string} totalConnectedDomains - number of domains
 * @property {string} referralAdditionalInfo - where users came from
 * @property {boolean} isAccountPremium - is a user has at least one valid premium
 * @property {GUID} reseller - reseller guid
 * @property {string} pageType - default, reseller
 * @property {boolean} isPremium - has a premium on the current site
 * @property {string} totalAssignedDomains - number of domains
 * @property {GUID} msid - msid for site level, null for account
 * @property {boolean} isSale - true, false
 * @return {LogObject<emptyStateInteractionsParams>} LogObject<emptyStateInteractionsParams>
 */
export function emptyStateInteractions(params) {
    return { evid: 799, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'viewPromotionAsset' event (evid: 8000)
 *
 * Event description: View promotion assets: banner,lightbox
 *
 * @param {viewPromotionAssetParams} params - The parameters for this event
 * @property {string} abTest - ab test group
 * @property {string} assetId - asset_campaign_id
 * @property {GUID} assetCampaignGuid - asset_campaign_guid
 * @property {string} promotionAssetType - Banner/lightbox
 * @property {string} dealerVersion - dealer version
 * @property {string} saleGroup - seasonal,none
 * @property {string} premiumLng - premiumLng
 * @property {GUID} lightboxGuid - The offer from dealer
 * @property {boolean} isPremium - isPremium
 * @property {GUID} msid - msid
 * @property {string} bannerLocationOnPage - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the asset
 * @property {boolean} aboveTheFold - was the item full viewed above the fold
 * @return {LogObject<viewPromotionAssetParams>} LogObject<viewPromotionAssetParams>
 */
export function viewPromotionAsset(params) {
    return { evid: 8000, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'clickPromotionAsset' event (evid: 8001)
 *
 * Event description: Click on promotion assets: banner,lightbox
 *
 * @param {clickPromotionAssetParams} params - The parameters for this event
 * @property {string} abTest - ab test group
 * @property {string} assetId - asset_campaign_id
 * @property {GUID} assetCampaignGuid - asset_campaign_guid
 * @property {string} targetUrl - the banner link url
 * @property {string} clickType - the button the user clicked on
 * @property {string} promotionAssetType - Banner/lightbox
 * @property {string} dealerVersion - dealer_version
 * @property {string} saleGroup - seasonal,none
 * @property {string} premiumLng - premiumLng
 * @property {GUID} lightboxGuid - The offer from dealer
 * @property {boolean} isPremium - isPremium
 * @property {GUID} msid - msid
 * @property {string} bannerLocationOnPage - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the asset
 * @return {LogObject<clickPromotionAssetParams>} LogObject<clickPromotionAssetParams>
 */
export function clickPromotionAsset(params) {
    return { evid: 8001, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'promotionAssetLoadingTime' event (evid: 8002)
 *
 * Event description: The promotion asset loading time
 *
 * @param {promotionAssetLoadingTimeParams} params - The parameters for this event
 * @property {string} abTest - ab test group
 * @property {string} assetId - asset_campaign_id
 * @property {GUID} assetCampaignGuid - asset_campaign_guid‎
 * @property {string} promotionAssetType - Banner/lightbox
 * @property {string} dealerVersion - dealer_version
 * @property {string} saleGroup - seasonal,none
 * @property {string} premiumLng - premiumLng
 * @property {GUID} lightboxGuid - The offer from dealer
 * @property {number} loadTime - loading time
 * @property {boolean} isPremium - isPremium
 * @property {GUID} msid - msid
 * @property {string} bannerLocationOnPage - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the asset
 * @return {LogObject<promotionAssetLoadingTimeParams>} LogObject<promotionAssetLoadingTimeParams>
 */
export function promotionAssetLoadingTime(params) {
    return { evid: 8002, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'bannerInit' event (evid: 8003)
 *
 * Event description: Banner_Init
 *
 * @param {bannerInitParams} params - The parameters for this event
 * @property {string} lightboxguid - lightboxguid for DA
 * @property {GUID} requestGuid - request_guid
 * @property {GUID} assetCampaignGuid - assetcampaignguid for DA
 * @property {string} realEstateId - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the asset
 * @property {string} dealerVersion - dealer_version
 * @property {string} assetid - assetid
 * @property {GUID} msid - msid
 * @return {LogObject<bannerInitParams>} LogObject<bannerInitParams>
 */
export function bannerInit(params) {
    return { evid: 8003, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'bannerRendered' event (evid: 8004)
 *
 * Event description: Banner_Rendered
 *
 * @param {bannerRenderedParams} params - The parameters for this event
 * @property {string} assetId - assetId
 * @property {GUID} requestGuid - request_guid
 * @property {GUID} assetCampaignGuid - asset_campaign_guid‎
 * @property {string} realEstateId - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the asset
 * @property {string} dealerVersion - dealer_version
 * @property {string} premiumLng - premiumLng
 * @property {GUID} lightboxGuid - The offer from dealer
 * @property {boolean} isPremium - isPremium
 * @property {GUID} msid - msid
 * @return {LogObject<bannerRenderedParams>} LogObject<bannerRenderedParams>
 */
export function bannerRendered(params) {
    return { evid: 8004, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'oldNewDealerApiResponseComparison' event (evid: 8005)
 *
 * Event description: We are migrating dealer client to call a new platformized api.
 * those events will contains comparison results of both api's - new and old.  it will make migration process safer.
 *
 * @param {oldNewDealerApiResponseComparisonParams} params - The parameters for this event
 * @property {GUID} bannerIdNew - banner id returning from new dealer
 * @property {GUID} bannerIdOld - banner id returning fro old dealer
 * @property {string} realEstateId - the real estate that the request was made from
 * @property {boolean} assetIdEqual - true if assetId has the same value in both responses
 * @property {boolean} dynamicParamsEqual - true if dynamicParams has the same value in both responses
 * @property {boolean} equal - true if all other comparison fields are true
 * @property {boolean} daysLeftEqual - true if daysLeft has the same value in both responses - only if its back from new dealer
 * @property {boolean} bannerIdEqual - true if bannerId has the same value in both responses
 * @property {boolean} templateEqual - true if template has the same value in both responses
 * @property {boolean} saleTypeEqual - true if saleType has the same value in both responses - only if its back from new dealer
 * @property {boolean} lightboxTriggersEqual - true if lightboxTriggers has the same value in both responses
 * @property {GUID} msid - the metasite id in context of request
 * @return {LogObject<oldNewDealerApiResponseComparisonParams>} LogObject<oldNewDealerApiResponseComparisonParams>
 */
export function oldNewDealerApiResponseComparison(params) {
    return { evid: 8005, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePage' event (evid: 820)
 *
 * Event description: User entered the partner package page
 *
 * @param {partnerPackagePageViewPartnerPackagePageParams} params - The parameters for this event
 * @property {string} viewMode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageParams>} LogObject<partnerPackagePageViewPartnerPackagePageParams>
 */
export function partnerPackagePageViewPartnerPackagePage(params) {
    return { evid: 820, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSubmitForm' event (evid: 821)
 *
 * Event description: user clicked "submit" after entering the "contact us" page
 *
 * @param {partnerPackagePageViewPartnerPackagePageSubmitFormParams} params - The parameters for this event
 * @property {GUID} subscriptionId - partner package id
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSubmitFormParams>} LogObject<partnerPackagePageViewPartnerPackagePageSubmitFormParams>
 */
export function partnerPackagePageViewPartnerPackagePageSubmitForm(params) {
    return { evid: 821, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageClick' event (evid: 824)
 *
 * Event description: User clicked on one of the buttons in the partner package page
 *
 * @param {partnerPackagePageViewPartnerPackagePageClickParams} params - The parameters for this event
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - Assign Plans(top) / Assign Plans(Congrats) / Assign Plans(package) / close / actions/ tier benefits / assign more plans
 * @property {string} viewmode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageClick(params) {
    return { evid: 824, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageViewAssignPlansClick' event (evid: 825)
 *
 * Event description: User chose plans to assign and clicked assign or closed the window
 *
 * @param {partnerPackagePageViewPartnerPackagePageViewAssignPlansClickParams} params - The parameters for this event
 * @property {GUID} subscriptionId - partner package id
 * @property {number} numOfSubscriptionsAssigned - number of assigned subscriptions
 * @property {string} clickType - cancel / close / assign
 * @property {string} productTypeName - product type name
 * @property {string} assignedSitesIds - ids of the assigned sites
 * @property {string} productTypeId - product type id
 * @property {string} assignedClientsIds - ids of the assigned clients
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageViewAssignPlansClick(params) {
    return { evid: 825, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenu' event (evid: 826)
 *
 * Event description: User clicked the site action button and chose one of the options
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - connect/view_features/unassign_plan/unassign_client/assign_client
 * @property {string} productTypeName - product name_on_screen
 * @property {string} productTypeId - product_guid
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenu(params) {
    return { evid: 826, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlan' event (evid: 827)
 *
 * Event description: User clicked on unassign license from a site and reached the unassign page
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlanParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/unassign/close
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlanParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlanParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignPlan(params) {
    return { evid: 827, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClient' event (evid: 828)
 *
 * Event description: User entered the assign client for a specific site and clicked on one of the options
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClientParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/back/close/create_assign /add_new_contact
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @property {GUID} siteGuid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClientParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClientParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuAssignClient(params) {
    return { evid: 828, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContact' event (evid: 829)
 *
 * Event description: User entered the add new contact page and clicked on one of the options
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContactParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/back/close/create_assign
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContactParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContactParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuNewContact(params) {
    return { evid: 829, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClient' event (evid: 830)
 *
 * Event description: User chose to unassign a client from a specific site and clicked on one of the options in the unassign client page
 *
 * @param {partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClientParams} params - The parameters for this event
 * @property {GUID} clientId - client id of the chosen site
 * @property {GUID} licenseId - assigned license id of the chosen site
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - cancel/close/unassign
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @property {GUID} msid - the chosen site guid
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClientParams>} LogObject<partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClientParams>
 */
export function partnerPackagePageViewPartnerPackagePageSiteActionMenuUnassignClient(params) {
    return { evid: 830, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageActionMenu' event (evid: 831)
 *
 * Event description: User clicked on one of the actions from the actions menu
 *
 * @param {partnerPackagePageViewPartnerPackagePageActionMenuParams} params - The parameters for this event
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - manage / tier_benefits
 * @property {string} viewmode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageActionMenuParams>} LogObject<partnerPackagePageViewPartnerPackagePageActionMenuParams>
 */
export function partnerPackagePageViewPartnerPackagePageActionMenu(params) {
    return { evid: 831, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageContactUsFullUseClick' event (evid: 832)
 *
 * Event description: User clicked on "contact us" after assigning all his licenses
 *
 * @param {partnerPackagePageViewPartnerPackagePageContactUsFullUseClickParams} params - The parameters for this event
 * @property {number} assignedSites - number of sites assigned
 * @property {GUID} subscriptionId - partner package id
 * @property {string} viewmode - empty_state / no_assigned_sites / sites_assigned
 * @property {number} totalLicenses - number of total licenses purchased
 * @property {string} productTypeName - product type name
 * @property {string} productTypeId - product type id
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageContactUsFullUseClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageContactUsFullUseClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageContactUsFullUseClick(params) {
    return { evid: 832, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClick' event (evid: 833)
 *
 * Event description: user assign a partner package plan to a site with an existing premium
 *
 * @param {partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClickParams} params - The parameters for this event
 * @property {GUID} subscriptionId - partner package id
 * @property {string} clickType - back / cancel / assign / close
 * @property {string} assignedSitesIds - ids of the assigned sites
 * @property {string} assignedClientsIds - ids of the assigned clients
 * @return {LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClickParams>} LogObject<partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClickParams>
 */
export function partnerPackagePageViewPartnerPackagePageViewAssignPlansAssignOverPremiumClick(params) {
    return { evid: 833, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'dayfulUserEnteredRestrictedPage' event (evid: 841)
 *
 * Event description: The event is fired every time a Dayful user enters (view) a page he shouldn't be able entering to
 *
 * @param {dayfulUserEnteredRestrictedPageParams} params - The parameters for this event
 * @property {string} referringUrl - url the user came from
 * @property {string} referralAdditionalInfo - entry point
 * @property {GUID} msid - dayful site id
 * @return {LogObject<dayfulUserEnteredRestrictedPageParams>} LogObject<dayfulUserEnteredRestrictedPageParams>
 */
export function dayfulUserEnteredRestrictedPage(params) {
    return { evid: 841, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteAcceptScreenLoad' event (evid: 850)
 *
 * Event description: transfer site accept screen load (1st screen)
 *
 * @param {premiumTransferSiteAcceptScreenLoadParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteAcceptScreenLoadParams>} LogObject<premiumTransferSiteAcceptScreenLoadParams>
 */
export function premiumTransferSiteAcceptScreenLoad(params) {
    return { evid: 850, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteAcceptScreenClickNext' event (evid: 851)
 *
 * Event description: Premium > Transfer Site accept screen click next (1st screen)
 *
 * @param {premiumTransferSiteAcceptScreenClickNextParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react transfer
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteAcceptScreenClickNextParams>} LogObject<premiumTransferSiteAcceptScreenClickNextParams>
 */
export function premiumTransferSiteAcceptScreenClickNext(params) {
    return { evid: 851, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'bundlePurchaseViewSuccessPage' event (evid: 8519)
 *
 * Event description: Bundle Plan purchase success page - client  (when plan is purchased alone, evid 17:147 is triggered)
 *
 * @param {bundlePurchaseViewSuccessPageParams} params - The parameters for this event
 * @property {string} siteTypeName - site_type_name
 * @property {string} packagePickerType - package_picker_type
 * @property {string} voucher - true/false
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {number} paymentMethod - payment_method
 * @property {string} acceptLang - accept_lng
 * @property {string} eventAggregator - event_aggregator
 * @property {string} newPurchase - is_new_purchase
 * @property {number} site_type - site_type
 * @property {string} premiumLng - premium_lng
 * @property {GUID} packageGuid - package_id
 * @property {number} cycle - cycle_id
 * @property {string} flow - express_checkout
 * @property {string} pagename - abTesting
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {number} productId - product_id
 * @property {string} pageType - default success page / connect domain success page
 * @property {Url} referer - referral
 * @property {string} productGuid - Product Guid
 * @property {GUID} msid - msid
 * @property {number} referralType - referral_type
 * @property {GUID} siteGuid - site_id
 * @property {string} product - bundle_domain_plan
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} abTesting - abTesting
 * @return {LogObject<bundlePurchaseViewSuccessPageParams>} LogObject<bundlePurchaseViewSuccessPageParams>
 */
export function bundlePurchaseViewSuccessPage(params) {
    return { evid: 8519, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteAcceptScreenClickViewSite' event (evid: 852)
 *
 * Event description: transfer site accept screen click view_site (1st screen)
 *
 * @param {premiumTransferSiteAcceptScreenClickViewSiteParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteAcceptScreenClickViewSiteParams>} LogObject<premiumTransferSiteAcceptScreenClickViewSiteParams>
 */
export function premiumTransferSiteAcceptScreenClickViewSite(params) {
    return { evid: 852, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteBillingInfoLoad' event (evid: 853)
 *
 * Event description: transfer site  billing info load (2nd screen)
 *
 * @param {premiumTransferSiteBillingInfoLoadParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteBillingInfoLoadParams>} LogObject<premiumTransferSiteBillingInfoLoadParams>
 */
export function premiumTransferSiteBillingInfoLoad(params) {
    return { evid: 853, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteBillingInfoClickNext' event (evid: 854)
 *
 * Event description: transfer site billing info click next (in case there is one more step) (2nd screen)
 *
 * @param {premiumTransferSiteBillingInfoClickNextParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteBillingInfoClickNextParams>} LogObject<premiumTransferSiteBillingInfoClickNextParams>
 */
export function premiumTransferSiteBillingInfoClickNext(params) {
    return { evid: 854, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteBillingInfoUserError' event (evid: 855)
 *
 * Event description: transfer site billing info user error (in case there is an error) (2nd screen)
 *
 * @param {premiumTransferSiteBillingInfoUserErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteBillingInfoUserErrorParams>} LogObject<premiumTransferSiteBillingInfoUserErrorParams>
 */
export function premiumTransferSiteBillingInfoUserError(params) {
    return { evid: 855, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteDomainInfoLoad' event (evid: 856)
 *
 * Event description: transfer site domain info load  (3rd screen)
 *
 * @param {premiumTransferSiteDomainInfoLoadParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteDomainInfoLoadParams>} LogObject<premiumTransferSiteDomainInfoLoadParams>
 */
export function premiumTransferSiteDomainInfoLoad(params) {
    return { evid: 856, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteDomainInfoUserError' event (evid: 857)
 *
 * Event description: transfer site domain info user error (in case there is an error) (3rd screen)
 *
 * @param {premiumTransferSiteDomainInfoUserErrorParams} params - The parameters for this event
 * @property {string} errorInfo - error
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteDomainInfoUserErrorParams>} LogObject<premiumTransferSiteDomainInfoUserErrorParams>
 */
export function premiumTransferSiteDomainInfoUserError(params) {
    return { evid: 857, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSiteClickSubmit' event (evid: 858)
 *
 * Event description: transfer site click submit (2nd or 3rd screen)
 *
 * @param {premiumTransferSiteClickSubmitParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react transfer
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSiteClickSubmitParams>} LogObject<premiumTransferSiteClickSubmitParams>
 */
export function premiumTransferSiteClickSubmit(params) {
    return { evid: 858, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'premiumTransferSitePending' event (evid: 859)
 *
 * Event description: transfer site pending
 *
 * @param {premiumTransferSitePendingParams} params - The parameters for this event
 * @property {GUID} sourceSiteGuid - the transfered site
 * @property {boolean} isV2 - is react version
 * @property {GUID} newSiteGuid - new site
 * @property {GUID} sourceUserGuid - the transferring user
 * @property {GUID} transferRequestId - id in premium db
 * @property {GUID} userGuid - accepting user
 * @return {LogObject<premiumTransferSitePendingParams>} LogObject<premiumTransferSitePendingParams>
 */
export function premiumTransferSitePending(params) {
    return { evid: 859, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsSitePickerView' event (evid: 866)
 *
 * Event description: User viewed the site picker modal
 *
 * @param {b2BSubscriptionsSitePickerViewParams} params - The parameters for this event
 * @property {string} viewMode - available,no_sites,all_sites_premium, all_sites_assigned
 * @property {string} msids - array of msids
 * @property {GUID} selectedClient - selectedclient
 * @return {LogObject<b2BSubscriptionsSitePickerViewParams>} LogObject<b2BSubscriptionsSitePickerViewParams>
 */
export function b2BSubscriptionsSitePickerView(params) {
    return { evid: 866, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsSitePickerViewClick' event (evid: 867)
 *
 * Event description: User viewed the site picker modal
 *
 * @param {b2BSubscriptionsSitePickerViewClickParams} params - The parameters for this event
 * @property {string} viewMode - available,no_sites,all_sites_premium, all_sites_assigned
 * @property {string} msids - array of msids
 * @property {GUID} selectedMsid - the selected msid
 * @property {string} clickType - cancel,select,close
 * @property {GUID} selectedClient - the client assigned to the msid
 * @return {LogObject<b2BSubscriptionsSitePickerViewClickParams>} LogObject<b2BSubscriptionsSitePickerViewClickParams>
 */
export function b2BSubscriptionsSitePickerViewClick(params) {
    return { evid: 867, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep1View' event (evid: 868)
 *
 * Event description: User viewed the premium PP modal
 *
 * @param {b2BSubscriptionsAddPremiumPpStep1ViewParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @property {GUID} selectedMsid - adding premium plan for this site
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep1ViewParams>} LogObject<b2BSubscriptionsAddPremiumPpStep1ViewParams>
 */
export function b2BSubscriptionsAddPremiumPpStep1View(params) {
    return { evid: 868, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep1Click' event (evid: 869)
 *
 * Event description: User viewed the premium PP modal and closed / continued the flow
 *
 * @param {b2BSubscriptionsAddPremiumPpStep1ClickParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected site to add premium to
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {string} clickType - close,back,cancel,next
 * @property {number} cycle - selected cycle
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep1ClickParams>} LogObject<b2BSubscriptionsAddPremiumPpStep1ClickParams>
 */
export function b2BSubscriptionsAddPremiumPpStep1Click(params) {
    return { evid: 869, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2bSubscriptionsAddPremiumPpStep1Select' event (evid: 870)
 *
 * Event description: User viewed the premium PP modal and selected one of the options (not necessary chose them as a final option)
 *
 * @param {b2bSubscriptionsAddPremiumPpStep1SelectParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected site to add premium to
 * @property {number} cycle - selected cycle
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2bSubscriptionsAddPremiumPpStep1SelectParams>} LogObject<b2bSubscriptionsAddPremiumPpStep1SelectParams>
 */
export function b2bSubscriptionsAddPremiumPpStep1Select(params) {
    return { evid: 870, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep2View' event (evid: 871)
 *
 * Event description: User viewed the premium PP step2
 *
 * @param {b2BSubscriptionsAddPremiumPpStep2ViewParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected site to add premium to
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {number} cycle - selected cycle
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep2ViewParams>} LogObject<b2BSubscriptionsAddPremiumPpStep2ViewParams>
 */
export function b2BSubscriptionsAddPremiumPpStep2View(params) {
    return { evid: 871, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsAddPremiumPpStep2Click' event (evid: 872)
 *
 * Event description: User clicked in the premium PP step2
 *
 * @param {b2BSubscriptionsAddPremiumPpStep2ClickParams} params - The parameters for this event
 * @property {GUID} selectedMsid - selected_msid
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {string} clickType - close,back,cancel,next
 * @property {number} cycle - selected cycle
 * @property {number} selectedFee - fee
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2BSubscriptionsAddPremiumPpStep2ClickParams>} LogObject<b2BSubscriptionsAddPremiumPpStep2ClickParams>
 */
export function b2BSubscriptionsAddPremiumPpStep2Click(params) {
    return { evid: 872, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2bSubscriptionsAddPremiumPpStep3Click' event (evid: 874)
 *
 * Event description: User clicked  in the premium PP step3
 *
 * @param {b2bSubscriptionsAddPremiumPpStep3ClickParams} params - The parameters for this event
 * @property {GUID} subscriptionId - guid of the premium plan
 * @property {string} clickType - close,back,cancel,add_to_invoice
 * @property {number} subscriptionPricing - subscription cost
 * @property {number} lineItemTotal - total line item price
 * @property {number} selectedFee - fee
 * @property {string} productGuid - premium type guid
 * @property {GUID} msid - msid
 * @return {LogObject<b2bSubscriptionsAddPremiumPpStep3ClickParams>} LogObject<b2bSubscriptionsAddPremiumPpStep3ClickParams>
 */
export function b2bSubscriptionsAddPremiumPpStep3Click(params) {
    return { evid: 874, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'b2BSubscriptionsPickerError' event (evid: 875)
 *
 * Event description: user received an error after trying to assign a site / premium plan
 *
 * @param {b2BSubscriptionsPickerErrorParams} params - The parameters for this event
 * @property {string} errorType - premium , sites
 * @return {LogObject<b2BSubscriptionsPickerErrorParams>} LogObject<b2BSubscriptionsPickerErrorParams>
 */
export function b2BSubscriptionsPickerError(params) {
    return { evid: 875, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'debugEvent' event (evid: 888)
 *
 * Event description: for debug purposes
 *
 * @param {debugEventParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - string for whatever
 * @property {string} udger_ua_class - udger_ua_class
 * @property {string} location - location
 * @property {GUID} '4' - user guid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - user guid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - string for whatever
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @return {LogObject<debugEventParams>} LogObject<debugEventParams>
 */
export function debugEvent(params) {
    return { evid: 888, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aWixPpClickOnBuyNow' event (evid: 901)
 *
 * Event description: the click between PP and Purchase Page. current version "select"
 *
 * @param {aWixPpClickOnBuyNowParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aWixPpClickOnBuyNowParams>} LogObject<aWixPpClickOnBuyNowParams>
 */
export function aWixPpClickOnBuyNow(params) {
    return { evid: 901, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aContractSelected' event (evid: 91)
 *
 * Event description: click on "select" in PP 1st step or radio button in 2nd step. NOT available in OnePage
 *
 * @param {aContractSelectedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aContractSelectedParams>} LogObject<aContractSelectedParams>
 */
export function aContractSelected(params) {
    return { evid: 91, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aPremiumpploaded' event (evid: 940)
 *
 * Event description: Plan PP page  is loaded (goes with 168.. events) A_PremiumPPLoaded
 *
 * @param {aPremiumpploadedParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} productTypeName - product_type_name
 * @property {string} productTypeId - product_type_id
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - view_mode
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - Loading time
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} changePlanType - product is in current offering/ legacy / in offering but was updated
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} intent - intent
 * @property {string} flowType - 2nd upgrade/initial/change plan
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {boolean} didFinish - Was fully loaded
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} loadedComponents - list of components that were supposed to load, and indication if they were loaded {marketing cards : true , title :false}
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} products - products
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} currentProductGuid - current_product_guid
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} ppType - pp_type
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} currentProductId - product id for change plan / second upgrade flows
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} currency - Currency
 * @property {string} additionalInfo - Loading time
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} intentDomainName - if the user found a domain before the PP
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {string} offeringType - Seasonal/personal/default
 * @property {number} '29' - initiator
 * @property {string} initiatorName - who called the app (Cart/editor)
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - Pricing
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @property {string} cartFlow - cartFlow
 * @return {LogObject<aPremiumpploadedParams>} LogObject<aPremiumpploadedParams>
 */
export function aPremiumpploaded(params) {
    return { evid: 940, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'aPaymentPageReady' event (evid: 942)
 *
 * Event description: Client - A_PaymentPageReady
 *
 * @param {aPaymentPageReadyParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} externalSessionId - external_session_id
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} products - products
 * @property {string} eventAggregator - event_aggregator
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} vendorName - ab_test
 * @property {string} device_type - device_type
 * @property {string} event_platform - event_platform
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral_additional_info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {number} cycle - cycle_id
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab_test
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral_additional_info
 * @property {string} currency - currency
 * @property {string} additionalInfo - error_info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {number} productId - product_id
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab_test
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {GUID} skuId - sku_id
 * @property {number} '29' - initiator
 * @property {string} productGuid - product_guid
 * @property {GUID} '3' - gsi
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {string} pricing - pricing
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab_test
 * @return {LogObject<aPaymentPageReadyParams>} LogObject<aPaymentPageReadyParams>
 */
export function aPaymentPageReady(params) {
    return { evid: 942, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerStartLoad' event (evid: 944)
 *
 * Event description: Package picker started loading
 *
 * @param {packagePickerStartLoadParams} params - The parameters for this event
 * @property {string} eventAggregator - identifier of event
 * @property {string} packagePickerType - Example: sunrise,studio
 * @return {LogObject<packagePickerStartLoadParams>} LogObject<packagePickerStartLoadParams>
 */
export function packagePickerStartLoad(params) {
    return { evid: 944, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerComponentStartLoad' event (evid: 945)
 *
 * Event description: A package picker component (Grid/Marketing cards)started to load
 *
 * @param {packagePickerComponentStartLoadParams} params - The parameters for this event
 * @property {string} packagePickerType - sunrise/studio etc
 * @property {string} flowType - initial purchase/2nd upgrade/change plan
 * @property {string} componentName - example Grid/Marketing cards
 * @property {number} cycle - current_cycle_id
 * @property {number} productId - for sites that are already upgraded
 * @property {string} offeringType - default / seasonal / personal
 * @property {string} initiatorName - Source of loading (cart/Editor)
 * @property {string} pricing - a list of the products offered and their prices
 * @property {string} referraladditionalinfo - referral_additional_info
 * @property {string} eventAggregator - aggregator
 * @return {LogObject<packagePickerComponentStartLoadParams>} LogObject<packagePickerComponentStartLoadParams>
 */
export function packagePickerComponentStartLoad(params) {
    return { evid: 945, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'packagePickerComponentFinishLoad' event (evid: 946)
 *
 * Event description: A package picker component (Grid/Marketing cards) successfully loaded
 *
 * @param {packagePickerComponentFinishLoadParams} params - The parameters for this event
 * @property {string} packagePickerType - sunrise/studio etc
 * @property {string} flowType - initial purchase/2nd upgrade/change plan
 * @property {string} componentName - example Grid/Marketing cards
 * @property {number} cycle - for sites that are already upgraded
 * @property {number} productId - for sites that are already upgraded
 * @property {string} offeringType - default / seasonal / personal
 * @property {string} initiatorName - Source of loading (cart/Editor)
 * @property {string} pricing - a list of the products offered and their prices
 * @property {string} referraladditionalinfo - Specific entry point to the PP
 * @property {string} eventAggregator - aggregator
 * @return {LogObject<packagePickerComponentFinishLoadParams>} LogObject<packagePickerComponentFinishLoadParams>
 */
export function packagePickerComponentFinishLoad(params) {
    return { evid: 946, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'expressFlowCheckoutPageClickBack' event (evid: 964)
 *
 * Event description: click back in Checkout page (Bundle Express checkout)
 *
 * @param {expressFlowCheckoutPageClickBackParams} params - The parameters for this event
 * @property {string} lng - lng
 * @property {string} externalSessionId - unique checkout guid
 * @property {GUID} uuid - uuid
 * @property {string} countryCode - .
 * @property {string} initiatorName - .
 * @property {GUID} msid - site
 * @property {string} referraladditionalinfo - .
 * @return {LogObject<expressFlowCheckoutPageClickBackParams>} LogObject<expressFlowCheckoutPageClickBackParams>
 */
export function expressFlowCheckoutPageClickBack(params) {
    return { evid: 964, src: 17, endpoint: 'pre', params: params };
}
/**
 * A function to create a log object for the 'submitCheckoutPlanReassignDomainFlow' event (evid: 997)
 *
 * Event description: triggered when user is on re-assign domain flow, and upgrade his site.
 *
 * @param {submitCheckoutPlanReassignDomainFlowParams} params - The parameters for this event
 * @property {DateTime} '5' - date_created
 * @property {string} '33' - site_type_name
 * @property {string} siteTypeName - site_type_name
 * @property {GUID} '6' - package_id
 * @property {GUID} packageGuid - package_id
 * @property {GUID} '34' - appstore_id
 * @property {number} '12' - referral_type
 * @property {string} city - city
 * @property {string} viewMode - site_level/account_level
 * @property {number} '8' - product_id
 * @property {string} packagePickerType - package_picker_type
 * @property {string} device_id - device_id
 * @property {string} bitwalker_browser_name - bitwalker_browser_name
 * @property {string} '19' - user_agent
 * @property {string} '23' - error_info
 * @property {string} udger_ua_class - udger_ua_class
 * @property {GUID} '4' - uuid
 * @property {string} '15' - lng
 * @property {string} '11' - is_new_purchase
 * @property {number} '9' - cycle_id
 * @property {string} '22' - cancel_text_reason
 * @property {GUID} '26' - client_id
 * @property {string} domain - domain
 * @property {GUID} uuid - uuid
 * @property {string} host - host
 * @property {GUID} '37' - sku_id
 * @property {string} acceptLang - accept_lng
 * @property {Url} '13' - referral
 * @property {string} bitwalker_browser_family - bitwalker_browser_family
 * @property {string} '24' - ip
 * @property {GUID} '35' - email_package_guid
 * @property {string} '16' - accept_lng
 * @property {string} os_name - os_name
 * @property {string} '10' - coupon
 * @property {string} udger_ua_family - udger_ua_family
 * @property {string} eventAggregator - event
 * @property {string} '21' - cancel_site_type
 * @property {string} newPurchase - is_new_purchase
 * @property {number} catalog_version - catalog_version
 * @property {string} device_type - device_type
 * @property {string} pod - pod
 * @property {number} site_type - site_type
 * @property {number} '32' - domain_sku_id
 * @property {string} udger_os_name - udger_os_name
 * @property {string} country_code - country_code
 * @property {string} premiumLng - premium_lng
 * @property {string} udger_device_marketname - udger_device_marketname
 * @property {number} '36' - email_sku_id
 * @property {string} udger_ua - udger_ua
 * @property {string} '17' - premium_lng
 * @property {string} '25' - experiment_id
 * @property {string} '14' - referral additional info
 * @property {string} browser_family - browser_family
 * @property {string} bot_name - bot_name
 * @property {string} '31' - domain
 * @property {string} bitwalker_browser_version - bitwalker_browser_version
 * @property {string} udger_ua_version - udger_ua_version
 * @property {string} udger_device_class - udger_device_class
 * @property {string} udger_crawler_category - udger_crawler_category
 * @property {string} pagename - ab test identifier
 * @property {string} bitwalker_device_type - bitwalker_device_type
 * @property {number} '20' - cancel_reason
 * @property {number} '27' - email_provider
 * @property {GUID} '2' - billing_session_id
 * @property {string} region - region
 * @property {GUID} '38' - package_id
 * @property {string} referralAdditionalInfo - referral additional info
 * @property {string} cruncher_pod - cruncher_pod
 * @property {GUID} _event_hash - event_hash
 * @property {Url} referer - referral
 * @property {string} '18' - ab test identifier
 * @property {string} browser_version - browser_version
 * @property {number} '30' - payment_method
 * @property {GUID} '7' - site_id
 * @property {number} '29' - initiator
 * @property {GUID} '3' - gsi
 * @property {GUID} msid - msid
 * @property {string} browser_name - browser_name
 * @property {number} referralType - referral_type
 * @property {boolean} udger_is_bot - udger_is_bot
 * @property {GUID} siteGuid - site_id
 * @property {number} '28' - billing_system
 * @property {GUID} purchaseFlowIdentifier - billing_session_id
 * @property {string} bitwalker_os_name - bitwalker_os_name
 * @property {string} abTesting - ab test identifier
 * @return {LogObject<submitCheckoutPlanReassignDomainFlowParams>} LogObject<submitCheckoutPlanReassignDomainFlowParams>
 */
export function submitCheckoutPlanReassignDomainFlow(params) {
    return { evid: 997, src: 17, endpoint: 'pre', params: params };
}
//# sourceMappingURL=index.js.map